let areaList = [{
  "name": "北京",
  "city": [{
    "name": "北京",
    "area": ["东城区", "西城区", "崇文区", "宣武区", "朝阳区", "丰台区", "石景山区", "海淀区", "门头沟区", "房山区", "通州区", "顺义区", "昌平区", "大兴区", "平谷区", "怀柔区", "密云县", "延庆县"]
  }],
  "json": "beijing"
}, {
  "name": "天津",
  "city": [{
    "name": "天津",
    "area": ["和平区", "河东区", "河西区", "南开区", "河北区", "红桥区", "塘沽区", "汉沽区", "大港区", "东丽区", "西青区", "津南区", "北辰区", "武清区", "宝坻区", "宁河县", "静海县", "蓟县"]
  }],
  "json": "tianjin"
}, {
  "name": "河北",
  "city": [{
    "name": "石家庄",
    "area": ["长安区", "桥东区", "桥西区", "新华区", "郊区", "井陉矿区", "井陉县", "正定县", "栾城县", "行唐县", "灵寿县", "高邑县", "深泽县", "赞皇县", "无极县", "平山县", "元氏县", "赵县", "辛集市", "藁", "晋州市", "新乐市", "鹿泉市"]
  }, {
    "name": "唐山",
    "area": ["路南区", "路北区", "古冶区", "开平区", "新区", "丰润县", "滦县", "滦南县", "乐亭县", "迁西县", "玉田县", "唐海县", "遵化市", "丰南市", "迁安市"]
  }, {"name": "秦皇岛", "area": ["海港区", "山海关区", "北戴河区", "青龙满族自治县", "昌黎县", "抚宁县", "卢龙县"]}, {
    "name": "邯郸",
    "area": ["邯山区", "丛台区", "复兴区", "峰峰矿区", "邯郸县", "临漳县", "成安县", "大名县", "涉县", "磁县", "肥乡县", "永年县", "邱县", "鸡泽县", "广平县", "馆陶县", "魏县", "曲周县", "武安市"]
  }, {
    "name": "邢台",
    "area": ["桥东区", "桥西区", "邢台县", "临城县", "内丘县", "柏乡县", "隆尧县", "任县", "南和县", "宁晋县", "巨鹿县", "新河县", "广宗县", "平乡县", "威县", "清河县", "临西县", "南宫市", "沙河市"]
  }, {
    "name": "保定",
    "area": ["新市区", "北市区", "南市区", "满城县", "清苑县", "涞水县", "阜平县", "徐水县", "定兴县", "唐县", "高阳县", "容城县", "涞源县", "望都县", "安新县", "易县", "曲阳县", "蠡县", "顺平县", "博野", "雄县", "涿州市", "定州市", "安国市", "高碑店市"]
  }, {
    "name": "张家口",
    "area": ["桥东区", "桥西区", "宣化区", "下花园区", "宣化县", "张北县", "康保县", "沽源县", "尚义县", "蔚县", "阳原县", "怀安县", "万全县", "怀来县", "涿鹿县", "赤城县", "崇礼县"]
  }, {
    "name": "承德",
    "area": ["双桥区", "双滦区", "鹰手营子矿区", "承德县", "兴隆县", "平泉县", "滦平县", "隆化县", "丰宁满族自治县", "宽城满族自治县", "围场满族蒙古族自治县"]
  }, {
    "name": "沧州",
    "area": ["新华区", "运河区", "沧县", "青县", "东光县", "海兴县", "盐山县", "肃宁县", "南皮县", "吴桥县", "献县", "孟村回族自治县", "泊头市", "任丘市", "黄骅市", "河间市"]
  }, {"name": "廊坊", "area": ["安次区", "固安县", "永清县", "香河县", "大城县", "文安县", "大厂回族自治县", "霸州市", "三河市"]}, {
    "name": "衡水",
    "area": ["桃城区", "枣强县", "武邑县", "武强县", "饶阳县", "安平县", "故城县", "景县", "阜城县", "冀州市", "深州市"]
  }],
  "json": "hebei"
}, {
  "name": "山西",
  "city": [{
    "name": "太原",
    "area": ["小店区", "迎泽区", "杏花岭区", "尖草坪区", "万柏林区", "晋源区", "清徐县", "阳曲县", "娄烦县", "古交市"]
  }, {"name": "大同", "area": ["城区", "矿区", "南郊区", "新荣区", "阳高县", "天镇县", "广灵县", "灵丘县", "浑源县", "左云县", "大同县"]}, {
    "name": "阳泉",
    "area": ["城区", "矿区", "郊区", "平定县", "盂县"]
  }, {
    "name": "长治",
    "area": ["城区", "郊区", "长治县", "襄垣县", "屯留县", "平顺县", "黎城县", "壶关县", "长子县", "武乡县", "沁县", "沁源县", "潞城市"]
  }, {"name": "晋城", "area": ["城区", "沁水县", "阳城县", "陵川县", "泽州县", "高平市"]}, {
    "name": "朔州",
    "area": ["朔城区", "平鲁区", "山阴县", "应县", "右玉县", "怀仁市"]
  }, {
    "name": "忻州",
    "area": ["忻府区", "原平市", "定襄县", "五台县", "代县", "繁峙县", "宁武县", "静乐县", "神池县", "五寨县", "岢岚县", "河曲县", "保德县", "偏关县"]
  }, {
    "name": "吕梁",
    "area": ["离石区", "孝义市", "汾阳市", "文水县", "交城县", "兴县", "临县", "柳林县", "石楼县", "岚县", "方山县", "中阳县", "交口县"]
  }, {
    "name": "晋中",
    "area": ["榆次市", "介休市", "榆社县", "左权县", "和顺县", "昔阳县", "寿阳县", "太谷县", "祁县", "平遥县", "灵石县"]
  }, {
    "name": "临汾",
    "area": ["临汾市", "侯马市", "霍州市", "曲沃县", "翼城县", "襄汾县", "洪洞县", "古县", "安泽县", "浮山县", "吉县", "乡宁县", "蒲县", "大宁县", "永和县", "隰县", "汾西县"]
  }, {"name": "运城", "area": ["运城市", "永济市", "河津市", "芮城县", "临猗县", "万荣县", "新绛县", "稷山县", "闻喜县", "夏县", "绛县", "平陆县", "垣曲县"]}],
  "json": "shanxi"
}, {
  "name": "内蒙古",
  "city": [{
    "name": "鄂尔多斯",
    "area": ["东胜区", "达拉特旗", "准格尔旗", "鄂托克前旗", "鄂托克旗", "杭锦旗", "乌审旗", "伊金霍洛旗"]
  }, {
    "name": "呼和浩特",
    "area": ["新城区", "回民区", "玉泉区", "郊区", "土默特左旗", "托克托县", "和林格尔县", "清水河县", "武川县"]
  }, {"name": "包头", "area": ["东河区", "昆都伦区", "青山区", "石拐矿区", "白云矿区", "郊区", "土默特右旗", "固阳县", "达尔罕茂明安联合旗"]}, {
    "name": "乌海",
    "area": ["海勃湾区", "海南区", "乌达区"]
  }, {
    "name": "赤峰",
    "area": ["红山区", "元宝山区", "松山区", "阿鲁科尔沁旗", "巴林左旗", "巴林右旗", "林西县", "克什克腾旗", "翁牛特旗", "喀喇沁旗", "宁城县", "敖汉旗"]
  }, {
    "name": "呼伦贝尔",
    "area": ["海拉尔市", "满洲里市", "扎兰屯市", "牙克石市", "根河市", "额尔古纳市", "阿荣旗", "莫力达瓦达斡尔族自治旗", "鄂伦春自治旗", "鄂温克族自治旗", "新巴尔虎右旗", "新巴尔虎左旗", "陈巴尔虎旗"]
  }, {"name": "兴安盟", "area": ["乌兰浩特市", "阿尔山市", "科尔沁右翼前旗", "科尔沁右翼中旗", "扎赉特旗", "突泉县"]}, {
    "name": "通辽",
    "area": ["科尔沁区", "霍林郭勒市", "科尔沁左翼中旗", "科尔沁左翼后旗", "开鲁县", "库伦旗", "奈曼旗", "扎鲁特旗"]
  }, {
    "name": "锡林郭勒盟",
    "area": ["二连浩特市", "锡林浩特市", "阿巴嘎旗", "苏尼特左旗", "苏尼特右旗", "东乌珠穆沁旗", "西乌珠穆沁旗", "太仆寺旗", "镶黄旗", "正镶白旗", "正蓝旗", "多伦县"]
  }, {
    "name": "乌兰察布盟",
    "area": ["集宁市", "丰镇市", "卓资县", "化德县", "商都县", "兴和县", "凉城县", "察哈尔右翼前旗", "察哈尔右翼中旗", "察哈尔右翼后旗", "四子王旗"]
  }, {"name": "伊克昭盟", "area": ["东胜市", "达拉特旗", "准格尔旗", "鄂托克前旗", "鄂托克旗", "杭锦旗", "乌审旗", "伊金霍洛旗"]}, {
    "name": "巴彦淖尔盟",
    "area": ["临河市", "五原县", "磴口县", "乌拉特前旗", "乌拉特中旗", "乌拉特后旗", "杭锦后旗"]
  }, {"name": "阿拉善盟", "area": ["阿拉善左旗", "阿拉善右旗", "额济纳旗"]}],
  "json": "neimenggu"
}, {
  "name": "辽宁",
  "city": [{
    "name": "沈阳",
    "area": ["沈河区", "皇姑区", "和平区", "大东区", "铁西区", "苏家屯区", "东陵区", "于洪区", "新民市", "法库县", "辽中县", "康平县", "新城子区", "其他"]
  }, {
    "name": "大连",
    "area": ["西岗区", "中山区", "沙河口区", "甘井子区", "旅顺口区", "金州区", "瓦房店市", "普兰店市", "庄河市", "长海县", "其他"]
  }, {"name": "鞍山", "area": ["铁东区", "铁西区", "立山区", "千山区", "海城市", "台安县", "岫岩满族自治县", "其他"]}, {
    "name": "抚顺",
    "area": ["顺城区", "新抚区", "东洲区", "望花区", "抚顺县", "清原满族自治县", "新宾满族自治县", "其他"]
  }, {"name": "本溪", "area": ["平山区", "明山区", "溪湖区", "南芬区", "本溪满族自治县", "桓仁满族自治县", "其他"]}, {
    "name": "丹东",
    "area": ["振兴区", "元宝区", "振安区", "东港市", "凤城市", "宽甸满族自治县", "其他"]
  }, {"name": "锦州", "area": ["太和区", "古塔区", "凌河区", "凌海市", "黑山县", "义县", "北宁市", "其他"]}, {
    "name": "营口",
    "area": ["站前区", "西市区", "鲅鱼圈区", "老边区", "大石桥市", "盖州市", "其他"]
  }, {"name": "阜新", "area": ["海州区", "新邱区", "太平区", "清河门区", "细河区", "彰武县", "阜新蒙古族自治县", "其他"]}, {
    "name": "辽阳",
    "area": ["白塔区", "文圣区", "宏伟区", "太子河区", "弓长岭区", "灯塔市", "辽阳县", "其他"]
  }, {"name": "盘锦", "area": ["双台子区", "兴隆台区", "盘山县", "大洼县", "其他"]}, {
    "name": "铁岭",
    "area": ["银州区", "清河区", "调兵山市", "开原市", "铁岭县", "昌图县", "西丰县", "其他"]
  }, {"name": "朝阳", "area": ["双塔区", "龙城区", "凌源市", "北票市", "朝阳县", "建平县", "喀喇沁左翼蒙古族自治县", "其他"]}, {
    "name": "葫芦岛",
    "area": ["龙港区", "南票区", "连山区", "兴城市", "绥中县", "建昌县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "liaoning"
}, {
  "name": "吉林",
  "city": [{
    "name": "长春",
    "area": ["朝阳区", "宽城区", "二道区", "南关区", "绿园区", "双阳区", "九台市", "榆树市", "德惠市", "农安县", "其他"]
  }, {"name": "吉林", "area": ["船营区", "昌邑区", "龙潭区", "丰满区", "舒兰市", "桦甸市", "蛟河市", "磐石市", "永吉县", "其他"]}, {
    "name": "四平",
    "area": ["铁西区", "铁东区", "公主岭市", "双辽市", "梨树县", "伊通满族自治县", "其他"]
  }, {"name": "辽源", "area": ["龙山区", "西安区", "东辽县", "东丰县", "其他"]}, {
    "name": "通化",
    "area": ["东昌区", "二道江区", "梅河口市", "集安市", "通化县", "辉南县", "柳河县", "其他"]
  }, {"name": "白山", "area": ["八道江区", "江源区", "临江市", "靖宇县", "抚松县", "长白朝鲜族自治县", "其他"]}, {
    "name": "松原",
    "area": ["宁江区", "乾安县", "长岭县", "扶余县", "前郭尔罗斯蒙古族自治县", "其他"]
  }, {"name": "白城", "area": ["洮北区", "大安市", "洮南市", "镇赉县", "通榆县", "其他"]}, {
    "name": "延边朝鲜族自治州",
    "area": ["延吉市", "图们市", "敦化市", "龙井市", "珲春市", "和龙市", "安图县", "汪清县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "jilin"
}, {
  "name": "黑龙江",
  "city": [{
    "name": "哈尔滨",
    "area": ["松北区", "道里区", "南岗区", "平房区", "香坊区", "道外区", "呼兰区", "阿城区", "双城市", "尚志市", "五常市", "宾县", "方正县", "通河县", "巴彦县", "延寿县", "木兰县", "依兰县", "其他"]
  }, {
    "name": "齐齐哈尔",
    "area": ["龙沙区", "昂昂溪区", "铁锋区", "建华区", "富拉尔基区", "碾子山区", "梅里斯达斡尔族区", "讷河市", "富裕县", "拜泉县", "甘南县", "依安县", "克山县", "泰来县", "克东县", "龙江县", "其他"]
  }, {"name": "鹤岗", "area": ["兴山区", "工农区", "南山区", "兴安区", "向阳区", "东山区", "萝北县", "绥滨县", "其他"]}, {
    "name": "双鸭山",
    "area": ["尖山区", "岭东区", "四方台区", "宝山区", "集贤县", "宝清县", "友谊县", "饶河县", "其他"]
  }, {"name": "鸡西", "area": ["鸡冠区", "恒山区", "城子河区", "滴道区", "梨树区", "麻山区", "密山市", "虎林市", "鸡东县", "其他"]}, {
    "name": "大庆",
    "area": ["萨尔图区", "红岗区", "龙凤区", "让胡路区", "大同区", "林甸县", "肇州县", "肇源县", "杜尔伯特蒙古族自治县", "其他"]
  }, {
    "name": "伊春",
    "area": ["伊春区", "带岭区", "南岔区", "金山屯区", "西林区", "美溪区", "乌马河区", "翠峦区", "友好区", "上甘岭区", "五营区", "红星区", "新青区", "汤旺河区", "乌伊岭区", "铁力市", "嘉荫县", "其他"]
  }, {
    "name": "牡丹江",
    "area": ["爱民区", "东安区", "阳明区", "西安区", "绥芬河市", "宁安市", "海林市", "穆棱市", "林口县", "东宁县", "其他"]
  }, {
    "name": "佳木斯",
    "area": ["向阳区", "前进区", "东风区", "郊区", "同江市", "富锦市", "桦川县", "抚远县", "桦南县", "汤原县", "其他"]
  }, {"name": "七台河", "area": ["桃山区", "新兴区", "茄子河区", "勃利县", "其他"]}, {
    "name": "黑河",
    "area": ["爱辉区", "北安市", "五大连池市", "逊克县", "嫩江县", "孙吴县", "其他"]
  }, {
    "name": "绥化",
    "area": ["北林区", "安达市", "肇东市", "海伦市", "绥棱县", "兰西县", "明水县", "青冈县", "庆安县", "望奎县", "其他"]
  }, {"name": "大兴安岭地区", "area": ["呼玛县", "塔河县", "漠河县", "大兴安岭辖区", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "heilongjiang"
}, {
  "name": "上海",
  "city": [{
    "name": "上海",
    "area": ["黄浦区", "卢湾区", "徐汇区", "长宁区", "静安区", "普陀区", "闸北区", "虹口区", "杨浦区", "宝山区", "闵行区", "嘉定区", "松江区", "金山区", "青浦区", "南汇区", "奉贤区", "浦东新区", "崇明县", "其他"]
  }],
  "json": "shanghai"
}, {
  "name": "江苏",
  "city": [{
    "name": "南京",
    "area": ["玄武区", "白下区", "秦淮区", "建邺区", "鼓楼区", "下关区", "栖霞区", "雨花台区", "浦口区", "江宁区", "六合区", "溧水县", "高淳县", "其他"]
  }, {
    "name": "苏州",
    "area": ["金阊区", "平江区", "沧浪区", "虎丘区", "吴中区", "相城区", "常熟市", "张家港市", "昆山市", "吴江市", "太仓市", "其他"]
  }, {"name": "无锡", "area": ["崇安区", "南长区", "北塘区", "滨湖区", "锡山区", "惠山区", "江阴市", "宜兴市", "其他"]}, {
    "name": "常州",
    "area": ["钟楼区", "天宁区", "戚墅堰区", "新北区", "武进区", "金坛市", "溧阳市", "其他"]
  }, {"name": "镇江", "area": ["京口区", "润州区", "丹徒区", "丹阳市", "扬中市", "句容市", "其他"]}, {
    "name": "南通",
    "area": ["崇川区", "港闸区", "通州市", "如皋市", "海门市", "启东市", "海安县", "如东县", "其他"]
  }, {"name": "泰州", "area": ["海陵区", "高港区", "姜堰市", "泰兴市", "靖江市", "兴化市", "其他"]}, {
    "name": "扬州",
    "area": ["广陵区", "维扬区", "邗江区", "江都市", "仪征市", "高邮市", "宝应县", "其他"]
  }, {"name": "盐城", "area": ["亭湖区", "盐都区", "大丰市", "东台市", "建湖县", "射阳县", "阜宁县", "滨海县", "响水县", "其他"]}, {
    "name": "连云港",
    "area": ["新浦区", "海州区", "连云区", "东海县", "灌云县", "赣榆县", "灌南县", "其他"]
  }, {
    "name": "徐州",
    "area": ["云龙区", "鼓楼区", "九里区", "泉山区", "贾汪区", "邳州市", "新沂市", "铜山县", "睢宁县", "沛县", "丰县", "其他"]
  }, {"name": "淮安", "area": ["清河区", "清浦区", "楚州区", "淮阴区", "涟水县", "洪泽县", "金湖县", "盱眙县", "其他"]}, {
    "name": "宿迁",
    "area": ["宿城区", "宿豫区", "沭阳县", "泗阳县", "泗洪县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "jiangsu"
}, {
  "name": "浙江",
  "city": [{
    "name": "杭州",
    "area": ["拱墅区", "西湖区", "上城区", "下城区", "江干区", "滨江区", "余杭区", "萧山区", "建德市", "富阳市", "临安市", "桐庐县", "淳安县", "其他"]
  }, {
    "name": "宁波",
    "area": ["海曙区", "江东区", "江北区", "镇海区", "北仑区", "鄞州区", "余姚市", "慈溪市", "奉化市", "宁海县", "象山县", "其他"]
  }, {
    "name": "温州",
    "area": ["鹿城区", "龙湾区", "瓯海区", "瑞安市", "乐清市", "永嘉县", "洞头县", "平阳县", "苍南县", "文成县", "泰顺县", "其他"]
  }, {"name": "嘉兴", "area": ["秀城区", "秀洲区", "海宁市", "平湖市", "桐乡市", "嘉善县", "海盐县", "其他"]}, {
    "name": "湖州",
    "area": ["吴兴区", "南浔区", "长兴县", "德清县", "安吉县", "其他"]
  }, {"name": "绍兴", "area": ["越城区", "诸暨市", "上虞市", "嵊州市", "绍兴县", "新昌县", "其他"]}, {
    "name": "金华",
    "area": ["婺城区", "金东区", "兰溪市", "义乌市", "东阳市", "永康市", "武义县", "浦江县", "磐安县", "其他"]
  }, {"name": "衢州", "area": ["柯城区", "衢江区", "江山市", "龙游县", "常山县", "开化县", "其他"]}, {
    "name": "舟山",
    "area": ["定海区", "普陀区", "岱山县", "嵊泗县", "其他"]
  }, {"name": "台州", "area": ["椒江区", "黄岩区", "路桥区", "临海市", "温岭市", "玉环县", "天台县", "仙居县", "三门县", "其他"]}, {
    "name": "丽水",
    "area": ["莲都区", "龙泉市", "缙云县", "青田县", "云和县", "遂昌县", "松阳县", "庆元县", "景宁畲族自治县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "zhejiang"
}, {
  "name": "安徽",
  "city": [{"name": "合肥", "area": ["庐阳区", "瑶海区", "蜀山区", "包河区", "长丰县", "肥东县", "肥西县", "其他"]}, {
    "name": "芜湖",
    "area": ["镜湖区", "弋江区", "鸠江区", "三山区", "芜湖县", "南陵县", "繁昌县", "其他"]
  }, {"name": "蚌埠", "area": ["蚌山区", "龙子湖区", "禹会区", "淮上区", "怀远县", "固镇县", "五河县", "其他"]}, {
    "name": "淮南",
    "area": ["田家庵区", "大通区", "谢家集区", "八公山区", "潘集区", "凤台县", "其他"]
  }, {"name": "马鞍山", "area": ["雨山区", "花山区", "金家庄区", "当涂县", "其他"]}, {
    "name": "淮北",
    "area": ["相山区", "杜集区", "烈山区", "濉溪县", "其他"]
  }, {"name": "铜陵", "area": ["铜官山区", "狮子山区", "郊区", "铜陵县", "其他"]}, {
    "name": "安庆",
    "area": ["迎江区", "大观区", "宜秀区", "桐城市", "宿松县", "枞阳县", "太湖县", "怀宁县", "岳西县", "望江县", "潜山县", "其他"]
  }, {"name": "黄山", "area": ["屯溪区", "黄山区", "徽州区", "休宁县", "歙县", "祁门县", "黟县", "其他"]}, {
    "name": "滁州",
    "area": ["琅琊区", "南谯区", "天长市", "明光市", "全椒县", "来安县", "定远县", "凤阳县", "其他"]
  }, {"name": "阜阳", "area": ["颍州区", "颍东区", "颍泉区", "界首市", "临泉县", "颍上县", "阜南县", "太和县", "其他"]}, {
    "name": "宿州",
    "area": ["埇桥区", "萧县", "泗县", "砀山县", "灵璧县", "其他"]
  }, {"name": "巢湖", "area": ["居巢区", "含山县", "无为县", "庐江县", "和县", "其他"]}, {
    "name": "六安",
    "area": ["金安区", "裕安区", "寿县", "霍山县", "霍邱县", "舒城县", "金寨县", "其他"]
  }, {"name": "亳州", "area": ["谯城区", "利辛县", "涡阳县", "蒙城县", "其他"]}, {
    "name": "池州",
    "area": ["贵池区", "东至县", "石台县", "青阳县", "其他"]
  }, {"name": "宣城", "area": ["宣州区", "宁国市", "广德县", "郎溪县", "泾县", "旌德县", "绩溪县", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "anhui"
}, {
  "name": "福建",
  "city": [{
    "name": "福州",
    "area": ["鼓楼区", "台江区", "仓山区", "马尾区", "晋安区", "福清市", "长乐市", "闽侯县", "闽清县", "永泰县", "连江县", "罗源县", "平潭县", "其他"]
  }, {"name": "厦门", "area": ["思明区", "海沧区", "湖里区", "集美区", "同安区", "翔安区", "其他"]}, {
    "name": "莆田",
    "area": ["城厢区", "涵江区", "荔城区", "秀屿区", "仙游县", "其他"]
  }, {
    "name": "三明",
    "area": ["梅列区", "三元区", "永安市", "明溪县", "将乐县", "大田县", "宁化县", "建宁县", "沙县", "尤溪县", "清流县", "泰宁县", "其他"]
  }, {
    "name": "泉州",
    "area": ["鲤城区", "丰泽区", "洛江区", "泉港区", "石狮市", "晋江市", "南安市", "惠安县", "永春县", "安溪县", "德化县", "金门县", "其他"]
  }, {
    "name": "漳州",
    "area": ["芗城区", "龙文区", "龙海市", "平和县", "南靖县", "诏安县", "漳浦县", "华安县", "东山县", "长泰县", "云霄县", "其他"]
  }, {
    "name": "南平",
    "area": ["延平区", "建瓯市", "邵武市", "武夷山市", "建阳市", "松溪县", "光泽县", "顺昌县", "浦城县", "政和县", "其他"]
  }, {"name": "龙岩", "area": ["新罗区", "漳平市", "长汀县", "武平县", "上杭县", "永定县", "连城县", "其他"]}, {
    "name": "宁德",
    "area": ["蕉城区", "福安市", "福鼎市", "寿宁县", "霞浦县", "柘荣县", "屏南县", "古田县", "周宁县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "fujian"
}, {
  "name": "江西",
  "city": [{
    "name": "南昌",
    "area": ["东湖区", "西湖区", "青云谱区", "湾里区", "青山湖区", "新建县", "南昌县", "进贤县", "安义县", "其他"]
  }, {"name": "景德镇", "area": ["珠山区", "昌江区", "乐平市", "浮梁县", "其他"]}, {
    "name": "萍乡",
    "area": ["安源区", "湘东区", "莲花县", "上栗县", "芦溪县", "其他"]
  }, {
    "name": "九江",
    "area": ["浔阳区", "庐山区", "瑞昌市", "九江县", "星子县", "武宁县", "彭泽县", "永修县", "修水县", "湖口县", "德安县", "都昌县", "其他"]
  }, {"name": "新余", "area": ["渝水区", "分宜县", "其他"]}, {"name": "鹰潭", "area": ["月湖区", "贵溪市", "余江县", "其他"]}, {
    "name": "赣州",
    "area": ["章贡区", "瑞金市", "南康市", "石城县", "安远县", "赣县", "宁都县", "寻乌县", "兴国县", "定南县", "上犹县", "于都县", "龙南县", "崇义县", "信丰县", "全南县", "大余县", "会昌县", "其他"]
  }, {
    "name": "吉安",
    "area": ["吉州区", "青原区", "井冈山市", "吉安县", "永丰县", "永新县", "新干县", "泰和县", "峡江县", "遂川县", "安福县", "吉水县", "万安县", "其他"]
  }, {
    "name": "宜春",
    "area": ["袁州区", "丰城市", "樟树市", "高安市", "铜鼓县", "靖安县", "宜丰县", "奉新县", "万载县", "上高县", "其他"]
  }, {
    "name": "抚州",
    "area": ["临川区", "南丰县", "乐安县", "金溪县", "南城县", "东乡县", "资溪县", "宜黄县", "广昌县", "黎川县", "崇仁县", "其他"]
  }, {
    "name": "上饶",
    "area": ["信州区", "德兴市", "上饶县", "广丰县", "鄱阳县", "婺源县", "铅山县", "余干县", "横峰县", "弋阳县", "玉山县", "万年县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "jiangxi"
}, {
  "name": "山东",
  "city": [{
    "name": "济南",
    "area": ["市中区", "历下区", "天桥区", "槐荫区", "历城区", "长清区", "章丘市", "平阴县", "济阳县", "商河县", "其他"]
  }, {
    "name": "青岛",
    "area": ["市南区", "市北区", "城阳区", "四方区", "李沧区", "黄岛区", "崂山区", "胶南市", "胶州市", "平度市", "莱西市", "即墨市", "其他"]
  }, {"name": "淄博", "area": ["张店区", "临淄区", "淄川区", "博山区", "周村区", "桓台县", "高青县", "沂源县", "其他"]}, {
    "name": "枣庄",
    "area": ["市中区", "山亭区", "峄城区", "台儿庄区", "薛城区", "滕州市", "其他"]
  }, {"name": "东营", "area": ["东营区", "河口区", "垦利县", "广饶县", "利津县", "其他"]}, {
    "name": "烟台",
    "area": ["芝罘区", "福山区", "牟平区", "莱山区", "龙口市", "莱阳市", "莱州市", "招远市", "蓬莱市", "栖霞市", "海阳市", "长岛县", "其他"]
  }, {
    "name": "潍坊",
    "area": ["潍城区", "寒亭区", "坊子区", "奎文区", "青州市", "诸城市", "寿光市", "安丘市", "高密市", "昌邑市", "昌乐县", "临朐县", "其他"]
  }, {
    "name": "济宁",
    "area": ["市中区", "任城区", "曲阜市", "兖州市", "邹城市", "鱼台县", "金乡县", "嘉祥县", "微山县", "汶上县", "泗水县", "梁山县", "其他"]
  }, {"name": "泰安", "area": ["泰山区", "岱岳区", "新泰市", "肥城市", "宁阳县", "东平县", "其他"]}, {
    "name": "威海",
    "area": ["环翠区", "乳山市", "文登市", "荣成市", "其他"]
  }, {"name": "日照", "area": ["东港区", "岚山区", "五莲县", "莒县", "其他"]}, {
    "name": "莱芜",
    "area": ["莱城区", "钢城区", "其他"]
  }, {
    "name": "临沂",
    "area": ["兰山区", "罗庄区", "河东区", "沂南县", "郯城县", "沂水县", "苍山县", "费县", "平邑县", "莒南县", "蒙阴县", "临沭县", "其他"]
  }, {
    "name": "德州",
    "area": ["德城区", "乐陵市", "禹城市", "陵县", "宁津县", "齐河县", "武城县", "庆云县", "平原县", "夏津县", "临邑县", "其他"]
  }, {"name": "聊城", "area": ["东昌府区", "临清市", "高唐县", "阳谷县", "茌平县", "莘县", "东阿县", "冠县", "其他"]}, {
    "name": "滨州",
    "area": ["滨城区", "邹平县", "沾化县", "惠民县", "博兴县", "阳信县", "无棣县", "其他"]
  }, {"name": "菏泽", "area": ["牡丹区", "鄄城县", "单县", "郓城县", "曹县", "定陶县", "巨野县", "东明县", "成武县", "其他"]}, {
    "name": "其他",
    "area": ["其他"]
  }],
  "json": "shandong"
}, {
  "name": "河南",
  "city": [{
    "name": "郑州",
    "area": ["中原区", "金水区", "二七区", "管城回族区", "上街区", "惠济区", "巩义市", "新郑市", "新密市", "登封市", "荥阳市", "中牟县", "其他"]
  }, {
    "name": "开封",
    "area": ["鼓楼区", "龙亭区", "顺河回族区", "禹王台区", "金明区", "开封县", "尉氏县", "兰考县", "杞县", "通许县", "其他"]
  }, {
    "name": "洛阳",
    "area": ["西工区", "老城区", "涧西区", "瀍河回族区", "洛龙区", "吉利区", "偃师市", "孟津县", "汝阳县", "伊川县", "洛宁县", "嵩县", "宜阳县", "新安县", "栾川县", "其他"]
  }, {"name": "平顶山", "area": ["新华区", "卫东区", "湛河区", "石龙区", "汝州市", "舞钢市", "宝丰县", "叶县", "郏县", "鲁山县", "其他"]}, {
    "name": "安阳",
    "area": ["北关区", "文峰区", "殷都区", "龙安区", "林州市", "安阳县", "滑县", "内黄县", "汤阴县", "其他"]
  }, {"name": "鹤壁", "area": ["淇滨区", "山城区", "鹤山区", "浚县", "淇县", "其他"]}, {
    "name": "新乡",
    "area": ["卫滨区", "红旗区", "凤泉区", "牧野区", "卫辉市", "辉县市", "新乡县", "获嘉县", "原阳县", "长垣县", "封丘县", "延津县", "其他"]
  }, {"name": "焦作", "area": ["解放区", "中站区", "马村区", "山阳区", "沁阳市", "孟州市", "修武县", "温县", "武陟县", "博爱县", "其他"]}, {
    "name": "濮阳",
    "area": ["华龙区", "濮阳县", "南乐县", "台前县", "清丰县", "范县", "其他"]
  }, {"name": "许昌", "area": ["魏都区", "禹州市", "长葛市", "许昌县", "鄢陵县", "襄城县", "其他"]}, {
    "name": "漯河",
    "area": ["源汇区", "郾城区", "召陵区", "临颍县", "舞阳县", "其他"]
  }, {"name": "三门峡", "area": ["湖滨区", "义马市", "灵宝市", "渑池县", "卢氏县", "陕县", "其他"]}, {
    "name": "南阳",
    "area": ["卧龙区", "宛城区", "邓州市", "桐柏县", "方城县", "淅川县", "镇平县", "唐河县", "南召县", "内乡县", "新野县", "社旗县", "西峡县", "其他"]
  }, {"name": "商丘", "area": ["梁园区", "睢阳区", "永城市", "宁陵县", "虞城县", "民权县", "夏邑县", "柘城县", "睢县", "其他"]}, {
    "name": "信阳",
    "area": ["浉河区", "平桥区", "潢川县", "淮滨县", "息县", "新县", "商城县", "固始县", "罗山县", "光山县", "其他"]
  }, {
    "name": "周口",
    "area": ["川汇区", "项城市", "商水县", "淮阳县", "太康县", "鹿邑县", "西华县", "扶沟县", "沈丘县", "郸城县", "其他"]
  }, {
    "name": "驻马店",
    "area": ["驿城区", "确山县", "新蔡县", "上蔡县", "西平县", "泌阳县", "平舆县", "汝南县", "遂平县", "正阳县", "其他"]
  }, {"name": "焦作", "area": ["济源市", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "henan"
}, {
  "name": "湖北",
  "city": [{
    "name": "武汉",
    "area": ["江岸区", "武昌区", "江汉区", "硚口区", "汉阳区", "青山区", "洪山区", "东西湖区", "汉南区", "蔡甸区", "江夏区", "黄陂区", "新洲区", "其他"]
  }, {"name": "黄石", "area": ["黄石港区", "西塞山区", "下陆区", "铁山区", "大冶市", "阳新县", "其他"]}, {
    "name": "十堰",
    "area": ["张湾区", "茅箭区", "丹江口市", "郧县", "竹山县", "房县", "郧西县", "竹溪县", "其他"]
  }, {"name": "荆州", "area": ["沙市区", "荆州区", "洪湖市", "石首市", "松滋市", "监利县", "公安县", "江陵县", "其他"]}, {
    "name": "宜昌",
    "area": ["西陵区", "伍家岗区", "点军区", "猇亭区", "夷陵区", "宜都市", "当阳市", "枝江市", "秭归县", "远安县", "兴山县", "五峰土家族自治县", "长阳土家族自治县", "其他"]
  }, {"name": "襄樊", "area": ["襄城区", "樊城区", "襄阳区", "老河口市", "枣阳市", "宜城市", "南漳县", "谷城县", "保康县", "其他"]}, {
    "name": "鄂州",
    "area": ["鄂城区", "华容区", "梁子湖区", "其他"]
  }, {"name": "荆门", "area": ["东宝区", "掇刀区", "钟祥市", "京山县", "沙洋县", "其他"]}, {
    "name": "孝感",
    "area": ["孝南区", "应城市", "安陆市", "汉川市", "云梦县", "大悟县", "孝昌县", "其他"]
  }, {
    "name": "黄冈",
    "area": ["黄州区", "麻城市", "武穴市", "红安县", "罗田县", "浠水县", "蕲春县", "黄梅县", "英山县", "团风县", "其他"]
  }, {"name": "咸宁", "area": ["咸安区", "赤壁市", "嘉鱼县", "通山县", "崇阳县", "通城县", "其他"]}, {
    "name": "随州",
    "area": ["曾都区", "广水市", "其他"]
  }, {"name": "恩施土家族苗族自治州", "area": ["恩施市", "利川市", "建始县", "来凤县", "巴东县", "鹤峰县", "宣恩县", "咸丰县", "其他"]}, {
    "name": "仙桃",
    "area": ["仙桃"]
  }, {"name": "天门", "area": ["天门"]}, {"name": "潜江", "area": ["潜江"]}, {
    "name": "神农架林区",
    "area": ["神农架林区"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "hubei"
}, {
  "name": "湖南",
  "city": [{"name": "长沙", "area": ["岳麓区", "芙蓉区", "天心区", "开福区", "雨花区", "浏阳市", "长沙县", "望城县", "宁乡县", "其他"]}, {
    "name": "株洲",
    "area": ["天元区", "荷塘区", "芦淞区", "石峰区", "醴陵市", "株洲县", "炎陵县", "茶陵县", "攸县", "其他"]
  }, {"name": "湘潭", "area": ["岳塘区", "雨湖区", "湘乡市", "韶山市", "湘潭县", "其他"]}, {
    "name": "衡阳",
    "area": ["雁峰区", "珠晖区", "石鼓区", "蒸湘区", "南岳区", "耒阳市", "常宁市", "衡阳县", "衡东县", "衡山县", "衡南县", "祁东县", "其他"]
  }, {
    "name": "邵阳",
    "area": ["双清区", "大祥区", "北塔区", "武冈市", "邵东县", "洞口县", "新邵县", "绥宁县", "新宁县", "邵阳县", "隆回县", "城步苗族自治县", "其他"]
  }, {"name": "岳阳", "area": ["岳阳楼区", "云溪区", "君山区", "临湘市", "汨罗市", "岳阳县", "湘阴县", "平江县", "华容县", "其他"]}, {
    "name": "常德",
    "area": ["武陵区", "鼎城区", "津市市", "澧县", "临澧县", "桃源县", "汉寿县", "安乡县", "石门县", "其他"]
  }, {"name": "张家界", "area": ["永定区", "武陵源区", "慈利县", "桑植县", "其他"]}, {
    "name": "益阳",
    "area": ["赫山区", "资阳区", "沅江市", "桃江县", "南县", "安化县", "其他"]
  }, {
    "name": "郴州",
    "area": ["北湖区", "苏仙区", "资兴市", "宜章县", "汝城县", "安仁县", "嘉禾县", "临武县", "桂东县", "永兴县", "桂阳县", "其他"]
  }, {
    "name": "永州",
    "area": ["冷水滩区", "零陵区", "祁阳县", "蓝山县", "宁远县", "新田县", "东安县", "江永县", "道县", "双牌县", "江华瑶族自治县", "其他"]
  }, {
    "name": "怀化",
    "area": ["鹤城区", "洪江市", "会同县", "沅陵县", "辰溪县", "溆浦县", "中方县", "新晃侗族自治县", "芷江侗族自治县", "通道侗族自治县", "靖州苗族侗族自治县", "麻阳苗族自治县", "其他"]
  }, {"name": "娄底", "area": ["娄星区", "冷水江市", "涟源市", "新化县", "双峰县", "其他"]}, {
    "name": "湘西土家族苗族自治州",
    "area": ["吉首市", "古丈县", "龙山县", "永顺县", "凤凰县", "泸溪县", "保靖县", "花垣县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "hunan"
}, {
  "name": "广东",
  "city": [{
    "name": "广州",
    "area": ["越秀区", "荔湾区", "海珠区", "天河区", "白云区", "黄埔区", "番禺区", "花都区", "南沙区", "萝岗区", "增城市", "从化市", "其他"]
  }, {"name": "深圳", "area": ["福田区", "罗湖区", "南山区", "宝安区", "龙岗区", "盐田区", "其他"]}, {
    "name": "东莞",
    "area": ["莞城", "常平", "塘厦", "其他"]
  }, {"name": "中山", "area": ["中山"]}, {"name": "潮州", "area": ["湘桥区", "潮安县", "饶平县", "其他"]}, {
    "name": "揭阳",
    "area": ["榕城区", "揭东县", "揭西县", "惠来县", "普宁市", "其他"]
  }, {"name": "云浮", "area": ["云城区", "新兴县", "郁南县", "云安县", "罗定市", "其他"]}, {
    "name": "珠海",
    "area": ["香洲区", "斗门区", "金湾区", "其他"]
  }, {"name": "汕头", "area": ["金平区", "濠江区", "龙湖区", "潮阳区", "潮南区", "澄海区", "南澳县", "其他"]}, {
    "name": "韶关",
    "area": ["浈江区", "武江区", "曲江区", "乐昌市", "南雄市", "始兴县", "仁化县", "翁源县", "新丰县", "乳源瑶族自治县", "其他"]
  }, {"name": "佛山", "area": ["禅城区", "南海区", "顺德区", "三水区", "高明区", "其他"]}, {
    "name": "江门",
    "area": ["蓬江区", "江海区", "新会区", "恩平市", "台山市", "开平市", "鹤山市", "其他"]
  }, {"name": "湛江", "area": ["赤坎区", "霞山区", "坡头区", "麻章区", "吴川市", "廉江市", "雷州市", "遂溪县", "徐闻县", "其他"]}, {
    "name": "茂名",
    "area": ["茂南区", "茂港区", "化州市", "信宜市", "高州市", "电白县", "其他"]
  }, {"name": "肇庆", "area": ["端州区", "鼎湖区", "高要市", "四会市", "广宁县", "怀集县", "封开县", "德庆县", "其他"]}, {
    "name": "惠州",
    "area": ["惠城区", "惠阳区", "博罗县", "惠东县", "龙门县", "其他"]
  }, {"name": "梅州", "area": ["梅江区", "兴宁市", "梅县", "大埔县", "丰顺县", "五华县", "平远县", "蕉岭县", "其他"]}, {
    "name": "汕尾",
    "area": ["城区", "陆丰市", "海丰县", "陆河县", "其他"]
  }, {"name": "河源", "area": ["源城区", "紫金县", "龙川县", "连平县", "和平县", "东源县", "其他"]}, {
    "name": "阳江",
    "area": ["江城区", "阳春市", "阳西县", "阳东县", "其他"]
  }, {"name": "清远", "area": ["清城区", "英德市", "连州市", "佛冈县", "阳山县", "清新县", "连山壮族瑶族自治县", "连南瑶族自治县", "其他"]}],
  "json": "guangdong"
}, {
  "name": "广西",
  "city": [{
    "name": "南宁",
    "area": ["青秀区", "兴宁区", "西乡塘区", "良庆区", "江南区", "邕宁区", "武鸣县", "隆安县", "马山县", "上林县", "宾阳县", "横县", "其他"]
  }, {
    "name": "柳州",
    "area": ["城中区", "鱼峰区", "柳北区", "柳南区", "柳江县", "柳城县", "鹿寨县", "融安县", "融水苗族自治县", "三江侗族自治县", "其他"]
  }, {
    "name": "桂林",
    "area": ["象山区", "秀峰区", "叠彩区", "七星区", "雁山区", "阳朔县", "临桂县", "灵川县", "全州县", "平乐县", "兴安县", "灌阳县", "荔浦县", "资源县", "永福县", "龙胜各族自治县", "恭城瑶族自治县", "其他"]
  }, {"name": "梧州", "area": ["万秀区", "蝶山区", "长洲区", "岑溪市", "苍梧县", "藤县", "蒙山县", "其他"]}, {
    "name": "北海",
    "area": ["海城区", "银海区", "铁山港区", "合浦县", "其他"]
  }, {"name": "防城港", "area": ["港口区", "防城区", "东兴市", "上思县", "其他"]}, {
    "name": "钦州",
    "area": ["钦南区", "钦北区", "灵山县", "浦北县", "其他"]
  }, {"name": "贵港", "area": ["港北区", "港南区", "覃塘区", "桂平市", "平南县", "其他"]}, {
    "name": "玉林",
    "area": ["玉州区", "北流市", "容县", "陆川县", "博白县", "兴业县", "其他"]
  }, {
    "name": "百色",
    "area": ["右江区", "凌云县", "平果县", "西林县", "乐业县", "德保县", "田林县", "田阳县", "靖西县", "田东县", "那坡县", "隆林各族自治县", "其他"]
  }, {"name": "贺州", "area": ["八步区", "钟山县", "昭平县", "富川瑶族自治县", "其他"]}, {
    "name": "河池",
    "area": ["金城江区", "宜州市", "天峨县", "凤山县", "南丹县", "东兰县", "都安瑶族自治县", "罗城仫佬族自治县", "巴马瑶族自治县", "环江毛南族自治县", "大化瑶族自治县", "其他"]
  }, {"name": "来宾", "area": ["兴宾区", "合山市", "象州县", "武宣县", "忻城县", "金秀瑶族自治县", "其他"]}, {
    "name": "崇左",
    "area": ["江州区", "凭祥市", "宁明县", "扶绥县", "龙州县", "大新县", "天等县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "guangxi"
}, {
  "name": "海南",
  "city": [{"name": "海口", "area": ["龙华区", "秀英区", "琼山区", "美兰区", "其他"]}, {
    "name": "三亚",
    "area": ["三亚市", "其他"]
  }, {"name": "五指山", "area": ["五指山"]}, {"name": "琼海", "area": ["琼海"]}, {"name": "儋州", "area": ["儋州"]}, {
    "name": "文昌",
    "area": ["文昌"]
  }, {"name": "万宁", "area": ["万宁"]}, {"name": "东方", "area": ["东方"]}, {"name": "澄迈县", "area": ["澄迈县"]}, {
    "name": "定安县",
    "area": ["定安县"]
  }, {"name": "屯昌县", "area": ["屯昌县"]}, {"name": "临高县", "area": ["临高县"]}, {
    "name": "白沙黎族自治县",
    "area": ["白沙黎族自治县"]
  }, {"name": "昌江黎族自治县", "area": ["昌江黎族自治县"]}, {"name": "乐东黎族自治县", "area": ["乐东黎族自治县"]}, {
    "name": "陵水黎族自治县",
    "area": ["陵水黎族自治县"]
  }, {"name": "保亭黎族苗族自治县", "area": ["保亭黎族苗族自治县"]}, {"name": "琼中黎族苗族自治县", "area": ["琼中黎族苗族自治县"]}, {
    "name": "其他",
    "area": ["其他"]
  }],
  "json": "hainan"
}, {
  "name": "重庆",
  "city": [{
    "name": "重庆",
    "area": ["渝中区", "大渡口区", "江北区", "南岸区", "北碚区", "渝北区", "巴南区", "长寿区", "双桥区", "沙坪坝区", "万盛区", "万州区", "涪陵区", "黔江区", "永川区", "合川区", "江津区", "九龙坡区", "南川区", "綦江县", "潼南县", "荣昌县", "璧山县", "大足县", "铜梁县", "梁平县", "开县", "忠县", "城口县", "垫江县", "武隆县", "丰都县", "奉节县", "云阳县", "巫溪县", "巫山县", "石柱土家族自治县", "秀山土家族苗族自治县", "酉阳土家族苗族自治县", "彭水苗族土家族自治县", "其他"]
  }],
  "json": "chongqing"
}, {
  "name": "四川",
  "city": [{
    "name": "成都",
    "area": ["青羊区", "锦江区", "金牛区", "武侯区", "成华区", "龙泉驿区", "青白江区", "新都区", "温江区", "都江堰市", "彭州市", "邛崃市", "崇州市", "金堂县", "郫县", "新津县", "双流县", "蒲江县", "大邑县", "其他"]
  }, {"name": "自贡", "area": ["大安区", "自流井区", "贡井区", "沿滩区", "荣县", "富顺县", "其他"]}, {
    "name": "攀枝花",
    "area": ["仁和区", "米易县", "盐边县", "东区", "西区", "其他"]
  }, {"name": "泸州", "area": ["江阳区", "纳溪区", "龙马潭区", "泸县", "合江县", "叙永县", "古蔺县", "其他"]}, {
    "name": "德阳",
    "area": ["旌阳区", "广汉市", "什邡市", "绵竹市", "罗江县", "中江县", "其他"]
  }, {"name": "绵阳", "area": ["涪城区", "游仙区", "江油市", "盐亭县", "三台县", "平武县", "安县", "梓潼县", "北川羌族自治县", "其他"]}, {
    "name": "广元",
    "area": ["元坝区", "朝天区", "青川县", "旺苍县", "剑阁县", "苍溪县", "市中区", "其他"]
  }, {"name": "遂宁", "area": ["船山区", "安居区", "射洪县", "蓬溪县", "大英县", "其他"]}, {
    "name": "内江",
    "area": ["市中区", "东兴区", "资中县", "隆昌县", "威远县", "其他"]
  }, {
    "name": "乐山",
    "area": ["市中区", "五通桥区", "沙湾区", "金口河区", "峨眉山市", "夹江县", "井研县", "犍为县", "沐川县", "马边彝族自治县", "峨边彝族自治县", "其他"]
  }, {"name": "南充", "area": ["顺庆区", "高坪区", "嘉陵区", "阆中市", "营山县", "蓬安县", "仪陇县", "南部县", "西充县", "其他"]}, {
    "name": "眉山",
    "area": ["东坡区", "仁寿县", "彭山县", "洪雅县", "丹棱县", "青神县", "其他"]
  }, {"name": "宜宾", "area": ["翠屏区", "宜宾县", "兴文县", "南溪县", "珙县", "长宁县", "高县", "江安县", "筠连县", "屏山县", "其他"]}, {
    "name": "广安",
    "area": ["广安区", "华蓥市", "岳池县", "邻水县", "武胜县", "其他"]
  }, {"name": "达州", "area": ["通川区", "万源市", "达县", "渠县", "宣汉县", "开江县", "大竹县", "其他"]}, {
    "name": "雅安",
    "area": ["雨城区", "芦山县", "石棉县", "名山县", "天全县", "荥经县", "宝兴县", "汉源县", "其他"]
  }, {"name": "巴中", "area": ["巴州区", "南江县", "平昌县", "通江县", "其他"]}, {
    "name": "资阳",
    "area": ["雁江区", "简阳市", "安岳县", "乐至县", "其他"]
  }, {
    "name": "阿坝藏族羌族自治州",
    "area": ["马尔康县", "九寨沟县", "红原县", "汶川县", "阿坝县", "理县", "若尔盖县", "小金县", "黑水县", "金川县", "松潘县", "壤塘县", "茂县", "其他"]
  }, {
    "name": "甘孜藏族自治州",
    "area": ["康定县", "丹巴县", "炉霍县", "九龙县", "甘孜县", "雅江县", "新龙县", "道孚县", "白玉县", "理塘县", "德格县", "乡城县", "石渠县", "稻城县", "色达县", "巴塘县", "泸定县", "得荣县", "其他"]
  }, {
    "name": "凉山彝族自治州",
    "area": ["西昌市", "美姑县", "昭觉县", "金阳县", "甘洛县", "布拖县", "雷波县", "普格县", "宁南县", "喜德县", "会东县", "越西县", "会理县", "盐源县", "德昌县", "冕宁县", "木里藏族自治县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "sichuan"
}, {
  "name": "贵州",
  "city": [{
    "name": "贵阳",
    "area": ["南明区", "云岩区", "花溪区", "乌当区", "白云区", "小河区", "清镇市", "开阳县", "修文县", "息烽县", "其他"]
  }, {"name": "六盘水", "area": ["钟山区", "水城县", "盘县", "六枝特区", "其他"]}, {
    "name": "遵义",
    "area": ["红花岗区", "汇川区", "赤水市", "仁怀市", "遵义县", "绥阳县", "桐梓县", "习水县", "凤冈县", "正安县", "余庆县", "湄潭县", "道真仡佬族苗族自治县", "务川仡佬族苗族自治县", "其他"]
  }, {"name": "安顺", "area": ["西秀区", "普定县", "平坝县", "镇宁布依族苗族自治县", "紫云苗族布依族自治县", "关岭布依族苗族自治县", "其他"]}, {
    "name": "铜仁地区",
    "area": ["铜仁市", "德江县", "江口县", "思南县", "石阡县", "玉屏侗族自治县", "松桃苗族自治县", "印江土家族苗族自治县", "沿河土家族自治县", "万山特区", "其他"]
  }, {
    "name": "毕节地区",
    "area": ["毕节市", "黔西县", "大方县", "织金县", "金沙县", "赫章县", "纳雍县", "威宁彝族回族苗族自治县", "其他"]
  }, {
    "name": "黔西南布依族苗族自治州",
    "area": ["兴义市", "望谟县", "兴仁县", "普安县", "册亨县", "晴隆县", "贞丰县", "安龙县", "其他"]
  }, {
    "name": "黔东南苗族侗族自治州",
    "area": ["凯里市", "施秉县", "从江县", "锦屏县", "镇远县", "麻江县", "台江县", "天柱县", "黄平县", "榕江县", "剑河县", "三穗县", "雷山县", "黎平县", "岑巩县", "丹寨县", "其他"]
  }, {
    "name": "黔南布依族苗族自治州",
    "area": ["都匀市", "福泉市", "贵定县", "惠水县", "罗甸县", "瓮安县", "荔波县", "龙里县", "平塘县", "长顺县", "独山县", "三都水族自治县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "guizhou"
}, {
  "name": "云南",
  "city": [{
    "name": "昆明",
    "area": ["盘龙区", "五华区", "官渡区", "西山区", "东川区", "安宁市", "呈贡县", "晋宁县", "富民县", "宜良县", "嵩明县", "石林彝族自治县", "禄劝彝族苗族自治县", "寻甸回族彝族自治县", "其他"]
  }, {"name": "曲靖", "area": ["麒麟区", "宣威市", "马龙县", "沾益县", "富源县", "罗平县", "师宗县", "陆良县", "会泽县", "其他"]}, {
    "name": "玉溪",
    "area": ["红塔区", "江川县", "澄江县", "通海县", "华宁县", "易门县", "峨山彝族自治县", "新平彝族傣族自治县", "元江哈尼族彝族傣族自治县", "其他"]
  }, {"name": "保山", "area": ["隆阳区", "施甸县", "腾冲县", "龙陵县", "昌宁县", "其他"]}, {
    "name": "昭通",
    "area": ["昭阳区", "鲁甸县", "巧家县", "盐津县", "大关县", "永善县", "绥江县", "镇雄县", "彝良县", "威信县", "水富县", "其他"]
  }, {"name": "丽江", "area": ["古城区", "永胜县", "华坪县", "玉龙纳西族自治县", "宁蒗彝族自治县", "其他"]}, {
    "name": "普洱",
    "area": ["思茅区", "普洱哈尼族彝族自治县", "墨江哈尼族自治县", "景东彝族自治县", "景谷傣族彝族自治县", "镇沅彝族哈尼族拉祜族自治县", "江城哈尼族彝族自治县", "孟连傣族拉祜族佤族自治县", "澜沧拉祜族自治县", "西盟佤族自治县", "其他"]
  }, {
    "name": "临沧",
    "area": ["临翔区", "凤庆县", "云县", "永德县", "镇康县", "双江拉祜族佤族布朗族傣族自治县", "耿马傣族佤族自治县", "沧源佤族自治县", "其他"]
  }, {"name": "德宏傣族景颇族自治州", "area": ["潞西市", "瑞丽市", "梁河县", "盈江县", "陇川县", "其他"]}, {
    "name": "怒江傈僳族自治州",
    "area": ["泸水县", "福贡县", "贡山独龙族怒族自治县", "兰坪白族普米族自治县", "其他"]
  }, {"name": "迪庆藏族自治州", "area": ["香格里拉县", "德钦县", "维西傈僳族自治县", "其他"]}, {
    "name": "大理白族自治州",
    "area": ["大理市", "祥云县", "宾川县", "弥渡县", "永平县", "云龙县", "洱源县", "剑川县", "鹤庆县", "漾濞彝族自治县", "南涧彝族自治县", "巍山彝族回族自治县", "其他"]
  }, {
    "name": "楚雄彝族自治州",
    "area": ["楚雄市", "双柏县", "牟定县", "南华县", "姚安县", "大姚县", "永仁县", "元谋县", "武定县", "禄丰县", "其他"]
  }, {
    "name": "红河哈尼族彝族自治州",
    "area": ["蒙自县", "个旧市", "开远市", "绿春县", "建水县", "石屏县", "弥勒县", "泸西县", "元阳县", "红河县", "金平苗族瑶族傣族自治县", "河口瑶族自治县", "屏边苗族自治县", "其他"]
  }, {
    "name": "文山壮族苗族自治州",
    "area": ["文山县", "砚山县", "西畴县", "麻栗坡县", "马关县", "丘北县", "广南县", "富宁县", "其他"]
  }, {"name": "西双版纳傣族自治州", "area": ["景洪市", "勐海县", "勐腊县", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "yunnan"
}, {
  "name": "西藏",
  "city": [{"name": "拉萨", "area": ["城关区", "林周县", "当雄县", "尼木县", "曲水县", "堆龙德庆县", "达孜县", "墨竹工卡县", "其他"]}, {
    "name": "那曲地区",
    "area": ["那曲县", "嘉黎县", "比如县", "聂荣县", "安多县", "申扎县", "索县", "班戈县", "巴青县", "尼玛县", "其他"]
  }, {
    "name": "昌都地区",
    "area": ["昌都县", "江达县", "贡觉县", "类乌齐县", "丁青县", "察雅县", "八宿县", "左贡县", "芒康县", "洛隆县", "边坝县", "其他"]
  }, {"name": "林芝地区", "area": ["林芝县", "工布江达县", "米林县", "墨脱县", "波密县", "察隅县", "朗县", "其他"]}, {
    "name": "山南地区",
    "area": ["乃东县", "扎囊县", "贡嘎县", "桑日县", "琼结县", "曲松县", "措美县", "洛扎县", "加查县", "隆子县", "错那县", "浪卡子县", "其他"]
  }, {
    "name": "日喀则地区",
    "area": ["日喀则市", "南木林县", "江孜县", "定日县", "萨迦县", "拉孜县", "昂仁县", "谢通门县", "白朗县", "仁布县", "康马县", "定结县", "仲巴县", "亚东县", "吉隆县", "聂拉木县", "萨嘎县", "岗巴县", "其他"]
  }, {"name": "阿里地区", "area": ["噶尔县", "普兰县", "札达县", "日土县", "革吉县", "改则县", "措勤县", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "xizang"
}, {
  "name": "陕西",
  "city": [{
    "name": "西安",
    "area": ["莲湖区", "新城区", "碑林区", "雁塔区", "灞桥区", "未央区", "阎良区", "临潼区", "长安区", "高陵县", "蓝田县", "户县", "周至县", "其他"]
  }, {"name": "铜川", "area": ["耀州区", "王益区", "印台区", "宜君县", "其他"]}, {
    "name": "宝鸡",
    "area": ["渭滨区", "金台区", "陈仓区", "岐山县", "凤翔县", "陇县", "太白县", "麟游县", "扶风县", "千阳县", "眉县", "凤县", "其他"]
  }, {
    "name": "咸阳",
    "area": ["秦都区", "渭城区", "杨陵区", "兴平市", "礼泉县", "泾阳县", "永寿县", "三原县", "彬县", "旬邑县", "长武县", "乾县", "武功县", "淳化县", "其他"]
  }, {
    "name": "渭南",
    "area": ["临渭区", "韩城市", "华阴市", "蒲城县", "潼关县", "白水县", "澄城县", "华县", "合阳县", "富平县", "大荔县", "其他"]
  }, {
    "name": "延安",
    "area": ["宝塔区", "安塞县", "洛川县", "子长县", "黄陵县", "延川县", "富县", "延长县", "甘泉县", "宜川县", "志丹县", "黄龙县", "吴起县", "其他"]
  }, {
    "name": "汉中",
    "area": ["汉台区", "留坝县", "镇巴县", "城固县", "南郑县", "洋县", "宁强县", "佛坪县", "勉县", "西乡县", "略阳县", "其他"]
  }, {
    "name": "榆林",
    "area": ["榆阳区", "清涧县", "绥德县", "神木县", "佳县", "府谷县", "子洲县", "靖边县", "横山县", "米脂县", "吴堡县", "定边县", "其他"]
  }, {
    "name": "安康",
    "area": ["汉滨区", "紫阳县", "岚皋县", "旬阳县", "镇坪县", "平利县", "石泉县", "宁陕县", "白河县", "汉阴县", "其他"]
  }, {"name": "商洛", "area": ["商州区", "镇安县", "山阳县", "洛南县", "商南县", "丹凤县", "柞水县", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "shanxi1"
}, {
  "name": "甘肃",
  "city": [{"name": "兰州", "area": ["城关区", "七里河区", "西固区", "安宁区", "红古区", "永登县", "皋兰县", "榆中县", "其他"]}, {
    "name": "嘉峪关",
    "area": ["嘉峪关市", "其他"]
  }, {"name": "金昌", "area": ["金川区", "永昌县", "其他"]}, {
    "name": "白银",
    "area": ["白银区", "平川区", "靖远县", "会宁县", "景泰县", "其他"]
  }, {"name": "天水", "area": ["清水县", "秦安县", "甘谷县", "武山县", "张家川回族自治县", "北道区", "秦城区", "其他"]}, {
    "name": "武威",
    "area": ["凉州区", "民勤县", "古浪县", "天祝藏族自治县", "其他"]
  }, {"name": "酒泉", "area": ["肃州区", "玉门市", "敦煌市", "金塔县", "肃北蒙古族自治县", "阿克塞哈萨克族自治县", "安西县", "其他"]}, {
    "name": "张掖",
    "area": ["甘州区", "民乐县", "临泽县", "高台县", "山丹县", "肃南裕固族自治县", "其他"]
  }, {"name": "庆阳", "area": ["西峰区", "庆城县", "环县", "华池县", "合水县", "正宁县", "宁县", "镇原县", "其他"]}, {
    "name": "平凉",
    "area": ["崆峒区", "泾川县", "灵台县", "崇信县", "华亭县", "庄浪县", "静宁县", "其他"]
  }, {"name": "定西", "area": ["安定区", "通渭县", "临洮县", "漳县", "岷县", "渭源县", "陇西县", "其他"]}, {
    "name": "陇南",
    "area": ["武都区", "成县", "宕昌县", "康县", "文县", "西和县", "礼县", "两当县", "徽县", "其他"]
  }, {
    "name": "临夏回族自治州",
    "area": ["临夏市", "临夏县", "康乐县", "永靖县", "广河县", "和政县", "东乡族自治县", "积石山保安族东乡族撒拉族自治县", "其他"]
  }, {"name": "甘南藏族自治州", "area": ["合作市", "临潭县", "卓尼县", "舟曲县", "迭部县", "玛曲县", "碌曲县", "夏河县", "其他"]}, {
    "name": "其他",
    "area": ["其他"]
  }],
  "json": "gansu"
}, {
  "name": "青海",
  "city": [{"name": "西宁", "area": ["城中区", "城东区", "城西区", "城北区", "湟源县", "湟中县", "大通回族土族自治县", "其他"]}, {
    "name": "海东地区",
    "area": ["平安县", "乐都县", "民和回族土族自治县", "互助土族自治县", "化隆回族自治县", "循化撒拉族自治县", "其他"]
  }, {"name": "海北藏族自治州", "area": ["海晏县", "祁连县", "刚察县", "门源回族自治县", "其他"]}, {
    "name": "海南藏族自治州",
    "area": ["共和县", "同德县", "贵德县", "兴海县", "贵南县", "其他"]
  }, {"name": "黄南藏族自治州", "area": ["同仁县", "尖扎县", "泽库县", "河南蒙古族自治县", "其他"]}, {
    "name": "果洛藏族自治州",
    "area": ["玛沁县", "班玛县", "甘德县", "达日县", "久治县", "玛多县", "其他"]
  }, {"name": "玉树藏族自治州", "area": ["玉树县", "杂多县", "称多县", "治多县", "囊谦县", "曲麻莱县", "其他"]}, {
    "name": "海西蒙古族藏族自治州",
    "area": ["德令哈市", "格尔木市", "乌兰县", "都兰县", "天峻县", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "qinghai"
}, {
  "name": "宁夏",
  "city": [{"name": "银川", "area": ["兴庆区", "西夏区", "金凤区", "灵武市", "永宁县", "贺兰县", "其他"]}, {
    "name": "石嘴山",
    "area": ["大武口区", "惠农区", "平罗县", "其他"]
  }, {"name": "吴忠", "area": ["利通区", "青铜峡市", "盐池县", "同心县", "其他"]}, {
    "name": "固原",
    "area": ["原州区", "西吉县", "隆德县", "泾源县", "彭阳县", "其他"]
  }, {"name": "中卫", "area": ["沙坡头区", "中宁县", "海原县", "其他"]}, {"name": "其他", "area": ["其他"]}],
  "json": "ningxia"
}, {
  "name": "新疆",
  "city": [{
    "name": "乌鲁木齐",
    "area": ["天山区", "沙依巴克区", "新市区", "水磨沟区", "头屯河区", "达坂城区", "东山区", "乌鲁木齐县", "其他"]
  }, {"name": "克拉玛依", "area": ["克拉玛依区", "独山子区", "白碱滩区", "乌尔禾区", "其他"]}, {
    "name": "吐鲁番地区",
    "area": ["吐鲁番市", "托克逊县", "鄯善县", "其他"]
  }, {"name": "哈密地区", "area": ["哈密市", "伊吾县", "巴里坤哈萨克自治县", "其他"]}, {
    "name": "和田地区",
    "area": ["和田市", "和田县", "洛浦县", "民丰县", "皮山县", "策勒县", "于田县", "墨玉县", "其他"]
  }, {
    "name": "阿克苏地区",
    "area": ["阿克苏市", "温宿县", "沙雅县", "拜城县", "阿瓦提县", "库车县", "柯坪县", "新和县", "乌什县", "其他"]
  }, {
    "name": "喀什地区",
    "area": ["喀什市", "巴楚县", "泽普县", "伽师县", "叶城县", "岳普湖县", "疏勒县", "麦盖提县", "英吉沙县", "莎车县", "疏附县", "塔什库尔干塔吉克自治县", "其他"]
  }, {"name": "克孜勒苏柯尔克孜自治州", "area": ["阿图什市", "阿合奇县", "乌恰县", "阿克陶县", "其他"]}, {
    "name": "巴音郭楞蒙古自治州",
    "area": ["库尔勒市", "和静县", "尉犁县", "和硕县", "且末县", "博湖县", "轮台县", "若羌县", "焉耆回族自治县", "其他"]
  }, {
    "name": "昌吉回族自治州",
    "area": ["昌吉市", "阜康市", "奇台县", "玛纳斯县", "吉木萨尔县", "呼图壁县", "木垒哈萨克自治县", "米泉市", "其他"]
  }, {"name": "博尔塔拉蒙古自治州", "area": ["博乐市", "精河县", "温泉县", "其他"]}, {"name": "石河子", "area": ["石河子"]}, {
    "name": "阿拉尔",
    "area": ["阿拉尔"]
  }, {"name": "图木舒克", "area": ["图木舒克"]}, {"name": "五家渠", "area": ["五家渠"]}, {
    "name": "伊犁哈萨克自治州",
    "area": ["伊宁市", "奎屯市", "伊宁县", "特克斯县", "尼勒克县", "昭苏县", "新源县", "霍城县", "巩留县", "察布查尔锡伯自治县", "塔城地区", "阿勒泰地区", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "xinjiang"
}, {
  "name": "台湾",
  "city": [{
    "name": "台湾",
    "area": ["台北市", "高雄市", "台北县", "桃园县", "新竹县", "苗栗县", "台中县", "彰化县", "南投县", "云林县", "嘉义县", "台南县", "高雄县", "屏东县", "宜兰县", "花莲县", "台东县", "澎湖县", "基隆市", "新竹市", "台中市", "嘉义市", "台南市", "其他"]
  }, {"name": "其他", "area": ["其他"]}],
  "json": "taiwan"
}, {
  "name": "澳门",
  "city": [{"name": "澳门", "area": ["花地玛堂区", "圣安多尼堂区", "大堂区", "望德堂区", "风顺堂区", "嘉模堂区", "圣方济各堂区", "路凼", "其他"]}],
  "json": "aomen"
}, {
  "name": "香港",
  "city": [{
    "name": "香港",
    "area": ["中西区", "湾仔区", "东区", "南区", "深水埗区", "油尖旺区", "九龙城区", "黄大仙区", "观塘区", "北区", "大埔区", "沙田区", "西贡区", "元朗区", "屯门区", "荃湾区", "葵青区", "离岛区", "其他"]
  }],
  "json": "xianggang"
  }]
let zipCode = [{
	"id": 2,
	"name": "北京",
	"child": [{
		"id": 36,
		"name": "北京市",
		"child": [{
			"id": 377,
			"name": "东城区",
			"zipcode": "100011"
		}, {
			"id": 378,
			"name": "西城区",
			"zipcode": "100032"
		}, {
			"id": 379,
			"name": "崇文区",
			"zipcode": "100061"
		}, {
			"id": 380,
			"name": "宣武区",
			"zipcode": "100054"
		}, {
			"id": 381,
			"name": "朝阳区",
			"zipcode": "100020"
		}, {
			"id": 382,
			"name": "丰台区",
			"zipcode": "100071"
		}, {
			"id": 383,
			"name": "石景山区",
			"zipcode": "100043"
		}, {
			"id": 384,
			"name": "海淀区",
			"zipcode": "100089"
		}, {
			"id": 385,
			"name": "门头沟区",
			"zipcode": "102300"
		}, {
			"id": 386,
			"name": "房山区",
			"zipcode": "102488"
		}, {
			"id": 387,
			"name": "通州区",
			"zipcode": "101100"
		}, {
			"id": 388,
			"name": "顺义区",
			"zipcode": "101300"
		}, {
			"id": 389,
			"name": "昌平区",
			"zipcode": "102200"
		}, {
			"id": 390,
			"name": "大兴区",
			"zipcode": "102600"
		}, {
			"id": 391,
			"name": "怀柔区",
			"zipcode": "101400"
		}, {
			"id": 392,
			"name": "平谷区",
			"zipcode": "101200"
		}, {
			"id": 393,
			"name": "密云县",
			"zipcode": "101500"
		}, {
			"id": 394,
			"name": "延庆县",
			"zipcode": "102100"
		}]
	}]
}, {
	"id": 3,
	"name": "天津",
	"child": [{
		"id": 37,
		"name": "天津市",
		"child": [{
			"id": 395,
			"name": "和平区",
			"zipcode": "300041"
		}, {
			"id": 396,
			"name": "河东区",
			"zipcode": "300171"
		}, {
			"id": 397,
			"name": "河西区",
			"zipcode": "300202"
		}, {
			"id": 398,
			"name": "南开区",
			"zipcode": "300100"
		}, {
			"id": 399,
			"name": "河北区",
			"zipcode": "300143"
		}, {
			"id": 400,
			"name": "红桥区",
			"zipcode": "300131"
		}, {
			"id": 401,
			"name": "塘沽区",
			"zipcode": "300450"
		}, {
			"id": 402,
			"name": "汉沽区",
			"zipcode": "300480"
		}, {
			"id": 403,
			"name": "大港区",
			"zipcode": "300270"
		}, {
			"id": 404,
			"name": "东丽区",
			"zipcode": "300300"
		}, {
			"id": 405,
			"name": "西青区",
			"zipcode": "300380"
		}, {
			"id": 406,
			"name": "津南区",
			"zipcode": "300350"
		}, {
			"id": 407,
			"name": "北辰区",
			"zipcode": "300400"
		}, {
			"id": 408,
			"name": "武清区",
			"zipcode": "301700"
		}, {
			"id": 409,
			"name": "宝坻区",
			"zipcode": "301800"
		}, {
			"id": 410,
			"name": "宁河县",
			"zipcode": "301500"
		}, {
			"id": 411,
			"name": "静海县",
			"zipcode": "301600"
		}, {
			"id": 412,
			"name": "蓟县",
			"zipcode": "301900"
		}, {
			"id": 413,
			"name": "保税区",
			"zipcode": "300308"
		}, {
			"id": 414,
			"name": "经济技术开发区",
			"zipcode": "300457"
		}, {
			"id": 415,
			"name": "高新区",
			"zipcode": "300384"
		}, {
			"id": 416,
			"name": "滨海新区",
			"zipcode": "300457"
		}]
	}]
}, {
	"id": 4,
	"name": "河北",
	"child": [{
		"id": 38,
		"name": "石家庄市",
		"child": [{
			"id": 417,
			"name": "长安区",
			"zipcode": "050011"
		}, {
			"id": 418,
			"name": "桥东区",
			"zipcode": "050011"
		}, {
			"id": 419,
			"name": "桥西区",
			"zipcode": "050051"
		}, {
			"id": 420,
			"name": "新华区",
			"zipcode": "050051"
		}, {
			"id": 421,
			"name": "井陉矿区",
			"zipcode": "050100"
		}, {
			"id": 422,
			"name": "裕华区",
			"zipcode": "050081"
		}, {
			"id": 423,
			"name": "井陉县",
			"zipcode": "050300"
		}, {
			"id": 424,
			"name": "正定县",
			"zipcode": "050800"
		}, {
			"id": 425,
			"name": "栾城县",
			"zipcode": "051430"
		}, {
			"id": 426,
			"name": "行唐县",
			"zipcode": "050600"
		}, {
			"id": 427,
			"name": "灵寿县",
			"zipcode": "050500"
		}, {
			"id": 428,
			"name": "高邑县",
			"zipcode": "051330"
		}, {
			"id": 429,
			"name": "深泽县",
			"zipcode": "052560"
		}, {
			"id": 430,
			"name": "赞皇县",
			"zipcode": "051230"
		}, {
			"id": 431,
			"name": "无极县",
			"zipcode": "052400"
		}, {
			"id": 432,
			"name": "平山县",
			"zipcode": "050400"
		}, {
			"id": 433,
			"name": "元氏县",
			"zipcode": "051130"
		}, {
			"id": 434,
			"name": "赵县",
			"zipcode": "051530"
		}, {
			"id": 435,
			"name": "辛集市",
			"zipcode": "052300"
		}, {
			"id": 436,
			"name": "藁城市",
			"zipcode": "052160"
		}, {
			"id": 437,
			"name": "晋州市",
			"zipcode": "052200"
		}, {
			"id": 438,
			"name": "新乐市",
			"zipcode": "050700"
		}, {
			"id": 439,
			"name": "鹿泉市",
			"zipcode": "050200"
		}, {
			"id": 440,
			"name": "高新技术开发区",
			"zipcode": "050035"
		}]
	}, {
		"id": 39,
		"name": "唐山市",
		"child": [{
			"id": 441,
			"name": "路南区",
			"zipcode": "063017"
		}, {
			"id": 442,
			"name": "路北区",
			"zipcode": "063015"
		}, {
			"id": 443,
			"name": "古冶区",
			"zipcode": "063104"
		}, {
			"id": 444,
			"name": "开平区",
			"zipcode": "063021"
		}, {
			"id": 445,
			"name": "丰南区",
			"zipcode": "063300"
		}, {
			"id": 446,
			"name": "丰润区",
			"zipcode": "064000"
		}, {
			"id": 447,
			"name": "滦县",
			"zipcode": "063700"
		}, {
			"id": 448,
			"name": "滦南县",
			"zipcode": "063500"
		}, {
			"id": 449,
			"name": "乐亭县",
			"zipcode": "063600"
		}, {
			"id": 450,
			"name": "迁西县",
			"zipcode": "064300"
		}, {
			"id": 451,
			"name": "玉田县",
			"zipcode": "064100"
		}, {
			"id": 452,
			"name": "唐海县",
			"zipcode": "063200"
		}, {
			"id": 453,
			"name": "遵化市",
			"zipcode": "064200"
		}, {
			"id": 454,
			"name": "迁安市",
			"zipcode": "064400"
		}, {
			"id": 455,
			"name": "高新区",
			"zipcode": "063020"
		}, {
			"id": 456,
			"name": "汉沽管理区",
			"zipcode": "301501"
		}, {
			"id": 457,
			"name": "海港开发区",
			"zipcode": "063600"
		}, {
			"id": 458,
			"name": "芦台开发区",
			"zipcode": "301501"
		}, {
			"id": 459,
			"name": "南堡开发区",
			"zipcode": "063305"
		}, {
			"id": 460,
			"name": "曹妃甸工业区",
			"zipcode": "063200"
		}]
	}, {
		"id": 40,
		"name": "秦皇岛市",
		"child": [{
			"id": 461,
			"name": "海港区",
			"zipcode": "066000"
		}, {
			"id": 462,
			"name": "山海关区",
			"zipcode": "066200"
		}, {
			"id": 463,
			"name": "北戴河区",
			"zipcode": "066100"
		}, {
			"id": 464,
			"name": "青龙满族自治县",
			"zipcode": "066500"
		}, {
			"id": 465,
			"name": "昌黎县",
			"zipcode": "066600"
		}, {
			"id": 466,
			"name": "抚宁县",
			"zipcode": "066300"
		}, {
			"id": 467,
			"name": "卢龙县",
			"zipcode": "066400"
		}, {
			"id": 468,
			"name": "经济技术开发区",
			"zipcode": "066004"
		}]
	}, {
		"id": 41,
		"name": "邯郸市",
		"child": [{
			"id": 469,
			"name": "邯山区",
			"zipcode": "056001"
		}, {
			"id": 470,
			"name": "丛台区",
			"zipcode": "056004"
		}, {
			"id": 471,
			"name": "复兴区",
			"zipcode": "056003"
		}, {
			"id": 472,
			"name": "峰峰矿区",
			"zipcode": "056200"
		}, {
			"id": 473,
			"name": "邯郸县",
			"zipcode": "056100"
		}, {
			"id": 474,
			"name": "临漳县",
			"zipcode": "056600"
		}, {
			"id": 475,
			"name": "成安县",
			"zipcode": "056700"
		}, {
			"id": 476,
			"name": "大名县",
			"zipcode": "056900"
		}, {
			"id": 477,
			"name": "涉县",
			"zipcode": "056400"
		}, {
			"id": 478,
			"name": "磁县",
			"zipcode": "056500"
		}, {
			"id": 479,
			"name": "肥乡县",
			"zipcode": "057550"
		}, {
			"id": 480,
			"name": "永年县",
			"zipcode": "057150"
		}, {
			"id": 481,
			"name": "邱县",
			"zipcode": "057450"
		}, {
			"id": 482,
			"name": "鸡泽县",
			"zipcode": "057350"
		}, {
			"id": 483,
			"name": "广平县",
			"zipcode": "057650"
		}, {
			"id": 484,
			"name": "馆陶县",
			"zipcode": "057750"
		}, {
			"id": 485,
			"name": "魏县",
			"zipcode": "056800"
		}, {
			"id": 486,
			"name": "曲周县",
			"zipcode": "057250"
		}, {
			"id": 487,
			"name": "武安市",
			"zipcode": "056300"
		}, {
			"id": 488,
			"name": "经济开发区",
			"zipcode": "056002"
		}]
	}, {
		"id": 42,
		"name": "邢台市",
		"child": [{
			"id": 489,
			"name": "桥东区",
			"zipcode": "054001"
		}, {
			"id": 490,
			"name": "桥西区",
			"zipcode": "054000"
		}, {
			"id": 491,
			"name": "邢台县",
			"zipcode": "054001"
		}, {
			"id": 492,
			"name": "临城县",
			"zipcode": "054300"
		}, {
			"id": 493,
			"name": "内丘县",
			"zipcode": "054200"
		}, {
			"id": 494,
			"name": "柏乡县",
			"zipcode": "055450"
		}, {
			"id": 495,
			"name": "隆尧县",
			"zipcode": "055350"
		}, {
			"id": 496,
			"name": "任县",
			"zipcode": "055150"
		}, {
			"id": 497,
			"name": "南和县",
			"zipcode": "054400"
		}, {
			"id": 498,
			"name": "宁晋县",
			"zipcode": "055550"
		}, {
			"id": 499,
			"name": "巨鹿县",
			"zipcode": "055250"
		}, {
			"id": 500,
			"name": "新河县",
			"zipcode": "051730"
		}, {
			"id": 501,
			"name": "广宗县",
			"zipcode": "054600"
		}, {
			"id": 502,
			"name": "平乡县",
			"zipcode": "054500"
		}, {
			"id": 503,
			"name": "威县",
			"zipcode": "054700"
		}, {
			"id": 504,
			"name": "清河县",
			"zipcode": "054800"
		}, {
			"id": 505,
			"name": "临西县",
			"zipcode": "054900"
		}, {
			"id": 506,
			"name": "南宫市",
			"zipcode": "055750"
		}, {
			"id": 507,
			"name": "沙河市",
			"zipcode": "054100"
		}]
	}, {
		"id": 43,
		"name": "保定市",
		"child": [{
			"id": 509,
			"name": "新市区",
			"zipcode": "071052"
		}, {
			"id": 510,
			"name": "南市区",
			"zipcode": "071000"
		}, {
			"id": 511,
			"name": "北市区",
			"zipcode": "071000"
		}, {
			"id": 512,
			"name": "满城县",
			"zipcode": "072150"
		}, {
			"id": 513,
			"name": "清苑县",
			"zipcode": "071100"
		}, {
			"id": 514,
			"name": "涞水县",
			"zipcode": "074100"
		}, {
			"id": 515,
			"name": "阜平县",
			"zipcode": "073200"
		}, {
			"id": 516,
			"name": "徐水县",
			"zipcode": "072550"
		}, {
			"id": 517,
			"name": "定兴县",
			"zipcode": "072650"
		}, {
			"id": 518,
			"name": "唐县",
			"zipcode": "072350"
		}, {
			"id": 519,
			"name": "高阳县",
			"zipcode": "071500"
		}, {
			"id": 520,
			"name": "容城县",
			"zipcode": "071700"
		}, {
			"id": 521,
			"name": "涞源县",
			"zipcode": "074300"
		}, {
			"id": 522,
			"name": "望都县",
			"zipcode": "072450"
		}, {
			"id": 523,
			"name": "安新县",
			"zipcode": "071600"
		}, {
			"id": 524,
			"name": "易县",
			"zipcode": "074200"
		}, {
			"id": 525,
			"name": "曲阳县",
			"zipcode": "073100"
		}, {
			"id": 526,
			"name": "蠡县",
			"zipcode": "071400"
		}, {
			"id": 527,
			"name": "顺平县",
			"zipcode": "072250"
		}, {
			"id": 528,
			"name": "博野县",
			"zipcode": "071300"
		}, {
			"id": 529,
			"name": "雄县",
			"zipcode": "071800"
		}, {
			"id": 530,
			"name": "涿州市",
			"zipcode": "072750"
		}, {
			"id": 531,
			"name": "定州市",
			"zipcode": "073000"
		}, {
			"id": 532,
			"name": "安国市",
			"zipcode": "071200"
		}, {
			"id": 533,
			"name": "高碑店市",
			"zipcode": "074000"
		}]
	}, {
		"id": 44,
		"name": "张家口市",
		"child": [{
			"id": 534,
			"name": "桥东区",
			"zipcode": "075000"
		}, {
			"id": 535,
			"name": "桥西区",
			"zipcode": "075061"
		}, {
			"id": 536,
			"name": "宣化区",
			"zipcode": "075100"
		}, {
			"id": 537,
			"name": "下花园区",
			"zipcode": "075300"
		}, {
			"id": 538,
			"name": "宣化县",
			"zipcode": "075100"
		}, {
			"id": 539,
			"name": "张北县",
			"zipcode": "076450"
		}, {
			"id": 540,
			"name": "康保县",
			"zipcode": "076650"
		}, {
			"id": 541,
			"name": "沽源县",
			"zipcode": "076550"
		}, {
			"id": 542,
			"name": "尚义县",
			"zipcode": "076750"
		}, {
			"id": 543,
			"name": "蔚县",
			"zipcode": "075700"
		}, {
			"id": 544,
			"name": "阳原县",
			"zipcode": "075800"
		}, {
			"id": 545,
			"name": "怀安县",
			"zipcode": "076150"
		}, {
			"id": 546,
			"name": "万全县",
			"zipcode": "076250"
		}, {
			"id": 547,
			"name": "怀来县",
			"zipcode": "075400"
		}, {
			"id": 548,
			"name": "涿鹿县",
			"zipcode": "075600"
		}, {
			"id": 549,
			"name": "赤城县",
			"zipcode": "075500"
		}, {
			"id": 550,
			"name": "崇礼县",
			"zipcode": "076350"
		}]
	}, {
		"id": 45,
		"name": "承德市",
		"child": [{
			"id": 551,
			"name": "双桥区",
			"zipcode": "067000"
		}, {
			"id": 552,
			"name": "双滦区",
			"zipcode": "067000"
		}, {
			"id": 553,
			"name": "鹰手营子矿区",
			"zipcode": "067200"
		}, {
			"id": 554,
			"name": "承德县",
			"zipcode": "067400"
		}, {
			"id": 555,
			"name": "兴隆县",
			"zipcode": "067300"
		}, {
			"id": 556,
			"name": "平泉县",
			"zipcode": "067500"
		}, {
			"id": 557,
			"name": "滦平县",
			"zipcode": "068250"
		}, {
			"id": 558,
			"name": "隆化县",
			"zipcode": "068150"
		}, {
			"id": 559,
			"name": "丰宁满族自治县",
			"zipcode": "068350"
		}, {
			"id": 560,
			"name": "宽城满族自治县",
			"zipcode": "067600"
		}, {
			"id": 561,
			"name": "围场满族蒙古族自治县",
			"zipcode": "068450"
		}]
	}, {
		"id": 46,
		"name": "沧州市",
		"child": [{
			"id": 562,
			"name": "新华区",
			"zipcode": "061000"
		}, {
			"id": 563,
			"name": "运河区",
			"zipcode": "061000"
		}, {
			"id": 564,
			"name": "沧县",
			"zipcode": "061000"
		}, {
			"id": 565,
			"name": "青县",
			"zipcode": "062650"
		}, {
			"id": 566,
			"name": "东光县",
			"zipcode": "061600"
		}, {
			"id": 567,
			"name": "海兴县",
			"zipcode": "061200"
		}, {
			"id": 568,
			"name": "盐山县",
			"zipcode": "061300"
		}, {
			"id": 569,
			"name": "肃宁县",
			"zipcode": "062350"
		}, {
			"id": 570,
			"name": "南皮县",
			"zipcode": "061500"
		}, {
			"id": 571,
			"name": "吴桥县",
			"zipcode": "061800"
		}, {
			"id": 572,
			"name": "献县",
			"zipcode": "062250"
		}, {
			"id": 573,
			"name": "孟村回族自治县",
			"zipcode": "061400"
		}, {
			"id": 574,
			"name": "泊头市",
			"zipcode": "062150"
		}, {
			"id": 575,
			"name": "任丘市",
			"zipcode": "062550"
		}, {
			"id": 576,
			"name": "黄骅市",
			"zipcode": "061100"
		}, {
			"id": 577,
			"name": "河间市",
			"zipcode": "062450"
		}]
	}, {
		"id": 47,
		"name": "廊坊市",
		"child": [{
			"id": 578,
			"name": "安次区",
			"zipcode": "065000"
		}, {
			"id": 579,
			"name": "广阳区",
			"zipcode": "065000"
		}, {
			"id": 580,
			"name": "固安县",
			"zipcode": "065500"
		}, {
			"id": 581,
			"name": "永清县",
			"zipcode": "065600"
		}, {
			"id": 582,
			"name": "香河县",
			"zipcode": "065400"
		}, {
			"id": 583,
			"name": "大城县",
			"zipcode": "065900"
		}, {
			"id": 584,
			"name": "文安县",
			"zipcode": "065800"
		}, {
			"id": 585,
			"name": "大厂回族自治县",
			"zipcode": "065300"
		}, {
			"id": 586,
			"name": "霸州市",
			"zipcode": "065700"
		}, {
			"id": 587,
			"name": "三河市",
			"zipcode": "065200"
		}, {
			"id": 588,
			"name": "开发区",
			"zipcode": "065001"
		}]
	}, {
		"id": 48,
		"name": "衡水市",
		"child": [{
			"id": 589,
			"name": "桃城区",
			"zipcode": "053000"
		}, {
			"id": 590,
			"name": "枣强县",
			"zipcode": "053100"
		}, {
			"id": 591,
			"name": "武邑县",
			"zipcode": "053400"
		}, {
			"id": 592,
			"name": "武强县",
			"zipcode": "053300"
		}, {
			"id": 593,
			"name": "饶阳县",
			"zipcode": "053900"
		}, {
			"id": 594,
			"name": "安平县",
			"zipcode": "053600"
		}, {
			"id": 595,
			"name": "故城县",
			"zipcode": "253800"
		}, {
			"id": 596,
			"name": "景县",
			"zipcode": "053500"
		}, {
			"id": 597,
			"name": "阜城县",
			"zipcode": "053700"
		}, {
			"id": 598,
			"name": "冀州市",
			"zipcode": "053200"
		}, {
			"id": 599,
			"name": "深州市",
			"zipcode": "053800"
		}]
	}]
}, {
	"id": 5,
	"name": "山西",
	"child": [{
		"id": 49,
		"name": "太原市",
		"child": [{
			"id": 600,
			"name": "小店区",
			"zipcode": "030032"
		}, {
			"id": 601,
			"name": "迎泽区",
			"zipcode": "030024"
		}, {
			"id": 602,
			"name": "杏花岭区",
			"zipcode": "030001"
		}, {
			"id": 603,
			"name": "尖草坪区",
			"zipcode": "030003"
		}, {
			"id": 604,
			"name": "万柏林区",
			"zipcode": "030027"
		}, {
			"id": 605,
			"name": "晋源区",
			"zipcode": "030025"
		}, {
			"id": 606,
			"name": "清徐县",
			"zipcode": "030400"
		}, {
			"id": 607,
			"name": "阳曲县",
			"zipcode": "030100"
		}, {
			"id": 608,
			"name": "娄烦县",
			"zipcode": "030300"
		}, {
			"id": 609,
			"name": "古交市",
			"zipcode": "030200"
		}]
	}, {
		"id": 50,
		"name": "大同市",
		"child": [{
			"id": 610,
			"name": "城区",
			"zipcode": "037008"
		}, {
			"id": 611,
			"name": "矿区",
			"zipcode": "037001"
		}, {
			"id": 612,
			"name": "南郊区",
			"zipcode": "037001"
		}, {
			"id": 613,
			"name": "新荣区",
			"zipcode": "037002"
		}, {
			"id": 614,
			"name": "阳高县",
			"zipcode": "038100"
		}, {
			"id": 615,
			"name": "天镇县",
			"zipcode": "038200"
		}, {
			"id": 616,
			"name": "广灵县",
			"zipcode": "037500"
		}, {
			"id": 617,
			"name": "灵丘县",
			"zipcode": "034400"
		}, {
			"id": 618,
			"name": "浑源县",
			"zipcode": "037400"
		}, {
			"id": 619,
			"name": "左云县",
			"zipcode": "037100"
		}, {
			"id": 620,
			"name": "大同县",
			"zipcode": "037300"
		}]
	}, {
		"id": 51,
		"name": "阳泉市",
		"child": [{
			"id": 621,
			"name": "城区",
			"zipcode": "045000"
		}, {
			"id": 622,
			"name": "矿区",
			"zipcode": "045000"
		}, {
			"id": 623,
			"name": "郊区",
			"zipcode": "045011"
		}, {
			"id": 624,
			"name": "平定县",
			"zipcode": "045200"
		}, {
			"id": 625,
			"name": "盂县",
			"zipcode": "045100"
		}]
	}, {
		"id": 52,
		"name": "长治市",
		"child": [{
			"id": 626,
			"name": "城区",
			"zipcode": "046011"
		}, {
			"id": 627,
			"name": "郊区",
			"zipcode": "046011"
		}, {
			"id": 628,
			"name": "长治县",
			"zipcode": "047100"
		}, {
			"id": 629,
			"name": "襄垣县",
			"zipcode": "046200"
		}, {
			"id": 630,
			"name": "屯留县",
			"zipcode": "046100"
		}, {
			"id": 631,
			"name": "平顺县",
			"zipcode": "047400"
		}, {
			"id": 632,
			"name": "黎城县",
			"zipcode": "047600"
		}, {
			"id": 633,
			"name": "壶关县",
			"zipcode": "047300"
		}, {
			"id": 634,
			"name": "长子县",
			"zipcode": "046600"
		}, {
			"id": 635,
			"name": "武乡县",
			"zipcode": "046300"
		}, {
			"id": 636,
			"name": "沁县",
			"zipcode": "046400"
		}, {
			"id": 637,
			"name": "沁源县",
			"zipcode": "046500"
		}, {
			"id": 638,
			"name": "潞城市",
			"zipcode": "047500"
		}]
	}, {
		"id": 53,
		"name": "晋城市",
		"child": [{
			"id": 642,
			"name": "城区",
			"zipcode": "048000"
		}, {
			"id": 643,
			"name": "沁水县",
			"zipcode": "048200"
		}, {
			"id": 644,
			"name": "阳城县",
			"zipcode": "048100"
		}, {
			"id": 645,
			"name": "陵川县",
			"zipcode": "048300"
		}, {
			"id": 646,
			"name": "泽州县",
			"zipcode": "048012"
		}, {
			"id": 647,
			"name": "高平市",
			"zipcode": "048400"
		}]
	}, {
		"id": 54,
		"name": "朔州市",
		"child": [{
			"id": 648,
			"name": "朔城区",
			"zipcode": "038500"
		}, {
			"id": 649,
			"name": "平鲁区",
			"zipcode": "038600"
		}, {
			"id": 650,
			"name": "山阴县",
			"zipcode": "036900"
		}, {
			"id": 651,
			"name": "应县",
			"zipcode": "037600"
		}, {
			"id": 652,
			"name": "右玉县",
			"zipcode": "037200"
		}, {
			"id": 653,
			"name": "怀仁县",
			"zipcode": "038300"
		}]
	}, {
		"id": 55,
		"name": "晋中市",
		"child": [{
			"id": 654,
			"name": "榆次区",
			"zipcode": "030600"
		}, {
			"id": 655,
			"name": "榆社县",
			"zipcode": "031800"
		}, {
			"id": 656,
			"name": "左权县",
			"zipcode": "032600"
		}, {
			"id": 657,
			"name": "和顺县",
			"zipcode": "032700"
		}, {
			"id": 658,
			"name": "昔阳县",
			"zipcode": "045300"
		}, {
			"id": 659,
			"name": "寿阳县",
			"zipcode": "045400"
		}, {
			"id": 660,
			"name": "太谷县",
			"zipcode": "030800"
		}, {
			"id": 661,
			"name": "祁县",
			"zipcode": "030900"
		}, {
			"id": 662,
			"name": "平遥县",
			"zipcode": "031100"
		}, {
			"id": 663,
			"name": "灵石县",
			"zipcode": "031300"
		}, {
			"id": 664,
			"name": "介休市",
			"zipcode": "031200"
		}]
	}, {
		"id": 56,
		"name": "运城市",
		"child": [{
			"id": 665,
			"name": "盐湖区",
			"zipcode": "044000"
		}, {
			"id": 666,
			"name": "临猗县",
			"zipcode": "044100"
		}, {
			"id": 667,
			"name": "万荣县",
			"zipcode": "044200"
		}, {
			"id": 668,
			"name": "闻喜县",
			"zipcode": "043800"
		}, {
			"id": 669,
			"name": "稷山县",
			"zipcode": "043200"
		}, {
			"id": 670,
			"name": "新绛县",
			"zipcode": "043100"
		}, {
			"id": 671,
			"name": "绛县",
			"zipcode": "043600"
		}, {
			"id": 672,
			"name": "垣曲县",
			"zipcode": "043700"
		}, {
			"id": 673,
			"name": "夏县",
			"zipcode": "044400"
		}, {
			"id": 674,
			"name": "平陆县",
			"zipcode": "044300"
		}, {
			"id": 675,
			"name": "芮城县",
			"zipcode": "044600"
		}, {
			"id": 676,
			"name": "永济市",
			"zipcode": "044500"
		}, {
			"id": 677,
			"name": "河津市",
			"zipcode": "043300"
		}]
	}, {
		"id": 57,
		"name": "忻州市",
		"child": [{
			"id": 678,
			"name": "忻府区",
			"zipcode": "034000"
		}, {
			"id": 679,
			"name": "定襄县",
			"zipcode": "035400"
		}, {
			"id": 680,
			"name": "五台县",
			"zipcode": "035500"
		}, {
			"id": 681,
			"name": "代县",
			"zipcode": "034200"
		}, {
			"id": 682,
			"name": "繁峙县",
			"zipcode": "034300"
		}, {
			"id": 683,
			"name": "宁武县",
			"zipcode": "036700"
		}, {
			"id": 684,
			"name": "静乐县",
			"zipcode": "035100"
		}, {
			"id": 685,
			"name": "神池县",
			"zipcode": "036100"
		}, {
			"id": 686,
			"name": "五寨县",
			"zipcode": "036200"
		}, {
			"id": 687,
			"name": "岢岚县",
			"zipcode": "036300"
		}, {
			"id": 688,
			"name": "河曲县",
			"zipcode": "036500"
		}, {
			"id": 689,
			"name": "保德县",
			"zipcode": "036600"
		}, {
			"id": 690,
			"name": "偏关县",
			"zipcode": "036400"
		}, {
			"id": 691,
			"name": "原平市",
			"zipcode": "034100"
		}]
	}, {
		"id": 58,
		"name": "临汾市",
		"child": [{
			"id": 692,
			"name": "尧都区",
			"zipcode": "041000"
		}, {
			"id": 693,
			"name": "曲沃县",
			"zipcode": "043400"
		}, {
			"id": 694,
			"name": "翼城县",
			"zipcode": "043500"
		}, {
			"id": 695,
			"name": "襄汾县",
			"zipcode": "041500"
		}, {
			"id": 696,
			"name": "洪洞县",
			"zipcode": "031600"
		}, {
			"id": 697,
			"name": "古县",
			"zipcode": "042400"
		}, {
			"id": 698,
			"name": "安泽县",
			"zipcode": "042500"
		}, {
			"id": 699,
			"name": "浮山县",
			"zipcode": "042600"
		}, {
			"id": 700,
			"name": "吉县",
			"zipcode": "042200"
		}, {
			"id": 701,
			"name": "乡宁县",
			"zipcode": "042100"
		}, {
			"id": 702,
			"name": "大宁县",
			"zipcode": "042300"
		}, {
			"id": 703,
			"name": "隰县",
			"zipcode": "041300"
		}, {
			"id": 704,
			"name": "永和县",
			"zipcode": "041400"
		}, {
			"id": 705,
			"name": "蒲县",
			"zipcode": "041200"
		}, {
			"id": 706,
			"name": "汾西县",
			"zipcode": "031500"
		}, {
			"id": 707,
			"name": "侯马市",
			"zipcode": "043007"
		}, {
			"id": 708,
			"name": "霍州市",
			"zipcode": "031400"
		}]
	}, {
		"id": 59,
		"name": "吕梁市",
		"child": [{
			"id": 710,
			"name": "离石区",
			"zipcode": "033000"
		}, {
			"id": 711,
			"name": "文水县",
			"zipcode": "032100"
		}, {
			"id": 712,
			"name": "交城县",
			"zipcode": "030500"
		}, {
			"id": 713,
			"name": "兴县",
			"zipcode": "033600"
		}, {
			"id": 714,
			"name": "临县",
			"zipcode": "033200"
		}, {
			"id": 715,
			"name": "柳林县",
			"zipcode": "033300"
		}, {
			"id": 716,
			"name": "石楼县",
			"zipcode": "032500"
		}, {
			"id": 717,
			"name": "岚县",
			"zipcode": "033500"
		}, {
			"id": 718,
			"name": "方山县",
			"zipcode": "033100"
		}, {
			"id": 719,
			"name": "中阳县",
			"zipcode": "033400"
		}, {
			"id": 720,
			"name": "交口县",
			"zipcode": "032400"
		}, {
			"id": 721,
			"name": "孝义市",
			"zipcode": "032300"
		}, {
			"id": 722,
			"name": "汾阳市",
			"zipcode": "032200"
		}]
	}]
}, {
	"id": 6,
	"name": "内蒙古",
	"child": [{
		"id": 60,
		"name": "呼和浩特市",
		"child": [{
			"id": 723,
			"name": "回民区",
			"zipcode": "010030"
		}, {
			"id": 724,
			"name": "玉泉区",
			"zipcode": "010020"
		}, {
			"id": 725,
			"name": "新城区",
			"zipcode": "010030"
		}, {
			"id": 726,
			"name": "赛罕区",
			"zipcode": "010020"
		}, {
			"id": 727,
			"name": "土默特左旗",
			"zipcode": "010100"
		}, {
			"id": 728,
			"name": "托克托县",
			"zipcode": "010200"
		}, {
			"id": 729,
			"name": "和林格尔县",
			"zipcode": "011500"
		}, {
			"id": 730,
			"name": "清水河县",
			"zipcode": "011600"
		}, {
			"id": 731,
			"name": "武川县",
			"zipcode": "011700"
		}]
	}, {
		"id": 61,
		"name": "包头市",
		"child": [{
			"id": 733,
			"name": "东河区",
			"zipcode": "014040"
		}, {
			"id": 734,
			"name": "昆都仑区",
			"zipcode": "014010"
		}, {
			"id": 735,
			"name": "青山区",
			"zipcode": "014030"
		}, {
			"id": 736,
			"name": "石拐区",
			"zipcode": "014070"
		}, {
			"id": 737,
			"name": "白云矿区",
			"zipcode": "014080"
		}, {
			"id": 738,
			"name": "九原区",
			"zipcode": "014060"
		}, {
			"id": 739,
			"name": "土默特右旗",
			"zipcode": "014100"
		}, {
			"id": 740,
			"name": "固阳县",
			"zipcode": "014200"
		}, {
			"id": 741,
			"name": "达尔罕茂明安联合旗",
			"zipcode": "014500"
		}]
	}, {
		"id": 62,
		"name": "乌海市",
		"child": [{
			"id": 742,
			"name": "海勃湾区",
			"zipcode": "016000"
		}, {
			"id": 743,
			"name": "海南区",
			"zipcode": "016030"
		}, {
			"id": 744,
			"name": "乌达区",
			"zipcode": "016040"
		}]
	}, {
		"id": 63,
		"name": "赤峰市",
		"child": [{
			"id": 745,
			"name": "红山区",
			"zipcode": "024020"
		}, {
			"id": 746,
			"name": "元宝山区",
			"zipcode": "024076"
		}, {
			"id": 747,
			"name": "松山区",
			"zipcode": "024005"
		}, {
			"id": 748,
			"name": "阿鲁科尔沁旗",
			"zipcode": "025550"
		}, {
			"id": 749,
			"name": "巴林左旗",
			"zipcode": "025450"
		}, {
			"id": 750,
			"name": "巴林右旗",
			"zipcode": "025150"
		}, {
			"id": 751,
			"name": "林西县",
			"zipcode": "025250"
		}, {
			"id": 752,
			"name": "克什克腾旗",
			"zipcode": "025350"
		}, {
			"id": 753,
			"name": "翁牛特旗",
			"zipcode": "024500"
		}, {
			"id": 754,
			"name": "喀喇沁旗",
			"zipcode": "024400"
		}, {
			"id": 755,
			"name": "宁城县",
			"zipcode": "024200"
		}, {
			"id": 756,
			"name": "敖汉旗",
			"zipcode": "024300"
		}, {
			"id": 757,
			"name": "新城区",
			"zipcode": "025350"
		}]
	}, {
		"id": 64,
		"name": "通辽市",
		"child": [{
			"id": 758,
			"name": "科尔沁区",
			"zipcode": "028000"
		}, {
			"id": 759,
			"name": "科尔沁左翼中旗",
			"zipcode": "029300"
		}, {
			"id": 760,
			"name": "科尔沁左翼后旗",
			"zipcode": "028100"
		}, {
			"id": 761,
			"name": "开鲁县",
			"zipcode": "028400"
		}, {
			"id": 762,
			"name": "库伦旗",
			"zipcode": "028200"
		}, {
			"id": 763,
			"name": "奈曼旗",
			"zipcode": "028300"
		}, {
			"id": 764,
			"name": "扎鲁特旗",
			"zipcode": "029100"
		}, {
			"id": 765,
			"name": "霍林郭勒市",
			"zipcode": "029200"
		}]
	}, {
		"id": 65,
		"name": "鄂尔多斯市",
		"child": [{
			"id": 766,
			"name": "东胜区",
			"zipcode": "017000"
		}, {
			"id": 767,
			"name": "达拉特旗",
			"zipcode": "014300"
		}, {
			"id": 768,
			"name": "准格尔旗",
			"zipcode": "017100"
		}, {
			"id": 769,
			"name": "鄂托克前旗",
			"zipcode": "016200"
		}, {
			"id": 770,
			"name": "鄂托克旗",
			"zipcode": "016100"
		}, {
			"id": 771,
			"name": "杭锦旗",
			"zipcode": "017400"
		}, {
			"id": 772,
			"name": "乌审旗",
			"zipcode": "017300"
		}, {
			"id": 773,
			"name": "伊金霍洛旗",
			"zipcode": "017200"
		}]
	}, {
		"id": 66,
		"name": "呼伦贝尔市",
		"child": [{
			"id": 774,
			"name": "海拉尔区",
			"zipcode": "021000"
		}, {
			"id": 775,
			"name": "阿荣旗",
			"zipcode": "162750"
		}, {
			"id": 776,
			"name": "莫力达瓦达斡尔族自治旗",
			"zipcode": "162850"
		}, {
			"id": 777,
			"name": "鄂伦春自治旗",
			"zipcode": "165450"
		}, {
			"id": 778,
			"name": "鄂温克族自治旗",
			"zipcode": "021100"
		}, {
			"id": 779,
			"name": "陈巴尔虎旗",
			"zipcode": "021500"
		}, {
			"id": 780,
			"name": "新巴尔虎左旗",
			"zipcode": "021200"
		}, {
			"id": 781,
			"name": "新巴尔虎右旗",
			"zipcode": "021300"
		}, {
			"id": 782,
			"name": "满洲里市",
			"zipcode": "021400"
		}, {
			"id": 783,
			"name": "牙克石市",
			"zipcode": "022150"
		}, {
			"id": 784,
			"name": "扎兰屯市",
			"zipcode": "162650"
		}, {
			"id": 785,
			"name": "额尔古纳市",
			"zipcode": "022250"
		}, {
			"id": 786,
			"name": "根河市",
			"zipcode": "022350"
		}]
	}, {
		"id": 67,
		"name": "巴彦淖尔市",
		"child": [{
			"id": 787,
			"name": "临河区",
			"zipcode": "015001"
		}, {
			"id": 788,
			"name": "五原县",
			"zipcode": "015100"
		}, {
			"id": 789,
			"name": "磴口县",
			"zipcode": "015200"
		}, {
			"id": 790,
			"name": "乌拉特前旗",
			"zipcode": "014400"
		}, {
			"id": 791,
			"name": "乌拉特中旗",
			"zipcode": "015300"
		}, {
			"id": 792,
			"name": "乌拉特后旗",
			"zipcode": "015500"
		}, {
			"id": 793,
			"name": "杭锦后旗",
			"zipcode": "015400"
		}]
	}, {
		"id": 68,
		"name": "乌兰察布市",
		"child": [{
			"id": 794,
			"name": "集宁区",
			"zipcode": "012000"
		}, {
			"id": 795,
			"name": "卓资县",
			"zipcode": "012300"
		}, {
			"id": 796,
			"name": "化德县",
			"zipcode": "013350"
		}, {
			"id": 797,
			"name": "商都县",
			"zipcode": "013450"
		}, {
			"id": 798,
			"name": "兴和县",
			"zipcode": "013650"
		}, {
			"id": 799,
			"name": "凉城县",
			"zipcode": "013750"
		}, {
			"id": 800,
			"name": "察哈尔右翼前旗",
			"zipcode": "012200"
		}, {
			"id": 801,
			"name": "察哈尔右翼中旗",
			"zipcode": "013550"
		}, {
			"id": 802,
			"name": "察哈尔右翼后旗",
			"zipcode": "012400"
		}, {
			"id": 803,
			"name": "四子王旗",
			"zipcode": "011800"
		}, {
			"id": 804,
			"name": "丰镇市",
			"zipcode": "012100"
		}]
	}, {
		"id": 69,
		"name": "兴安盟",
		"child": [{
			"id": 805,
			"name": "乌兰浩特市",
			"zipcode": "137401"
		}, {
			"id": 806,
			"name": "阿尔山市",
			"zipcode": "137800"
		}, {
			"id": 807,
			"name": "科尔沁右翼前旗",
			"zipcode": "137423"
		}, {
			"id": 808,
			"name": "科尔沁右翼中旗",
			"zipcode": "029400"
		}, {
			"id": 809,
			"name": "扎赉特旗",
			"zipcode": "137600"
		}, {
			"id": 810,
			"name": "突泉县",
			"zipcode": "137500"
		}]
	}, {
		"id": 70,
		"name": "锡林郭勒盟",
		"child": [{
			"id": 811,
			"name": "二连浩特市",
			"zipcode": "011100"
		}, {
			"id": 812,
			"name": "锡林浩特市",
			"zipcode": "026000"
		}, {
			"id": 813,
			"name": "阿巴嘎旗",
			"zipcode": "011400"
		}, {
			"id": 814,
			"name": "苏尼特左旗",
			"zipcode": "011300"
		}, {
			"id": 815,
			"name": "苏尼特右旗",
			"zipcode": "011200"
		}, {
			"id": 816,
			"name": "东乌珠穆沁旗",
			"zipcode": "026300"
		}, {
			"id": 817,
			"name": "西乌珠穆沁旗",
			"zipcode": "026200"
		}, {
			"id": 818,
			"name": "太仆寺旗",
			"zipcode": "027000"
		}, {
			"id": 819,
			"name": "镶黄旗",
			"zipcode": "013250"
		}, {
			"id": 820,
			"name": "正镶白旗",
			"zipcode": "013800"
		}, {
			"id": 821,
			"name": "正蓝旗",
			"zipcode": "027200"
		}, {
			"id": 822,
			"name": "多伦县",
			"zipcode": "027300"
		}]
	}, {
		"id": 71,
		"name": "阿拉善盟",
		"child": [{
			"id": 823,
			"name": "阿拉善左旗",
			"zipcode": "750306"
		}, {
			"id": 824,
			"name": "阿拉善右旗",
			"zipcode": "737300"
		}, {
			"id": 825,
			"name": "额济纳旗",
			"zipcode": "735400"
		}]
	}]
}, {
	"id": 7,
	"name": "辽宁",
	"child": [{
		"id": 72,
		"name": "沈阳市",
		"child": [{
			"id": 826,
			"name": "和平区",
			"zipcode": "110001"
		}, {
			"id": 827,
			"name": "沈河区",
			"zipcode": "110013"
		}, {
			"id": 828,
			"name": "大东区",
			"zipcode": "110041"
		}, {
			"id": 829,
			"name": "皇姑区",
			"zipcode": "110031"
		}, {
			"id": 830,
			"name": "铁西区",
			"zipcode": "110021"
		}, {
			"id": 831,
			"name": "苏家屯区",
			"zipcode": "110101"
		}, {
			"id": 832,
			"name": "东陵区",
			"zipcode": "110015"
		}, {
			"id": 833,
			"name": "沈北新区",
			"zipcode": "110121"
		}, {
			"id": 834,
			"name": "于洪区",
			"zipcode": "110141"
		}, {
			"id": 835,
			"name": "辽中县",
			"zipcode": "110200"
		}, {
			"id": 836,
			"name": "康平县",
			"zipcode": "110500"
		}, {
			"id": 837,
			"name": "法库县",
			"zipcode": "110400"
		}, {
			"id": 838,
			"name": "新民市",
			"zipcode": "110300"
		}, {
			"id": 839,
			"name": "经济技术开发区",
			"zipcode": "110141"
		}, {
			"id": 840,
			"name": "浑南新区",
			"zipcode": "110179"
		}, {
			"id": 841,
			"name": "新城子经济技术开发区",
			"zipcode": "110121"
		}]
	}, {
		"id": 73,
		"name": "大连市",
		"child": [{
			"id": 842,
			"name": "中山区",
			"zipcode": "116001"
		}, {
			"id": 843,
			"name": "西岗区",
			"zipcode": "116011"
		}, {
			"id": 844,
			"name": "沙河口区",
			"zipcode": "116021"
		}, {
			"id": 845,
			"name": "甘井子区",
			"zipcode": "116033"
		}, {
			"id": 846,
			"name": "旅顺口区",
			"zipcode": "116041"
		}, {
			"id": 847,
			"name": "金州区",
			"zipcode": "116100"
		}, {
			"id": 848,
			"name": "长海县",
			"zipcode": "116500"
		}, {
			"id": 849,
			"name": "瓦房店市",
			"zipcode": "116300"
		}, {
			"id": 850,
			"name": "普兰店市",
			"zipcode": "116200"
		}, {
			"id": 851,
			"name": "庄河市",
			"zipcode": "116400"
		}, {
			"id": 852,
			"name": "开发区",
			"zipcode": "116600"
		}, {
			"id": 853,
			"name": "保税区",
			"zipcode": "116600"
		}]
	}, {
		"id": 74,
		"name": "鞍山市",
		"child": [{
			"id": 854,
			"name": "铁东区",
			"zipcode": "114001"
		}, {
			"id": 855,
			"name": "铁西区",
			"zipcode": "114013"
		}, {
			"id": 856,
			"name": "立山区",
			"zipcode": "114031"
		}, {
			"id": 857,
			"name": "千山区",
			"zipcode": "114041"
		}, {
			"id": 858,
			"name": "台安县",
			"zipcode": "114100"
		}, {
			"id": 859,
			"name": "岫岩满族自治县",
			"zipcode": "114300"
		}, {
			"id": 860,
			"name": "海城市",
			"zipcode": "114200"
		}]
	}, {
		"id": 75,
		"name": "抚顺市",
		"child": [{
			"id": 861,
			"name": "新抚区",
			"zipcode": "113008"
		}, {
			"id": 862,
			"name": "东洲区",
			"zipcode": "113003"
		}, {
			"id": 863,
			"name": "望花区",
			"zipcode": "113001"
		}, {
			"id": 864,
			"name": "顺城区",
			"zipcode": "113006"
		}, {
			"id": 865,
			"name": "抚顺县",
			"zipcode": "113006"
		}, {
			"id": 866,
			"name": "新宾满族自治县",
			"zipcode": "113200"
		}, {
			"id": 867,
			"name": "清原满族自治县",
			"zipcode": "113300"
		}]
	}, {
		"id": 76,
		"name": "本溪市",
		"child": [{
			"id": 868,
			"name": "平山区",
			"zipcode": "117000"
		}, {
			"id": 869,
			"name": "明山区",
			"zipcode": "117021"
		}, {
			"id": 870,
			"name": "溪湖区",
			"zipcode": "117002"
		}, {
			"id": 871,
			"name": "南芬区",
			"zipcode": "117014"
		}, {
			"id": 872,
			"name": "本溪满族自治县",
			"zipcode": "117100"
		}, {
			"id": 873,
			"name": "桓仁满族自治县",
			"zipcode": "117200"
		}]
	}, {
		"id": 77,
		"name": "丹东市",
		"child": [{
			"id": 874,
			"name": "元宝区",
			"zipcode": "118000"
		}, {
			"id": 875,
			"name": "振兴区",
			"zipcode": "118002"
		}, {
			"id": 876,
			"name": "振安区",
			"zipcode": "118001"
		}, {
			"id": 877,
			"name": "宽甸满族自治县",
			"zipcode": "118200"
		}, {
			"id": 878,
			"name": "东港市",
			"zipcode": "118300"
		}, {
			"id": 879,
			"name": "凤城市",
			"zipcode": "118100"
		}]
	}, {
		"id": 78,
		"name": "锦州市",
		"child": [{
			"id": 880,
			"name": "古塔区",
			"zipcode": "121001"
		}, {
			"id": 881,
			"name": "凌河区",
			"zipcode": "121000"
		}, {
			"id": 882,
			"name": "太和区",
			"zipcode": "121011"
		}, {
			"id": 883,
			"name": "黑山县",
			"zipcode": "121400"
		}, {
			"id": 884,
			"name": "义县",
			"zipcode": "121100"
		}, {
			"id": 885,
			"name": "凌海市",
			"zipcode": "121200"
		}, {
			"id": 886,
			"name": "北宁市",
			"zipcode": "121300"
		}, {
			"id": 887,
			"name": "松山新区",
			"zipcode": "121219"
		}, {
			"id": 888,
			"name": "经济技术开发区",
			"zipcode": "121007"
		}]
	}, {
		"id": 79,
		"name": "营口市",
		"child": [{
			"id": 889,
			"name": "站前区",
			"zipcode": "115002"
		}, {
			"id": 890,
			"name": "西市区",
			"zipcode": "115004"
		}, {
			"id": 891,
			"name": "鲅鱼圈区",
			"zipcode": "115007"
		}, {
			"id": 892,
			"name": "老边区",
			"zipcode": "115005"
		}, {
			"id": 893,
			"name": "盖州市",
			"zipcode": "115200"
		}, {
			"id": 894,
			"name": "大石桥市",
			"zipcode": "115100"
		}]
	}, {
		"id": 80,
		"name": "阜新市",
		"child": [{
			"id": 895,
			"name": "海州区",
			"zipcode": "123000"
		}, {
			"id": 896,
			"name": "新邱区",
			"zipcode": "123005"
		}, {
			"id": 897,
			"name": "太平区",
			"zipcode": "123003"
		}, {
			"id": 898,
			"name": "清河门区",
			"zipcode": "123006"
		}, {
			"id": 899,
			"name": "细河区",
			"zipcode": "123000"
		}, {
			"id": 900,
			"name": "阜新蒙古族自治县",
			"zipcode": "123100"
		}, {
			"id": 901,
			"name": "彰武县",
			"zipcode": "123200"
		}]
	}, {
		"id": 81,
		"name": "辽阳市",
		"child": [{
			"id": 902,
			"name": "白塔区",
			"zipcode": "111000"
		}, {
			"id": 903,
			"name": "文圣区",
			"zipcode": "111000"
		}, {
			"id": 904,
			"name": "宏伟区",
			"zipcode": "111003"
		}, {
			"id": 905,
			"name": "弓长岭区",
			"zipcode": "111008"
		}, {
			"id": 906,
			"name": "太子河区",
			"zipcode": "111000"
		}, {
			"id": 907,
			"name": "辽阳县",
			"zipcode": "111200"
		}, {
			"id": 908,
			"name": "灯塔市",
			"zipcode": "111300"
		}]
	}, {
		"id": 82,
		"name": "盘锦市",
		"child": [{
			"id": 909,
			"name": "双台子区",
			"zipcode": "124000"
		}, {
			"id": 910,
			"name": "兴隆台区",
			"zipcode": "124010"
		}, {
			"id": 911,
			"name": "大洼县",
			"zipcode": "124200"
		}, {
			"id": 912,
			"name": "盘山县",
			"zipcode": "124000"
		}]
	}, {
		"id": 83,
		"name": "铁岭市",
		"child": [{
			"id": 913,
			"name": "银州区",
			"zipcode": "112000"
		}, {
			"id": 914,
			"name": "清河区",
			"zipcode": "112003"
		}, {
			"id": 915,
			"name": "铁岭县",
			"zipcode": "112000"
		}, {
			"id": 916,
			"name": "西丰县",
			"zipcode": "112400"
		}, {
			"id": 917,
			"name": "昌图县",
			"zipcode": "112500"
		}, {
			"id": 918,
			"name": "调兵山市",
			"zipcode": "112700"
		}, {
			"id": 919,
			"name": "开原市",
			"zipcode": "112300"
		}]
	}, {
		"id": 84,
		"name": "朝阳市",
		"child": [{
			"id": 920,
			"name": "双塔区",
			"zipcode": "122000"
		}, {
			"id": 921,
			"name": "龙城区",
			"zipcode": "122000"
		}, {
			"id": 922,
			"name": "朝阳县",
			"zipcode": "122000"
		}, {
			"id": 923,
			"name": "建平县",
			"zipcode": "122400"
		}, {
			"id": 924,
			"name": "喀喇沁左翼蒙古族自治县",
			"zipcode": "122300"
		}, {
			"id": 925,
			"name": "北票市",
			"zipcode": "122100"
		}, {
			"id": 926,
			"name": "凌源市",
			"zipcode": "122500"
		}]
	}, {
		"id": 85,
		"name": "葫芦岛市",
		"child": [{
			"id": 927,
			"name": "连山区",
			"zipcode": "125001"
		}, {
			"id": 928,
			"name": "龙港区",
			"zipcode": "125003"
		}, {
			"id": 929,
			"name": "南票区",
			"zipcode": "125027"
		}, {
			"id": 930,
			"name": "绥中县",
			"zipcode": "125200"
		}, {
			"id": 931,
			"name": "建昌县",
			"zipcode": "125300"
		}, {
			"id": 932,
			"name": "兴城市",
			"zipcode": "125100"
		}]
	}]
}, {
	"id": 8,
	"name": "吉林",
	"child": [{
		"id": 86,
		"name": "长春市",
		"child": [{
			"id": 933,
			"name": "南关区",
			"zipcode": "130022"
		}, {
			"id": 934,
			"name": "宽城区",
			"zipcode": "130051"
		}, {
			"id": 935,
			"name": "朝阳区",
			"zipcode": "130012"
		}, {
			"id": 936,
			"name": "二道区",
			"zipcode": "130031"
		}, {
			"id": 937,
			"name": "绿园区",
			"zipcode": "130062"
		}, {
			"id": 938,
			"name": "双阳区",
			"zipcode": "130600"
		}, {
			"id": 939,
			"name": "农安县",
			"zipcode": "130200"
		}, {
			"id": 940,
			"name": "九台市",
			"zipcode": "130500"
		}, {
			"id": 941,
			"name": "榆树市",
			"zipcode": "130400"
		}, {
			"id": 942,
			"name": "德惠市",
			"zipcode": "130300"
		}, {
			"id": 943,
			"name": "净月经济开发区",
			"zipcode": "130117"
		}, {
			"id": 944,
			"name": "高新技术产业开发区",
			"zipcode": "130015"
		}]
	}, {
		"id": 87,
		"name": "吉林市",
		"child": [{
			"id": 945,
			"name": "昌邑区",
			"zipcode": "132002"
		}, {
			"id": 946,
			"name": "龙潭区",
			"zipcode": "132021"
		}, {
			"id": 947,
			"name": "船营区",
			"zipcode": "132011"
		}, {
			"id": 948,
			"name": "丰满区",
			"zipcode": "132013"
		}, {
			"id": 949,
			"name": "永吉县",
			"zipcode": "132200"
		}, {
			"id": 950,
			"name": "蛟河市",
			"zipcode": "132500"
		}, {
			"id": 951,
			"name": "桦甸市",
			"zipcode": "132400"
		}, {
			"id": 952,
			"name": "舒兰市",
			"zipcode": "132600"
		}, {
			"id": 953,
			"name": "磐石市",
			"zipcode": "132300"
		}]
	}, {
		"id": 88,
		"name": "四平市",
		"child": [{
			"id": 954,
			"name": "铁西区",
			"zipcode": "136000"
		}, {
			"id": 955,
			"name": "铁东区",
			"zipcode": "136001"
		}, {
			"id": 956,
			"name": "梨树县",
			"zipcode": "136500"
		}, {
			"id": 957,
			"name": "伊通满族自治县",
			"zipcode": "130700"
		}, {
			"id": 958,
			"name": "公主岭市",
			"zipcode": "136100"
		}, {
			"id": 959,
			"name": "双辽市",
			"zipcode": "136400"
		}]
	}, {
		"id": 89,
		"name": "辽源市",
		"child": [{
			"id": 960,
			"name": "龙山区",
			"zipcode": "136200"
		}, {
			"id": 961,
			"name": "西安区",
			"zipcode": "136201"
		}, {
			"id": 962,
			"name": "东丰县",
			"zipcode": "136300"
		}, {
			"id": 963,
			"name": "东辽县",
			"zipcode": "136600"
		}]
	}, {
		"id": 90,
		"name": "通化市",
		"child": [{
			"id": 964,
			"name": "东昌区",
			"zipcode": "134001"
		}, {
			"id": 965,
			"name": "二道江区",
			"zipcode": "134003"
		}, {
			"id": 966,
			"name": "通化县",
			"zipcode": "134100"
		}, {
			"id": 967,
			"name": "辉南县",
			"zipcode": "135100"
		}, {
			"id": 968,
			"name": "柳河县",
			"zipcode": "135300"
		}, {
			"id": 969,
			"name": "梅河口市",
			"zipcode": "135000"
		}, {
			"id": 970,
			"name": "集安市",
			"zipcode": "134200"
		}]
	}, {
		"id": 91,
		"name": "白山市",
		"child": [{
			"id": 971,
			"name": "八道江区",
			"zipcode": "134300"
		}, {
			"id": 972,
			"name": "抚松县",
			"zipcode": "134500"
		}, {
			"id": 973,
			"name": "靖宇县",
			"zipcode": "135200"
		}, {
			"id": 974,
			"name": "长白朝鲜族自治县",
			"zipcode": "134400"
		}, {
			"id": 975,
			"name": "江源县",
			"zipcode": "134700"
		}, {
			"id": 976,
			"name": "临江市",
			"zipcode": "134600"
		}]
	}, {
		"id": 92,
		"name": "松原市",
		"child": [{
			"id": 978,
			"name": "宁江区",
			"zipcode": "138000"
		}, {
			"id": 979,
			"name": "前郭尔罗斯蒙古族自治县",
			"zipcode": "138000"
		}, {
			"id": 980,
			"name": "长岭县",
			"zipcode": "131500"
		}, {
			"id": 981,
			"name": "乾安县",
			"zipcode": "131400"
		}, {
			"id": 982,
			"name": "扶余县",
			"zipcode": "131200"
		}]
	}, {
		"id": 93,
		"name": "白城市",
		"child": [{
			"id": 983,
			"name": "洮北区",
			"zipcode": "137000"
		}, {
			"id": 984,
			"name": "镇赉县",
			"zipcode": "137300"
		}, {
			"id": 985,
			"name": "通榆县",
			"zipcode": "137200"
		}, {
			"id": 986,
			"name": "洮南市",
			"zipcode": "137100"
		}, {
			"id": 987,
			"name": "大安市",
			"zipcode": "131300"
		}]
	}, {
		"id": 94,
		"name": "延边朝鲜族自治州",
		"child": [{
			"id": 988,
			"name": "延吉市",
			"zipcode": "133000"
		}, {
			"id": 989,
			"name": "图们市",
			"zipcode": "133100"
		}, {
			"id": 990,
			"name": "敦化市",
			"zipcode": "133700"
		}, {
			"id": 991,
			"name": "珲春市",
			"zipcode": "133300"
		}, {
			"id": 992,
			"name": "龙井市",
			"zipcode": "133400"
		}, {
			"id": 993,
			"name": "和龙市",
			"zipcode": "133500"
		}, {
			"id": 994,
			"name": "汪清县",
			"zipcode": "133200"
		}, {
			"id": 995,
			"name": "安图县",
			"zipcode": "133600"
		}]
	}]
}, {
	"id": 9,
	"name": "黑龙江",
	"child": [{
		"id": 95,
		"name": "哈尔滨市",
		"child": [{
			"id": 996,
			"name": "道里区",
			"zipcode": "150010"
		}, {
			"id": 997,
			"name": "南岗区",
			"zipcode": "150006"
		}, {
			"id": 998,
			"name": "道外区",
			"zipcode": "150020"
		}, {
			"id": 999,
			"name": "香坊区",
			"zipcode": "150036"
		}, {
			"id": 1000,
			"name": "动力区",
			"zipcode": "150040"
		}, {
			"id": 1001,
			"name": "平房区",
			"zipcode": "150060"
		}, {
			"id": 1002,
			"name": "松北区",
			"zipcode": "150028"
		}, {
			"id": 1003,
			"name": "呼兰区",
			"zipcode": "150500"
		}, {
			"id": 1004,
			"name": "依兰县",
			"zipcode": "154800"
		}, {
			"id": 1005,
			"name": "方正县",
			"zipcode": "150800"
		}, {
			"id": 1006,
			"name": "宾县",
			"zipcode": "150400"
		}, {
			"id": 1007,
			"name": "巴彦县",
			"zipcode": "151800"
		}, {
			"id": 1008,
			"name": "木兰县",
			"zipcode": "151900"
		}, {
			"id": 1009,
			"name": "通河县",
			"zipcode": "150900"
		}, {
			"id": 1010,
			"name": "延寿县",
			"zipcode": "150700"
		}, {
			"id": 1011,
			"name": "阿城区",
			"zipcode": "150300"
		}, {
			"id": 1012,
			"name": "双城市",
			"zipcode": "150100"
		}, {
			"id": 1013,
			"name": "尚志市",
			"zipcode": "150600"
		}, {
			"id": 1014,
			"name": "五常市",
			"zipcode": "150200"
		}]
	}, {
		"id": 96,
		"name": "齐齐哈尔市",
		"child": [{
			"id": 1016,
			"name": "龙沙区",
			"zipcode": "161000"
		}, {
			"id": 1017,
			"name": "建华区",
			"zipcode": "161006"
		}, {
			"id": 1018,
			"name": "铁锋区",
			"zipcode": "161000"
		}, {
			"id": 1019,
			"name": "昂昂溪区",
			"zipcode": "161031"
		}, {
			"id": 1020,
			"name": "富拉尔基区",
			"zipcode": "161041"
		}, {
			"id": 1021,
			"name": "碾子山区",
			"zipcode": "161046"
		}, {
			"id": 1022,
			"name": "梅里斯达斡尔族区",
			"zipcode": "161021"
		}, {
			"id": 1023,
			"name": "龙江县",
			"zipcode": "161100"
		}, {
			"id": 1024,
			"name": "依安县",
			"zipcode": "161500"
		}, {
			"id": 1025,
			"name": "泰来县",
			"zipcode": "162400"
		}, {
			"id": 1026,
			"name": "甘南县",
			"zipcode": "162100"
		}, {
			"id": 1027,
			"name": "富裕县",
			"zipcode": "161200"
		}, {
			"id": 1028,
			"name": "克山县",
			"zipcode": "161600"
		}, {
			"id": 1029,
			"name": "克东县",
			"zipcode": "164800"
		}, {
			"id": 1030,
			"name": "拜泉县",
			"zipcode": "164700"
		}, {
			"id": 1031,
			"name": "讷河市",
			"zipcode": "161300"
		}]
	}, {
		"id": 97,
		"name": "鸡西市",
		"child": [{
			"id": 1032,
			"name": "鸡冠区",
			"zipcode": "158100"
		}, {
			"id": 1033,
			"name": "恒山区",
			"zipcode": "158130"
		}, {
			"id": 1034,
			"name": "滴道区",
			"zipcode": "158150"
		}, {
			"id": 1035,
			"name": "梨树区",
			"zipcode": "158160"
		}, {
			"id": 1036,
			"name": "城子河区",
			"zipcode": "158170"
		}, {
			"id": 1037,
			"name": "麻山区",
			"zipcode": "158180"
		}, {
			"id": 1038,
			"name": "鸡东县",
			"zipcode": "158200"
		}, {
			"id": 1039,
			"name": "虎林市",
			"zipcode": "158400"
		}, {
			"id": 1040,
			"name": "密山市",
			"zipcode": "158300"
		}]
	}, {
		"id": 98,
		"name": "鹤岗市",
		"child": [{
			"id": 1041,
			"name": "向阳区",
			"zipcode": "154100"
		}, {
			"id": 1042,
			"name": "工农区",
			"zipcode": "154101"
		}, {
			"id": 1043,
			"name": "南山区",
			"zipcode": "154104"
		}, {
			"id": 1044,
			"name": "兴安区",
			"zipcode": "154102"
		}, {
			"id": 1045,
			"name": "东山区",
			"zipcode": "154106"
		}, {
			"id": 1046,
			"name": "兴山区",
			"zipcode": "154105"
		}, {
			"id": 1047,
			"name": "萝北县",
			"zipcode": "154200"
		}, {
			"id": 1048,
			"name": "绥滨县",
			"zipcode": "156200"
		}]
	}, {
		"id": 99,
		"name": "双鸭山市",
		"child": [{
			"id": 1049,
			"name": "尖山区",
			"zipcode": "155100"
		}, {
			"id": 1050,
			"name": "岭东区",
			"zipcode": "155120"
		}, {
			"id": 1051,
			"name": "四方台区",
			"zipcode": "155130"
		}, {
			"id": 1052,
			"name": "宝山区",
			"zipcode": "155131"
		}, {
			"id": 1053,
			"name": "集贤县",
			"zipcode": "155900"
		}, {
			"id": 1054,
			"name": "友谊县",
			"zipcode": "155800"
		}, {
			"id": 1055,
			"name": "宝清县",
			"zipcode": "155600"
		}, {
			"id": 1056,
			"name": "饶河县",
			"zipcode": "155700"
		}]
	}, {
		"id": 100,
		"name": "大庆市",
		"child": [{
			"id": 1057,
			"name": "萨尔图区",
			"zipcode": "163001"
		}, {
			"id": 1058,
			"name": "龙凤区",
			"zipcode": "163711"
		}, {
			"id": 1059,
			"name": "让胡路区",
			"zipcode": "163712"
		}, {
			"id": 1060,
			"name": "红岗区",
			"zipcode": "163511"
		}, {
			"id": 1061,
			"name": "大同区",
			"zipcode": "163515"
		}, {
			"id": 1062,
			"name": "肇州县",
			"zipcode": "166400"
		}, {
			"id": 1063,
			"name": "肇源县",
			"zipcode": "166500"
		}, {
			"id": 1064,
			"name": "林甸县",
			"zipcode": "166300"
		}, {
			"id": 1065,
			"name": "杜尔伯特蒙古族自治县",
			"zipcode": "166200"
		}]
	}, {
		"id": 101,
		"name": "伊春市",
		"child": [{
			"id": 1066,
			"name": "伊春区",
			"zipcode": "153000"
		}, {
			"id": 1067,
			"name": "南岔区",
			"zipcode": "153100"
		}, {
			"id": 1068,
			"name": "友好区",
			"zipcode": "153031"
		}, {
			"id": 1069,
			"name": "西林区",
			"zipcode": "153025"
		}, {
			"id": 1070,
			"name": "翠峦区",
			"zipcode": "153013"
		}, {
			"id": 1071,
			"name": "新青区",
			"zipcode": "153036"
		}, {
			"id": 1072,
			"name": "美溪区",
			"zipcode": "153021"
		}, {
			"id": 1073,
			"name": "金山屯区",
			"zipcode": "153026"
		}, {
			"id": 1074,
			"name": "五营区",
			"zipcode": "153033"
		}, {
			"id": 1075,
			"name": "乌马河区",
			"zipcode": "153011"
		}, {
			"id": 1076,
			"name": "汤旺河区",
			"zipcode": "153037"
		}, {
			"id": 1077,
			"name": "带岭区",
			"zipcode": "153106"
		}, {
			"id": 1078,
			"name": "乌伊岭区",
			"zipcode": "153038"
		}, {
			"id": 1079,
			"name": "红星区",
			"zipcode": "153035"
		}, {
			"id": 1080,
			"name": "上甘岭区",
			"zipcode": "153032"
		}, {
			"id": 1081,
			"name": "嘉荫县",
			"zipcode": "153200"
		}, {
			"id": 1082,
			"name": "铁力市",
			"zipcode": "152500"
		}]
	}, {
		"id": 102,
		"name": "佳木斯市",
		"child": [{
			"id": 1083,
			"name": "向阳区",
			"zipcode": "154002"
		}, {
			"id": 1084,
			"name": "前进区",
			"zipcode": "154002"
		}, {
			"id": 1085,
			"name": "东风区",
			"zipcode": "154005"
		}, {
			"id": 1086,
			"name": "郊区",
			"zipcode": "154004"
		}, {
			"id": 1087,
			"name": "桦南县",
			"zipcode": "154400"
		}, {
			"id": 1088,
			"name": "桦川县",
			"zipcode": "154300"
		}, {
			"id": 1089,
			"name": "汤原县",
			"zipcode": "154700"
		}, {
			"id": 1090,
			"name": "抚远县",
			"zipcode": "156500"
		}, {
			"id": 1091,
			"name": "同江市",
			"zipcode": "156400"
		}, {
			"id": 1092,
			"name": "富锦市",
			"zipcode": "156100"
		}]
	}, {
		"id": 103,
		"name": "七台河市",
		"child": [{
			"id": 1093,
			"name": "新兴区",
			"zipcode": "154604"
		}, {
			"id": 1094,
			"name": "桃山区",
			"zipcode": "154600"
		}, {
			"id": 1095,
			"name": "茄子河区",
			"zipcode": "154622"
		}, {
			"id": 1096,
			"name": "勃利县",
			"zipcode": "154500"
		}]
	}, {
		"id": 104,
		"name": "牡丹江市",
		"child": [{
			"id": 1097,
			"name": "东安区",
			"zipcode": "157000"
		}, {
			"id": 1098,
			"name": "爱民区",
			"zipcode": "157009"
		}, {
			"id": 1099,
			"name": "阳明区",
			"zipcode": "157013"
		}, {
			"id": 1100,
			"name": "西安区",
			"zipcode": "157000"
		}, {
			"id": 1101,
			"name": "东宁县",
			"zipcode": "157200"
		}, {
			"id": 1102,
			"name": "林口县",
			"zipcode": "157600"
		}, {
			"id": 1103,
			"name": "绥芬河市",
			"zipcode": "157300"
		}, {
			"id": 1104,
			"name": "海林市",
			"zipcode": "157100"
		}, {
			"id": 1105,
			"name": "宁安市",
			"zipcode": "157400"
		}, {
			"id": 1106,
			"name": "穆棱市",
			"zipcode": "157500"
		}]
	}, {
		"id": 105,
		"name": "黑河市",
		"child": [{
			"id": 1107,
			"name": "爱辉区",
			"zipcode": "164300"
		}, {
			"id": 1108,
			"name": "嫩江县",
			"zipcode": "161400"
		}, {
			"id": 1109,
			"name": "逊克县",
			"zipcode": "164400"
		}, {
			"id": 1110,
			"name": "孙吴县",
			"zipcode": "164200"
		}, {
			"id": 1111,
			"name": "北安市",
			"zipcode": "164000"
		}, {
			"id": 1112,
			"name": "五大连池市",
			"zipcode": "164100"
		}]
	}, {
		"id": 106,
		"name": "绥化市",
		"child": [{
			"id": 1113,
			"name": "北林区",
			"zipcode": "152000"
		}, {
			"id": 1114,
			"name": "望奎县",
			"zipcode": "152100"
		}, {
			"id": 1115,
			"name": "兰西县",
			"zipcode": "151500"
		}, {
			"id": 1116,
			"name": "青冈县",
			"zipcode": "151600"
		}, {
			"id": 1117,
			"name": "庆安县",
			"zipcode": "152400"
		}, {
			"id": 1118,
			"name": "明水县",
			"zipcode": "151700"
		}, {
			"id": 1119,
			"name": "绥棱县",
			"zipcode": "152200"
		}, {
			"id": 1120,
			"name": "安达市",
			"zipcode": "151400"
		}, {
			"id": 1121,
			"name": "肇东市",
			"zipcode": "151100"
		}, {
			"id": 1122,
			"name": "海伦市",
			"zipcode": "152300"
		}]
	}, {
		"id": 107,
		"name": "大兴安岭地区",
		"child": [{
			"id": 1123,
			"name": "呼玛县",
			"zipcode": "165100"
		}, {
			"id": 1124,
			"name": "塔河县",
			"zipcode": "165200"
		}, {
			"id": 1125,
			"name": "漠河县",
			"zipcode": "165300"
		}, {
			"id": 1126,
			"name": "加格达奇区",
			"zipcode": "165000"
		}, {
			"id": 1127,
			"name": "松岭区",
			"zipcode": "165012"
		}, {
			"id": 1128,
			"name": "新林区",
			"zipcode": "165023"
		}, {
			"id": 1129,
			"name": "呼中区",
			"zipcode": "165036"
		}]
	}]
}, {
	"id": 10,
	"name": "上海",
	"child": [{
		"id": 108,
		"name": "上海市",
		"child": [{
			"id": 1130,
			"name": "黄浦区",
			"zipcode": "200001"
		}, {
			"id": 1131,
			"name": "卢湾区",
			"zipcode": "200020"
		}, {
			"id": 1132,
			"name": "徐汇区",
			"zipcode": "200030"
		}, {
			"id": 1133,
			"name": "长宁区",
			"zipcode": "200050"
		}, {
			"id": 1134,
			"name": "静安区",
			"zipcode": "200040"
		}, {
			"id": 1135,
			"name": "普陀区",
			"zipcode": "200333"
		}, {
			"id": 1136,
			"name": "闸北区",
			"zipcode": "200070"
		}, {
			"id": 1137,
			"name": "虹口区",
			"zipcode": "200080"
		}, {
			"id": 1138,
			"name": "杨浦区",
			"zipcode": "200082"
		}, {
			"id": 1139,
			"name": "闵行区",
			"zipcode": "201100"
		}, {
			"id": 1140,
			"name": "宝山区",
			"zipcode": "201900"
		}, {
			"id": 1141,
			"name": "嘉定区",
			"zipcode": "201800"
		}, {
			"id": 1142,
			"name": "浦东新区",
			"zipcode": "200135"
		}, {
			"id": 1143,
			"name": "金山区",
			"zipcode": "200540"
		}, {
			"id": 1144,
			"name": "松江区",
			"zipcode": "201600"
		}, {
			"id": 1145,
			"name": "青浦区",
			"zipcode": "201700"
		}, {
			"id": 1146,
			"name": "南汇区",
			"zipcode": "201300"
		}, {
			"id": 1147,
			"name": "奉贤区",
			"zipcode": "201400"
		}, {
			"id": 1148,
			"name": "崇明县",
			"zipcode": "202150"
		}]
	}]
}, {
	"id": 11,
	"name": "江苏",
	"child": [{
		"id": 109,
		"name": "南京市",
		"child": [{
			"id": 1149,
			"name": "玄武区",
			"zipcode": "210018"
		}, {
			"id": 1150,
			"name": "白下区",
			"zipcode": "210002"
		}, {
			"id": 1151,
			"name": "秦淮区",
			"zipcode": "210001"
		}, {
			"id": 1152,
			"name": "建邺区",
			"zipcode": "210004"
		}, {
			"id": 1153,
			"name": "鼓楼区",
			"zipcode": "210009"
		}, {
			"id": 1154,
			"name": "下关区",
			"zipcode": "210011"
		}, {
			"id": 1155,
			"name": "浦口区",
			"zipcode": "211800"
		}, {
			"id": 1156,
			"name": "栖霞区",
			"zipcode": "210046"
		}, {
			"id": 1157,
			"name": "雨花台区",
			"zipcode": "210012"
		}, {
			"id": 1158,
			"name": "江宁区",
			"zipcode": "211100"
		}, {
			"id": 1159,
			"name": "六合区",
			"zipcode": "211500"
		}, {
			"id": 1160,
			"name": "溧水县",
			"zipcode": "211200"
		}, {
			"id": 1161,
			"name": "高淳县",
			"zipcode": "211300"
		}]
	}, {
		"id": 110,
		"name": "无锡市",
		"child": [{
			"id": 1162,
			"name": "崇安区",
			"zipcode": "214002"
		}, {
			"id": 1163,
			"name": "南长区",
			"zipcode": "214021"
		}, {
			"id": 1164,
			"name": "北塘区",
			"zipcode": "214044"
		}, {
			"id": 1165,
			"name": "锡山区",
			"zipcode": "214101"
		}, {
			"id": 1166,
			"name": "惠山区",
			"zipcode": "214174"
		}, {
			"id": 1167,
			"name": "滨湖区",
			"zipcode": "214062"
		}, {
			"id": 1168,
			"name": "江阴市",
			"zipcode": "214400"
		}, {
			"id": 1169,
			"name": "宜兴市",
			"zipcode": "214200"
		}, {
			"id": 1170,
			"name": "新区",
			"zipcode": "214028"
		}]
	}, {
		"id": 111,
		"name": "徐州市",
		"child": [{
			"id": 1171,
			"name": "云龙区",
			"zipcode": "221009"
		}, {
			"id": 1172,
			"name": "鼓楼区",
			"zipcode": "221005"
		}, {
			"id": 1173,
			"name": "九里区",
			"zipcode": "221140"
		}, {
			"id": 1174,
			"name": "泉山区",
			"zipcode": "221006"
		}, {
			"id": 1175,
			"name": "铜山县",
			"zipcode": "221116"
		}, {
			"id": 1176,
			"name": "贾汪区",
			"zipcode": "221011"
		}, {
			"id": 1177,
			"name": "丰县",
			"zipcode": "221700"
		}, {
			"id": 1178,
			"name": "沛县",
			"zipcode": "221600"
		}, {
			"id": 1179,
			"name": "睢宁县",
			"zipcode": "221200"
		}, {
			"id": 1180,
			"name": "新沂市",
			"zipcode": "221400"
		}, {
			"id": 1181,
			"name": "邳州市",
			"zipcode": "221300"
		}]
	}, {
		"id": 112,
		"name": "常州市",
		"child": [{
			"id": 1182,
			"name": "天宁区",
			"zipcode": "213003"
		}, {
			"id": 1183,
			"name": "钟楼区",
			"zipcode": "213002"
		}, {
			"id": 1184,
			"name": "戚墅堰区",
			"zipcode": "213011"
		}, {
			"id": 1185,
			"name": "新北区",
			"zipcode": "213001"
		}, {
			"id": 1186,
			"name": "武进区",
			"zipcode": "213161"
		}, {
			"id": 1187,
			"name": "溧阳市",
			"zipcode": "213300"
		}, {
			"id": 1188,
			"name": "金坛市",
			"zipcode": "213200"
		}]
	}, {
		"id": 113,
		"name": "苏州市",
		"child": [{
			"id": 1192,
			"name": "虎丘区",
			"zipcode": "215004"
		}, {
			"id": 1193,
			"name": "吴中区",
			"zipcode": "215128"
		}, {
			"id": 1194,
			"name": "相城区",
			"zipcode": "215131"
		}, {
			"id": 1195,
			"name": "常熟市",
			"zipcode": "215500"
		}, {
			"id": 1196,
			"name": "张家港市",
			"zipcode": "215600"
		}, {
			"id": 1197,
			"name": "昆山市",
			"zipcode": "215300"
		}, {
			"id": 1198,
			"name": "吴江市",
			"zipcode": "215200"
		}, {
			"id": 1199,
			"name": "太仓市",
			"zipcode": "215400"
		}, {
			"id": 1200,
			"name": "工业园区",
			"zipcode": "215028"
		}, {
			"id": 1201,
			"name": "高新区",
			"zipcode": "215011"
		}, {
			"id": 7589,
			"name": "姑苏区",
			"zipcode": "215008"
		}]
	}, {
		"id": 114,
		"name": "南通市",
		"child": [{
			"id": 1202,
			"name": "崇川区",
			"zipcode": "226001"
		}, {
			"id": 1203,
			"name": "港闸区",
			"zipcode": "226001"
		}, {
			"id": 1204,
			"name": "海安县",
			"zipcode": "226600"
		}, {
			"id": 1205,
			"name": "如东县",
			"zipcode": "226400"
		}, {
			"id": 1206,
			"name": "启东市",
			"zipcode": "226200"
		}, {
			"id": 1207,
			"name": "如皋市",
			"zipcode": "226500"
		}, {
			"id": 1208,
			"name": "通州市",
			"zipcode": "226300"
		}, {
			"id": 1209,
			"name": "海门市",
			"zipcode": "226100"
		}, {
			"id": 1210,
			"name": "经济技术开发区",
			"zipcode": "226009"
		}]
	}, {
		"id": 115,
		"name": "连云港市",
		"child": [{
			"id": 1211,
			"name": "连云区",
			"zipcode": "222042"
		}, {
			"id": 1212,
			"name": "新浦区",
			"zipcode": "222003"
		}, {
			"id": 1213,
			"name": "海州区",
			"zipcode": "222023"
		}, {
			"id": 1214,
			"name": "赣榆县",
			"zipcode": "222100"
		}, {
			"id": 1215,
			"name": "东海县",
			"zipcode": "222300"
		}, {
			"id": 1216,
			"name": "灌云县",
			"zipcode": "222200"
		}, {
			"id": 1217,
			"name": "灌南县",
			"zipcode": "223500"
		}]
	}, {
		"id": 116,
		"name": "淮安市",
		"child": [{
			"id": 1218,
			"name": "清河区",
			"zipcode": "223001"
		}, {
			"id": 1219,
			"name": "楚州区",
			"zipcode": "223200"
		}, {
			"id": 1220,
			"name": "淮阴区",
			"zipcode": "223300"
		}, {
			"id": 1221,
			"name": "清浦区",
			"zipcode": "223002"
		}, {
			"id": 1222,
			"name": "涟水县",
			"zipcode": "223400"
		}, {
			"id": 1223,
			"name": "洪泽县",
			"zipcode": "223100"
		}, {
			"id": 1224,
			"name": "盱眙县",
			"zipcode": "211700"
		}, {
			"id": 1225,
			"name": "金湖县",
			"zipcode": "211600"
		}]
	}, {
		"id": 117,
		"name": "盐城市",
		"child": [{
			"id": 1226,
			"name": "亭湖区",
			"zipcode": "224005"
		}, {
			"id": 1227,
			"name": "盐都区",
			"zipcode": "224055"
		}, {
			"id": 1228,
			"name": "响水县",
			"zipcode": "224600"
		}, {
			"id": 1229,
			"name": "滨海县",
			"zipcode": "224500"
		}, {
			"id": 1230,
			"name": "阜宁县",
			"zipcode": "224400"
		}, {
			"id": 1231,
			"name": "射阳县",
			"zipcode": "224300"
		}, {
			"id": 1232,
			"name": "建湖县",
			"zipcode": "224700"
		}, {
			"id": 1233,
			"name": "东台市",
			"zipcode": "224200"
		}, {
			"id": 1234,
			"name": "大丰市",
			"zipcode": "224100"
		}]
	}, {
		"id": 118,
		"name": "扬州市",
		"child": [{
			"id": 1235,
			"name": "广陵区",
			"zipcode": "225002"
		}, {
			"id": 1236,
			"name": "邗江区",
			"zipcode": "225002"
		}, {
			"id": 1237,
			"name": "宝应县",
			"zipcode": "225800"
		}, {
			"id": 1238,
			"name": "仪征市",
			"zipcode": "211400"
		}, {
			"id": 1239,
			"name": "高邮市",
			"zipcode": "225600"
		}, {
			"id": 1240,
			"name": "江都市",
			"zipcode": "225200"
		}, {
			"id": 1241,
			"name": "维扬区",
			"zipcode": "225002"
		}, {
			"id": 1242,
			"name": "经济开发区",
			"zipcode": "225101"
		}]
	}, {
		"id": 119,
		"name": "镇江市",
		"child": [{
			"id": 1243,
			"name": "京口区",
			"zipcode": "212001"
		}, {
			"id": 1244,
			"name": "润州区",
			"zipcode": "212004"
		}, {
			"id": 1245,
			"name": "丹徒区",
			"zipcode": "212001"
		}, {
			"id": 1246,
			"name": "丹阳市",
			"zipcode": "212300"
		}, {
			"id": 1247,
			"name": "扬中市",
			"zipcode": "212200"
		}, {
			"id": 1248,
			"name": "句容市",
			"zipcode": "212400"
		}, {
			"id": 1249,
			"name": "新区",
			"zipcode": "212132"
		}]
	}, {
		"id": 120,
		"name": "泰州市",
		"child": [{
			"id": 1250,
			"name": "海陵区",
			"zipcode": "225300"
		}, {
			"id": 1251,
			"name": "高港区",
			"zipcode": "225321"
		}, {
			"id": 1252,
			"name": "兴化市",
			"zipcode": "225700"
		}, {
			"id": 1253,
			"name": "靖江市",
			"zipcode": "214500"
		}, {
			"id": 1254,
			"name": "泰兴市",
			"zipcode": "225400"
		}, {
			"id": 1255,
			"name": "姜堰市",
			"zipcode": "225500"
		}]
	}, {
		"id": 121,
		"name": "宿迁市",
		"child": [{
			"id": 1256,
			"name": "宿城区",
			"zipcode": "223800"
		}, {
			"id": 1257,
			"name": "宿豫区",
			"zipcode": "223800"
		}, {
			"id": 1258,
			"name": "沭阳县",
			"zipcode": "223600"
		}, {
			"id": 1259,
			"name": "泗阳县",
			"zipcode": "223700"
		}, {
			"id": 1260,
			"name": "泗洪县",
			"zipcode": "223900"
		}]
	}]
}, {
	"id": 12,
	"name": "浙江",
	"child": [{
		"id": 122,
		"name": "杭州市",
		"child": [{
			"id": 1261,
			"name": "上城区",
			"zipcode": "310002"
		}, {
			"id": 1262,
			"name": "下城区",
			"zipcode": "310006"
		}, {
			"id": 1263,
			"name": "江干区",
			"zipcode": "310016"
		}, {
			"id": 1264,
			"name": "拱墅区",
			"zipcode": "310011"
		}, {
			"id": 1265,
			"name": "西湖区",
			"zipcode": "310013"
		}, {
			"id": 1266,
			"name": "滨江区",
			"zipcode": "310051"
		}, {
			"id": 1267,
			"name": "萧山区",
			"zipcode": "311200"
		}, {
			"id": 1268,
			"name": "余杭区",
			"zipcode": "311100"
		}, {
			"id": 1269,
			"name": "桐庐县",
			"zipcode": "311500"
		}, {
			"id": 1270,
			"name": "淳安县",
			"zipcode": "311700"
		}, {
			"id": 1271,
			"name": "建德市",
			"zipcode": "311600"
		}, {
			"id": 1272,
			"name": "富阳市",
			"zipcode": "311400"
		}, {
			"id": 1273,
			"name": "临安市",
			"zipcode": "311300"
		}]
	}, {
		"id": 123,
		"name": "宁波市",
		"child": [{
			"id": 1274,
			"name": "海曙区",
			"zipcode": "315000"
		}, {
			"id": 1275,
			"name": "江东区",
			"zipcode": "315040"
		}, {
			"id": 1276,
			"name": "江北区",
			"zipcode": "315040"
		}, {
			"id": 1277,
			"name": "北仑区",
			"zipcode": "315800"
		}, {
			"id": 1278,
			"name": "镇海区",
			"zipcode": "315200"
		}, {
			"id": 1279,
			"name": "鄞州区",
			"zipcode": "315100"
		}, {
			"id": 1280,
			"name": "象山县",
			"zipcode": "315700"
		}, {
			"id": 1281,
			"name": "宁海县",
			"zipcode": "315600"
		}, {
			"id": 1282,
			"name": "余姚市",
			"zipcode": "315400"
		}, {
			"id": 1283,
			"name": "慈溪市",
			"zipcode": "315300"
		}, {
			"id": 1284,
			"name": "奉化市",
			"zipcode": "315500"
		}, {
			"id": 3382,
			"name": "国家高新区",
			"zipcode": "315040"
		}]
	}, {
		"id": 124,
		"name": "温州市",
		"child": [{
			"id": 1285,
			"name": "鹿城区",
			"zipcode": "325000"
		}, {
			"id": 1286,
			"name": "龙湾区",
			"zipcode": "325013"
		}, {
			"id": 1287,
			"name": "瓯海区",
			"zipcode": "325005"
		}, {
			"id": 1288,
			"name": "洞头县",
			"zipcode": "325700"
		}, {
			"id": 1289,
			"name": "永嘉县",
			"zipcode": "315100"
		}, {
			"id": 1290,
			"name": "平阳县",
			"zipcode": "325400"
		}, {
			"id": 1291,
			"name": "苍南县",
			"zipcode": "325800"
		}, {
			"id": 1292,
			"name": "文成县",
			"zipcode": "325300"
		}, {
			"id": 1293,
			"name": "泰顺县",
			"zipcode": "325500"
		}, {
			"id": 1294,
			"name": "瑞安市",
			"zipcode": "325200"
		}, {
			"id": 1295,
			"name": "乐清市",
			"zipcode": "325600"
		}]
	}, {
		"id": 125,
		"name": "嘉兴市",
		"child": [{
			"id": 1296,
			"name": "秀洲区",
			"zipcode": "314001"
		}, {
			"id": 1297,
			"name": "嘉善县",
			"zipcode": "314100"
		}, {
			"id": 1298,
			"name": "海盐县",
			"zipcode": "314300"
		}, {
			"id": 1299,
			"name": "海宁市",
			"zipcode": "314400"
		}, {
			"id": 1300,
			"name": "平湖市",
			"zipcode": "314200"
		}, {
			"id": 1301,
			"name": "桐乡市",
			"zipcode": "314500"
		}, {
			"id": 1302,
			"name": "南湖区",
			"zipcode": "314001"
		}]
	}, {
		"id": 126,
		"name": "湖州市",
		"child": [{
			"id": 1303,
			"name": "吴兴区",
			"zipcode": "313000"
		}, {
			"id": 1304,
			"name": "南浔区",
			"zipcode": "313009"
		}, {
			"id": 1305,
			"name": "德清县",
			"zipcode": "313200"
		}, {
			"id": 1306,
			"name": "长兴县",
			"zipcode": "313100"
		}, {
			"id": 1307,
			"name": "安吉县",
			"zipcode": "313300"
		}]
	}, {
		"id": 127,
		"name": "绍兴市",
		"child": [{
			"id": 1308,
			"name": "越城区",
			"zipcode": "312000"
		}, {
			"id": 1309,
			"name": "绍兴县",
			"zipcode": "312000"
		}, {
			"id": 1310,
			"name": "新昌县",
			"zipcode": "312500"
		}, {
			"id": 1311,
			"name": "诸暨市",
			"zipcode": "311800"
		}, {
			"id": 1312,
			"name": "上虞市",
			"zipcode": "312300"
		}, {
			"id": 1313,
			"name": "嵊州市",
			"zipcode": "312400"
		}]
	}, {
		"id": 128,
		"name": "金华市",
		"child": [{
			"id": 1314,
			"name": "婺城区",
			"zipcode": "321000"
		}, {
			"id": 1315,
			"name": "金东区",
			"zipcode": "321000"
		}, {
			"id": 1316,
			"name": "武义县",
			"zipcode": "321200"
		}, {
			"id": 1317,
			"name": "浦江县",
			"zipcode": "322200"
		}, {
			"id": 1318,
			"name": "磐安县",
			"zipcode": "322300"
		}, {
			"id": 1319,
			"name": "兰溪市",
			"zipcode": "321100"
		}, {
			"id": 1320,
			"name": "义乌市",
			"zipcode": "322000"
		}, {
			"id": 1321,
			"name": "东阳市",
			"zipcode": "322100"
		}, {
			"id": 1322,
			"name": "永康市",
			"zipcode": "321300"
		}]
	}, {
		"id": 129,
		"name": "衢州市",
		"child": [{
			"id": 1323,
			"name": "柯城区",
			"zipcode": "324100"
		}, {
			"id": 1324,
			"name": "衢江区",
			"zipcode": "324022"
		}, {
			"id": 1325,
			"name": "常山县",
			"zipcode": "324200"
		}, {
			"id": 1326,
			"name": "开化县",
			"zipcode": "324300"
		}, {
			"id": 1327,
			"name": "龙游县",
			"zipcode": "324400"
		}, {
			"id": 1328,
			"name": "江山市",
			"zipcode": "324100"
		}]
	}, {
		"id": 130,
		"name": "舟山市",
		"child": [{
			"id": 1329,
			"name": "定海区",
			"zipcode": "316000"
		}, {
			"id": 1330,
			"name": "普陀区",
			"zipcode": "316100"
		}, {
			"id": 1331,
			"name": "岱山县",
			"zipcode": "316200"
		}, {
			"id": 1332,
			"name": "嵊泗县",
			"zipcode": "202450"
		}]
	}, {
		"id": 131,
		"name": "台州市",
		"child": [{
			"id": 1333,
			"name": "椒江区",
			"zipcode": "318000"
		}, {
			"id": 1334,
			"name": "路桥区",
			"zipcode": "318050"
		}, {
			"id": 1335,
			"name": "黄岩区",
			"zipcode": "318020"
		}, {
			"id": 1336,
			"name": "玉环县",
			"zipcode": "317600"
		}, {
			"id": 1337,
			"name": "三门县",
			"zipcode": "317100"
		}, {
			"id": 1338,
			"name": "天台县",
			"zipcode": "317200"
		}, {
			"id": 1339,
			"name": "仙居县",
			"zipcode": "317300"
		}, {
			"id": 1340,
			"name": "温岭市",
			"zipcode": "317500"
		}, {
			"id": 1341,
			"name": "临海市",
			"zipcode": "317000"
		}]
	}, {
		"id": 132,
		"name": "丽水市",
		"child": [{
			"id": 1342,
			"name": "莲都区",
			"zipcode": "323000"
		}, {
			"id": 1343,
			"name": "青田县",
			"zipcode": "323900"
		}, {
			"id": 1344,
			"name": "缙云县",
			"zipcode": "321400"
		}, {
			"id": 1345,
			"name": "遂昌县",
			"zipcode": "323300"
		}, {
			"id": 1346,
			"name": "松阳县",
			"zipcode": "323400"
		}, {
			"id": 1347,
			"name": "云和县",
			"zipcode": "323600"
		}, {
			"id": 1348,
			"name": "庆元县",
			"zipcode": "323800"
		}, {
			"id": 1349,
			"name": "景宁畲族自治县",
			"zipcode": "323500"
		}, {
			"id": 1350,
			"name": "龙泉市",
			"zipcode": "323700"
		}]
	}]
}, {
	"id": 13,
	"name": "安徽",
	"child": [{
		"id": 133,
		"name": "合肥市",
		"child": [{
			"id": 1351,
			"name": "瑶海区",
			"zipcode": "230011"
		}, {
			"id": 1352,
			"name": "庐阳区",
			"zipcode": "230001"
		}, {
			"id": 1353,
			"name": "蜀山区",
			"zipcode": "230031"
		}, {
			"id": 1354,
			"name": "包河区",
			"zipcode": "230041"
		}, {
			"id": 1355,
			"name": "长丰县",
			"zipcode": "231100"
		}, {
			"id": 1356,
			"name": "肥东县",
			"zipcode": "231600"
		}, {
			"id": 1357,
			"name": "肥西县",
			"zipcode": "231200"
		}, {
			"id": 1358,
			"name": "经济技术开发区",
			"zipcode": "230601"
		}, {
			"id": 1359,
			"name": "新站试验区",
			"zipcode": "230011"
		}, {
			"id": 1360,
			"name": "政务文化新区",
			"zipcode": "230066"
		}, {
			"id": 1361,
			"name": "高新技术产业开发区",
			"zipcode": "230088"
		}, {
			"id": 1435,
			"name": "居巢区",
			"zipcode": "238000"
		}, {
			"id": 1436,
			"name": "庐江县",
			"zipcode": "231500"
		}]
	}, {
		"id": 134,
		"name": "芜湖市",
		"child": [{
			"id": 1362,
			"name": "镜湖区",
			"zipcode": "241000"
		}, {
			"id": 1363,
			"name": "鸠江区",
			"zipcode": "241000"
		}, {
			"id": 1364,
			"name": "芜湖县",
			"zipcode": "241100"
		}, {
			"id": 1365,
			"name": "繁昌县",
			"zipcode": "241200"
		}, {
			"id": 1366,
			"name": "南陵县",
			"zipcode": "242400"
		}, {
			"id": 1367,
			"name": "弋江区",
			"zipcode": "241000"
		}, {
			"id": 1368,
			"name": "三山区",
			"zipcode": "241000"
		}, {
			"id": 1437,
			"name": "无为县",
			"zipcode": "238300"
		}]
	}, {
		"id": 135,
		"name": "蚌埠市",
		"child": [{
			"id": 1369,
			"name": "龙子湖区",
			"zipcode": "233000"
		}, {
			"id": 1370,
			"name": "蚌山区",
			"zipcode": "233000"
		}, {
			"id": 1371,
			"name": "禹会区",
			"zipcode": "233000"
		}, {
			"id": 1372,
			"name": "淮上区",
			"zipcode": "233000"
		}, {
			"id": 1373,
			"name": "怀远县",
			"zipcode": "233400"
		}, {
			"id": 1374,
			"name": "五河县",
			"zipcode": "233300"
		}, {
			"id": 1375,
			"name": "固镇县",
			"zipcode": "233700"
		}]
	}, {
		"id": 136,
		"name": "淮南市",
		"child": [{
			"id": 1376,
			"name": "大通区",
			"zipcode": "232033"
		}, {
			"id": 1377,
			"name": "田家庵区",
			"zipcode": "232000"
		}, {
			"id": 1378,
			"name": "谢家集区",
			"zipcode": "232052"
		}, {
			"id": 1379,
			"name": "八公山区",
			"zipcode": "232072"
		}, {
			"id": 1380,
			"name": "潘集区",
			"zipcode": "232082"
		}, {
			"id": 1381,
			"name": "凤台县",
			"zipcode": "232100"
		}]
	}, {
		"id": 137,
		"name": "马鞍山市",
		"child": [{
			"id": 1382,
			"name": "雨山区",
			"zipcode": "243071"
		}, {
			"id": 1383,
			"name": "花山区",
			"zipcode": "243000"
		}, {
			"id": 1384,
			"name": "金家庄区",
			"zipcode": "243021"
		}, {
			"id": 1385,
			"name": "当涂县",
			"zipcode": "243100"
		}, {
			"id": 1386,
			"name": "经济技术开发区",
			"zipcode": "243041"
		}, {
			"id": 1438,
			"name": "含山县",
			"zipcode": "238100"
		}, {
			"id": 1439,
			"name": "和县",
			"zipcode": "238200"
		}]
	}, {
		"id": 138,
		"name": "淮北市",
		"child": [{
			"id": 1387,
			"name": "杜集区",
			"zipcode": "235000"
		}, {
			"id": 1388,
			"name": "相山区",
			"zipcode": "235000"
		}, {
			"id": 1389,
			"name": "烈山区",
			"zipcode": "235000"
		}, {
			"id": 1390,
			"name": "濉溪县",
			"zipcode": "235100"
		}]
	}, {
		"id": 139,
		"name": "铜陵市",
		"child": [{
			"id": 1391,
			"name": "铜官山区",
			"zipcode": "244000"
		}, {
			"id": 1392,
			"name": "狮子山区",
			"zipcode": "244000"
		}, {
			"id": 1393,
			"name": "郊区",
			"zipcode": "244000"
		}, {
			"id": 1394,
			"name": "铜陵县",
			"zipcode": "244100"
		}]
	}, {
		"id": 140,
		"name": "安庆市",
		"child": [{
			"id": 1395,
			"name": "迎江区",
			"zipcode": "246001"
		}, {
			"id": 1396,
			"name": "大观区",
			"zipcode": "246002"
		}, {
			"id": 1397,
			"name": "怀宁县",
			"zipcode": "246100"
		}, {
			"id": 1398,
			"name": "枞阳县",
			"zipcode": "246700"
		}, {
			"id": 1399,
			"name": "潜山县",
			"zipcode": "246300"
		}, {
			"id": 1400,
			"name": "太湖县",
			"zipcode": "246400"
		}, {
			"id": 1401,
			"name": "宿松县",
			"zipcode": "246500"
		}, {
			"id": 1402,
			"name": "望江县",
			"zipcode": "246200"
		}, {
			"id": 1403,
			"name": "岳西县",
			"zipcode": "246600"
		}, {
			"id": 1404,
			"name": "桐城市",
			"zipcode": "231400"
		}, {
			"id": 1405,
			"name": "宜秀区",
			"zipcode": "246003"
		}]
	}, {
		"id": 141,
		"name": "黄山市",
		"child": [{
			"id": 1406,
			"name": "屯溪区",
			"zipcode": "245000"
		}, {
			"id": 1407,
			"name": "黄山区",
			"zipcode": "242700"
		}, {
			"id": 1408,
			"name": "徽州区",
			"zipcode": "245061"
		}, {
			"id": 1409,
			"name": "歙县",
			"zipcode": "245200"
		}, {
			"id": 1410,
			"name": "休宁县",
			"zipcode": "245400"
		}, {
			"id": 1411,
			"name": "黟县",
			"zipcode": "245500"
		}, {
			"id": 1412,
			"name": "祁门县",
			"zipcode": "245600"
		}]
	}, {
		"id": 142,
		"name": "滁州市",
		"child": [{
			"id": 1413,
			"name": "琅琊区",
			"zipcode": "239000"
		}, {
			"id": 1414,
			"name": "南谯区",
			"zipcode": "239000"
		}, {
			"id": 1415,
			"name": "来安县",
			"zipcode": "239200"
		}, {
			"id": 1416,
			"name": "全椒县",
			"zipcode": "239500"
		}, {
			"id": 1417,
			"name": "定远县",
			"zipcode": "233200"
		}, {
			"id": 1418,
			"name": "凤阳县",
			"zipcode": "233100"
		}, {
			"id": 1419,
			"name": "天长市",
			"zipcode": "239300"
		}, {
			"id": 1420,
			"name": "明光市",
			"zipcode": "239400"
		}]
	}, {
		"id": 143,
		"name": "阜阳市",
		"child": [{
			"id": 1421,
			"name": "颍州区",
			"zipcode": "236001"
		}, {
			"id": 1422,
			"name": "颍东区",
			"zipcode": "236058"
		}, {
			"id": 1423,
			"name": "颍泉区",
			"zipcode": "236045"
		}, {
			"id": 1424,
			"name": "临泉县",
			"zipcode": "236400"
		}, {
			"id": 1425,
			"name": "太和县",
			"zipcode": "236600"
		}, {
			"id": 1426,
			"name": "阜南县",
			"zipcode": "236300"
		}, {
			"id": 1427,
			"name": "颍上县",
			"zipcode": "236200"
		}, {
			"id": 1428,
			"name": "界首市",
			"zipcode": "236500"
		}, {
			"id": 1429,
			"name": "经济开发区",
			"zipcode": "236112"
		}]
	}, {
		"id": 144,
		"name": "宿州市",
		"child": [{
			"id": 1430,
			"name": "埇桥区",
			"zipcode": "234000"
		}, {
			"id": 1431,
			"name": "砀山县",
			"zipcode": "235300"
		}, {
			"id": 1432,
			"name": "萧县",
			"zipcode": "235200"
		}, {
			"id": 1433,
			"name": "灵璧县",
			"zipcode": "234200"
		}, {
			"id": 1434,
			"name": "泗县",
			"zipcode": "234300"
		}]
	}, {
		"id": 146,
		"name": "六安市",
		"child": [{
			"id": 1440,
			"name": "金安区",
			"zipcode": "237000"
		}, {
			"id": 1441,
			"name": "裕安区",
			"zipcode": "237010"
		}, {
			"id": 1442,
			"name": "寿县",
			"zipcode": "232200"
		}, {
			"id": 1443,
			"name": "霍邱县",
			"zipcode": "237400"
		}, {
			"id": 1444,
			"name": "舒城县",
			"zipcode": "231300"
		}, {
			"id": 1445,
			"name": "金寨县",
			"zipcode": "237300"
		}, {
			"id": 1446,
			"name": "霍山县",
			"zipcode": "237200"
		}]
	}, {
		"id": 147,
		"name": "亳州市",
		"child": [{
			"id": 1447,
			"name": "谯城区",
			"zipcode": "236800"
		}, {
			"id": 1448,
			"name": "涡阳县",
			"zipcode": "233600"
		}, {
			"id": 1449,
			"name": "蒙城县",
			"zipcode": "233500"
		}, {
			"id": 1450,
			"name": "利辛县",
			"zipcode": "236700"
		}]
	}, {
		"id": 148,
		"name": "池州市",
		"child": [{
			"id": 1451,
			"name": "贵池区",
			"zipcode": "247100"
		}, {
			"id": 1452,
			"name": "东至县",
			"zipcode": "247200"
		}, {
			"id": 1453,
			"name": "石台县",
			"zipcode": "245100"
		}, {
			"id": 1454,
			"name": "青阳县",
			"zipcode": "242800"
		}]
	}, {
		"id": 149,
		"name": "宣城市",
		"child": [{
			"id": 1455,
			"name": "宣州区",
			"zipcode": "242000"
		}, {
			"id": 1456,
			"name": "郎溪县",
			"zipcode": "242100"
		}, {
			"id": 1457,
			"name": "广德县",
			"zipcode": "242200"
		}, {
			"id": 1458,
			"name": "泾县",
			"zipcode": "242500"
		}, {
			"id": 1459,
			"name": "绩溪县",
			"zipcode": "245300"
		}, {
			"id": 1460,
			"name": "旌德县",
			"zipcode": "242600"
		}, {
			"id": 1461,
			"name": "宁国市",
			"zipcode": "242300"
		}]
	}]
}, {
	"id": 14,
	"name": "福建",
	"child": [{
		"id": 150,
		"name": "福州市",
		"child": [{
			"id": 1462,
			"name": "鼓楼区",
			"zipcode": "350001"
		}, {
			"id": 1463,
			"name": "台江区",
			"zipcode": "350004"
		}, {
			"id": 1464,
			"name": "仓山区",
			"zipcode": "350007"
		}, {
			"id": 1465,
			"name": "马尾区",
			"zipcode": "350015"
		}, {
			"id": 1466,
			"name": "晋安区",
			"zipcode": "350011"
		}, {
			"id": 1467,
			"name": "闽侯县",
			"zipcode": "350100"
		}, {
			"id": 1468,
			"name": "连江县",
			"zipcode": "350500"
		}, {
			"id": 1469,
			"name": "罗源县",
			"zipcode": "350600"
		}, {
			"id": 1470,
			"name": "闽清县",
			"zipcode": "350800"
		}, {
			"id": 1471,
			"name": "永泰县",
			"zipcode": "350700"
		}, {
			"id": 1472,
			"name": "平潭县",
			"zipcode": "350400"
		}, {
			"id": 1473,
			"name": "福清市",
			"zipcode": "350300"
		}, {
			"id": 1474,
			"name": "长乐市",
			"zipcode": "350200"
		}]
	}, {
		"id": 151,
		"name": "厦门市",
		"child": [{
			"id": 1475,
			"name": "思明区",
			"zipcode": "361001"
		}, {
			"id": 1476,
			"name": "海沧区",
			"zipcode": "361026"
		}, {
			"id": 1477,
			"name": "湖里区",
			"zipcode": "361006"
		}, {
			"id": 1478,
			"name": "集美区",
			"zipcode": "361021"
		}, {
			"id": 1479,
			"name": "同安区",
			"zipcode": "361100"
		}, {
			"id": 1480,
			"name": "翔安区",
			"zipcode": "361101"
		}, {
			"id": 1481,
			"name": "鼓浪屿区",
			"zipcode": "361002"
		}, {
			"id": 1482,
			"name": "象屿保税区",
			"zipcode": "361006"
		}, {
			"id": 1483,
			"name": "火炬高新区",
			"zipcode": "361006"
		}]
	}, {
		"id": 152,
		"name": "莆田市",
		"child": [{
			"id": 1485,
			"name": "城厢区",
			"zipcode": "351100"
		}, {
			"id": 1486,
			"name": "涵江区",
			"zipcode": "351111"
		}, {
			"id": 1487,
			"name": "荔城区",
			"zipcode": "351100"
		}, {
			"id": 1488,
			"name": "秀屿区",
			"zipcode": "351152"
		}, {
			"id": 1489,
			"name": "仙游县",
			"zipcode": "351200"
		}]
	}, {
		"id": 153,
		"name": "三明市",
		"child": [{
			"id": 1490,
			"name": "梅列区",
			"zipcode": "365000"
		}, {
			"id": 1491,
			"name": "三元区",
			"zipcode": "365001"
		}, {
			"id": 1492,
			"name": "明溪县",
			"zipcode": "365200"
		}, {
			"id": 1493,
			"name": "清流县",
			"zipcode": "365300"
		}, {
			"id": 1494,
			"name": "宁化县",
			"zipcode": "365400"
		}, {
			"id": 1495,
			"name": "大田县",
			"zipcode": "366100"
		}, {
			"id": 1496,
			"name": "尤溪县",
			"zipcode": "365100"
		}, {
			"id": 1497,
			"name": "沙县",
			"zipcode": "365500"
		}, {
			"id": 1498,
			"name": "将乐县",
			"zipcode": "353300"
		}, {
			"id": 1499,
			"name": "泰宁县",
			"zipcode": "354400"
		}, {
			"id": 1500,
			"name": "建宁县",
			"zipcode": "354500"
		}, {
			"id": 1501,
			"name": "永安市",
			"zipcode": "366000"
		}]
	}, {
		"id": 154,
		"name": "泉州市",
		"child": [{
			"id": 1502,
			"name": "鲤城区",
			"zipcode": "362000"
		}, {
			"id": 1503,
			"name": "丰泽区",
			"zipcode": "362000"
		}, {
			"id": 1504,
			"name": "洛江区",
			"zipcode": "362011"
		}, {
			"id": 1505,
			"name": "泉港区",
			"zipcode": "362114"
		}, {
			"id": 1506,
			"name": "惠安县",
			"zipcode": "362100"
		}, {
			"id": 1507,
			"name": "安溪县",
			"zipcode": "362400"
		}, {
			"id": 1508,
			"name": "永春县",
			"zipcode": "362600"
		}, {
			"id": 1509,
			"name": "德化县",
			"zipcode": "362500"
		}, {
			"id": 1510,
			"name": "金门县",
			"zipcode": "362000"
		}, {
			"id": 1511,
			"name": "石狮市",
			"zipcode": "362700"
		}, {
			"id": 1512,
			"name": "晋江市",
			"zipcode": "362200"
		}, {
			"id": 1513,
			"name": "南安市",
			"zipcode": "362300"
		}, {
			"id": 1514,
			"name": "经济技术开发区",
			"zipcode": "362005"
		}]
	}, {
		"id": 155,
		"name": "漳州市",
		"child": [{
			"id": 1515,
			"name": "芗城区",
			"zipcode": "363000"
		}, {
			"id": 1516,
			"name": "龙文区",
			"zipcode": "363005"
		}, {
			"id": 1517,
			"name": "云霄县",
			"zipcode": "363300"
		}, {
			"id": 1518,
			"name": "漳浦县",
			"zipcode": "363200"
		}, {
			"id": 1519,
			"name": "诏安县",
			"zipcode": "363500"
		}, {
			"id": 1520,
			"name": "长泰县",
			"zipcode": "363900"
		}, {
			"id": 1521,
			"name": "东山县",
			"zipcode": "363400"
		}, {
			"id": 1522,
			"name": "南靖县",
			"zipcode": "363600"
		}, {
			"id": 1523,
			"name": "平和县",
			"zipcode": "363700"
		}, {
			"id": 1524,
			"name": "华安县",
			"zipcode": "363800"
		}, {
			"id": 1525,
			"name": "龙海市",
			"zipcode": "363100"
		}]
	}, {
		"id": 156,
		"name": "南平市",
		"child": [{
			"id": 1526,
			"name": "延平区",
			"zipcode": "353000"
		}, {
			"id": 1527,
			"name": "顺昌县",
			"zipcode": "353200"
		}, {
			"id": 1528,
			"name": "浦城县",
			"zipcode": "353400"
		}, {
			"id": 1529,
			"name": "光泽县",
			"zipcode": "354100"
		}, {
			"id": 1530,
			"name": "松溪县",
			"zipcode": "353500"
		}, {
			"id": 1531,
			"name": "政和县",
			"zipcode": "353600"
		}, {
			"id": 1532,
			"name": "邵武市",
			"zipcode": "354000"
		}, {
			"id": 1533,
			"name": "武夷山市",
			"zipcode": "354300"
		}, {
			"id": 1534,
			"name": "建瓯市",
			"zipcode": "353100"
		}, {
			"id": 1535,
			"name": "建阳市",
			"zipcode": "354200"
		}]
	}, {
		"id": 157,
		"name": "龙岩市",
		"child": [{
			"id": 1536,
			"name": "新罗区",
			"zipcode": "364000"
		}, {
			"id": 1537,
			"name": "长汀县",
			"zipcode": "366300"
		}, {
			"id": 1538,
			"name": "永定县",
			"zipcode": "364100"
		}, {
			"id": 1539,
			"name": "上杭县",
			"zipcode": "364200"
		}, {
			"id": 1540,
			"name": "武平县",
			"zipcode": "364300"
		}, {
			"id": 1541,
			"name": "连城县",
			"zipcode": "366200"
		}, {
			"id": 1542,
			"name": "漳平市",
			"zipcode": "364400"
		}]
	}, {
		"id": 158,
		"name": "宁德市",
		"child": [{
			"id": 1543,
			"name": "蕉城区",
			"zipcode": "352100"
		}, {
			"id": 1544,
			"name": "霞浦县",
			"zipcode": "355100"
		}, {
			"id": 1545,
			"name": "古田县",
			"zipcode": "352200"
		}, {
			"id": 1546,
			"name": "屏南县",
			"zipcode": "352300"
		}, {
			"id": 1547,
			"name": "寿宁县",
			"zipcode": "355500"
		}, {
			"id": 1548,
			"name": "周宁县",
			"zipcode": "355400"
		}, {
			"id": 1549,
			"name": "柘荣县",
			"zipcode": "355300"
		}, {
			"id": 1550,
			"name": "福安市",
			"zipcode": "355000"
		}, {
			"id": 1551,
			"name": "福鼎市",
			"zipcode": "355200"
		}]
	}]
}, {
	"id": 15,
	"name": "江西",
	"child": [{
		"id": 159,
		"name": "南昌市",
		"child": [{
			"id": 1552,
			"name": "东湖区",
			"zipcode": "330006"
		}, {
			"id": 1553,
			"name": "西湖区",
			"zipcode": "330009"
		}, {
			"id": 1554,
			"name": "青云谱区",
			"zipcode": "330001"
		}, {
			"id": 1555,
			"name": "湾里区",
			"zipcode": "330004"
		}, {
			"id": 1556,
			"name": "青山湖区",
			"zipcode": "330029"
		}, {
			"id": 1557,
			"name": "南昌县",
			"zipcode": "330200"
		}, {
			"id": 1558,
			"name": "新建县",
			"zipcode": "330100"
		}, {
			"id": 1559,
			"name": "安义县",
			"zipcode": "330500"
		}, {
			"id": 1560,
			"name": "进贤县",
			"zipcode": "331700"
		}, {
			"id": 1561,
			"name": "经济技术开发区",
			"zipcode": "330013"
		}, {
			"id": 1562,
			"name": "红谷滩新区",
			"zipcode": "330038"
		}, {
			"id": 1563,
			"name": "高新技术产业开发区",
			"zipcode": "330029"
		}, {
			"id": 1564,
			"name": "桑海经济技术开发区",
			"zipcode": "330115"
		}, {
			"id": 1565,
			"name": "英雄经济开发区",
			"zipcode": "330200"
		}]
	}, {
		"id": 160,
		"name": "景德镇市",
		"child": [{
			"id": 1566,
			"name": "昌江区",
			"zipcode": "333000"
		}, {
			"id": 1567,
			"name": "珠山区",
			"zipcode": "333000"
		}, {
			"id": 1568,
			"name": "浮梁县",
			"zipcode": "333400"
		}, {
			"id": 1569,
			"name": "乐平市",
			"zipcode": "333300"
		}]
	}, {
		"id": 161,
		"name": "萍乡市",
		"child": [{
			"id": 1570,
			"name": "安源区",
			"zipcode": "337000"
		}, {
			"id": 1571,
			"name": "湘东区",
			"zipcode": "337016"
		}, {
			"id": 1572,
			"name": "莲花县",
			"zipcode": "337100"
		}, {
			"id": 1573,
			"name": "上栗县",
			"zipcode": "337009"
		}, {
			"id": 1574,
			"name": "芦溪县",
			"zipcode": "337053"
		}]
	}, {
		"id": 162,
		"name": "九江市",
		"child": [{
			"id": 1575,
			"name": "庐山区",
			"zipcode": "332005"
		}, {
			"id": 1576,
			"name": "浔阳区",
			"zipcode": "332000"
		}, {
			"id": 1577,
			"name": "九江县",
			"zipcode": "332100"
		}, {
			"id": 1578,
			"name": "武宁县",
			"zipcode": "332300"
		}, {
			"id": 1579,
			"name": "修水县",
			"zipcode": "332400"
		}, {
			"id": 1580,
			"name": "永修县",
			"zipcode": "330300"
		}, {
			"id": 1581,
			"name": "德安县",
			"zipcode": "330400"
		}, {
			"id": 1582,
			"name": "星子县",
			"zipcode": "332800"
		}, {
			"id": 1583,
			"name": "都昌县",
			"zipcode": "332600"
		}, {
			"id": 1584,
			"name": "湖口县",
			"zipcode": "332500"
		}, {
			"id": 1585,
			"name": "彭泽县",
			"zipcode": "332700"
		}, {
			"id": 1586,
			"name": "瑞昌市",
			"zipcode": "332200"
		}, {
			"id": 3380,
			"name": "共青城市",
			"zipcode": "332020"
		}]
	}, {
		"id": 163,
		"name": "新余市",
		"child": [{
			"id": 1587,
			"name": "渝水区",
			"zipcode": "338025"
		}, {
			"id": 1588,
			"name": "分宜县",
			"zipcode": "336600"
		}]
	}, {
		"id": 164,
		"name": "鹰潭市",
		"child": [{
			"id": 1589,
			"name": "月湖区",
			"zipcode": "335000"
		}, {
			"id": 1590,
			"name": "余江县",
			"zipcode": "335200"
		}, {
			"id": 1591,
			"name": "贵溪市",
			"zipcode": "335400"
		}]
	}, {
		"id": 165,
		"name": "赣州市",
		"child": [{
			"id": 1592,
			"name": "章贡区",
			"zipcode": "341000"
		}, {
			"id": 1593,
			"name": "赣县",
			"zipcode": "341100"
		}, {
			"id": 1594,
			"name": "信丰县",
			"zipcode": "341600"
		}, {
			"id": 1595,
			"name": "大余县",
			"zipcode": "341500"
		}, {
			"id": 1596,
			"name": "上犹县",
			"zipcode": "341200"
		}, {
			"id": 1597,
			"name": "崇义县",
			"zipcode": "341300"
		}, {
			"id": 1598,
			"name": "安远县",
			"zipcode": "342100"
		}, {
			"id": 1599,
			"name": "龙南县",
			"zipcode": "341700"
		}, {
			"id": 1600,
			"name": "定南县",
			"zipcode": "341900"
		}, {
			"id": 1601,
			"name": "全南县",
			"zipcode": "341800"
		}, {
			"id": 1602,
			"name": "宁都县",
			"zipcode": "342800"
		}, {
			"id": 1603,
			"name": "于都县",
			"zipcode": "342300"
		}, {
			"id": 1604,
			"name": "兴国县",
			"zipcode": "342400"
		}, {
			"id": 1605,
			"name": "会昌县",
			"zipcode": "342600"
		}, {
			"id": 1606,
			"name": "寻乌县",
			"zipcode": "342200"
		}, {
			"id": 1607,
			"name": "石城县",
			"zipcode": "342700"
		}, {
			"id": 1608,
			"name": "瑞金市",
			"zipcode": "342500"
		}, {
			"id": 1609,
			"name": "南康市",
			"zipcode": "341400"
		}]
	}, {
		"id": 166,
		"name": "吉安市",
		"child": [{
			"id": 1610,
			"name": "吉州区",
			"zipcode": "343000"
		}, {
			"id": 1611,
			"name": "青原区",
			"zipcode": "343009"
		}, {
			"id": 1612,
			"name": "吉安县",
			"zipcode": "343100"
		}, {
			"id": 1613,
			"name": "吉水县",
			"zipcode": "331600"
		}, {
			"id": 1614,
			"name": "峡江县",
			"zipcode": "331400"
		}, {
			"id": 1615,
			"name": "新干县",
			"zipcode": "331300"
		}, {
			"id": 1616,
			"name": "永丰县",
			"zipcode": "331500"
		}, {
			"id": 1617,
			"name": "泰和县",
			"zipcode": "343700"
		}, {
			"id": 1618,
			"name": "遂川县",
			"zipcode": "343900"
		}, {
			"id": 1619,
			"name": "万安县",
			"zipcode": "343800"
		}, {
			"id": 1620,
			"name": "安福县",
			"zipcode": "343200"
		}, {
			"id": 1621,
			"name": "永新县",
			"zipcode": "343400"
		}, {
			"id": 1622,
			"name": "井冈山市",
			"zipcode": "343600"
		}]
	}, {
		"id": 167,
		"name": "宜春市",
		"child": [{
			"id": 1623,
			"name": "袁州区",
			"zipcode": "336000"
		}, {
			"id": 1624,
			"name": "奉新县",
			"zipcode": "330700"
		}, {
			"id": 1625,
			"name": "万载县",
			"zipcode": "336100"
		}, {
			"id": 1626,
			"name": "上高县",
			"zipcode": "336400"
		}, {
			"id": 1627,
			"name": "宜丰县",
			"zipcode": "336300"
		}, {
			"id": 1628,
			"name": "靖安县",
			"zipcode": "330600"
		}, {
			"id": 1629,
			"name": "铜鼓县",
			"zipcode": "336200"
		}, {
			"id": 1630,
			"name": "丰城市",
			"zipcode": "331100"
		}, {
			"id": 1631,
			"name": "樟树市",
			"zipcode": "331200"
		}, {
			"id": 1632,
			"name": "高安市",
			"zipcode": "330800"
		}]
	}, {
		"id": 168,
		"name": "抚州市",
		"child": [{
			"id": 1633,
			"name": "临川区",
			"zipcode": "344100"
		}, {
			"id": 1634,
			"name": "南城县",
			"zipcode": "344700"
		}, {
			"id": 1635,
			"name": "黎川县",
			"zipcode": "344600"
		}, {
			"id": 1636,
			"name": "南丰县",
			"zipcode": "344500"
		}, {
			"id": 1637,
			"name": "崇仁县",
			"zipcode": "344200"
		}, {
			"id": 1638,
			"name": "乐安县",
			"zipcode": "344300"
		}, {
			"id": 1639,
			"name": "宜黄县",
			"zipcode": "344400"
		}, {
			"id": 1640,
			"name": "金溪县",
			"zipcode": "344800"
		}, {
			"id": 1641,
			"name": "资溪县",
			"zipcode": "335300"
		}, {
			"id": 1642,
			"name": "东乡县",
			"zipcode": "331800"
		}, {
			"id": 1643,
			"name": "广昌县",
			"zipcode": "344900"
		}]
	}, {
		"id": 169,
		"name": "上饶市",
		"child": [{
			"id": 1644,
			"name": "信州区",
			"zipcode": "334000"
		}, {
			"id": 1645,
			"name": "上饶县",
			"zipcode": "334100"
		}, {
			"id": 1646,
			"name": "广丰县",
			"zipcode": "334600"
		}, {
			"id": 1647,
			"name": "玉山县",
			"zipcode": "334700"
		}, {
			"id": 1648,
			"name": "铅山县",
			"zipcode": "334500"
		}, {
			"id": 1649,
			"name": "横峰县",
			"zipcode": "334300"
		}, {
			"id": 1650,
			"name": "弋阳县",
			"zipcode": "334400"
		}, {
			"id": 1651,
			"name": "余干县",
			"zipcode": "335100"
		}, {
			"id": 1652,
			"name": "鄱阳县",
			"zipcode": "333100"
		}, {
			"id": 1653,
			"name": "万年县",
			"zipcode": "335500"
		}, {
			"id": 1654,
			"name": "婺源县",
			"zipcode": "333200"
		}, {
			"id": 1655,
			"name": "德兴市",
			"zipcode": "334200"
		}]
	}]
}, {
	"id": 16,
	"name": "山东",
	"child": [{
		"id": 170,
		"name": "济南市",
		"child": [{
			"id": 1656,
			"name": "历下区",
			"zipcode": "250014"
		}, {
			"id": 1657,
			"name": "市中区",
			"zipcode": "250001"
		}, {
			"id": 1658,
			"name": "槐荫区",
			"zipcode": "250022"
		}, {
			"id": 1659,
			"name": "天桥区",
			"zipcode": "250031"
		}, {
			"id": 1660,
			"name": "历城区",
			"zipcode": "250100"
		}, {
			"id": 1661,
			"name": "长清区",
			"zipcode": "250300"
		}, {
			"id": 1662,
			"name": "平阴县",
			"zipcode": "250400"
		}, {
			"id": 1663,
			"name": "济阳县",
			"zipcode": "251400"
		}, {
			"id": 1664,
			"name": "商河县",
			"zipcode": "251600"
		}, {
			"id": 1665,
			"name": "章丘市",
			"zipcode": "250200"
		}, {
			"id": 1666,
			"name": "高新区",
			"zipcode": "250101"
		}, {
			"id": 1667,
			"name": "经济开发区",
			"zipcode": "250300"
		}]
	}, {
		"id": 171,
		"name": "青岛市",
		"child": [{
			"id": 1668,
			"name": "市南区",
			"zipcode": "266001"
		}, {
			"id": 1669,
			"name": "市北区",
			"zipcode": "266011"
		}, {
			"id": 1670,
			"name": "四方区",
			"zipcode": "266031"
		}, {
			"id": 1671,
			"name": "黄岛区",
			"zipcode": "266500"
		}, {
			"id": 1672,
			"name": "崂山区",
			"zipcode": "266100"
		}, {
			"id": 1673,
			"name": "李沧区",
			"zipcode": "266021"
		}, {
			"id": 1674,
			"name": "城阳区",
			"zipcode": "266041"
		}, {
			"id": 1675,
			"name": "胶州市",
			"zipcode": "266300"
		}, {
			"id": 1676,
			"name": "即墨市",
			"zipcode": "266200"
		}, {
			"id": 1677,
			"name": "平度市",
			"zipcode": "266700"
		}, {
			"id": 1678,
			"name": "胶南市",
			"zipcode": "266400"
		}, {
			"id": 1679,
			"name": "莱西市",
			"zipcode": "266600"
		}]
	}, {
		"id": 172,
		"name": "淄博市",
		"child": [{
			"id": 1680,
			"name": "淄川区",
			"zipcode": "255100"
		}, {
			"id": 1681,
			"name": "张店区",
			"zipcode": "255022"
		}, {
			"id": 1682,
			"name": "博山区",
			"zipcode": "255200"
		}, {
			"id": 1683,
			"name": "临淄区",
			"zipcode": "255400"
		}, {
			"id": 1684,
			"name": "周村区",
			"zipcode": "255300"
		}, {
			"id": 1685,
			"name": "桓台县",
			"zipcode": "256400"
		}, {
			"id": 1686,
			"name": "高青县",
			"zipcode": "256300"
		}, {
			"id": 1687,
			"name": "沂源县",
			"zipcode": "256100"
		}, {
			"id": 1688,
			"name": "高新区",
			"zipcode": "255086"
		}]
	}, {
		"id": 173,
		"name": "枣庄市",
		"child": [{
			"id": 1689,
			"name": "市中区",
			"zipcode": "277101"
		}, {
			"id": 1690,
			"name": "薛城区",
			"zipcode": "277000"
		}, {
			"id": 1691,
			"name": "峄城区",
			"zipcode": "277300"
		}, {
			"id": 1692,
			"name": "台儿庄区",
			"zipcode": "277400"
		}, {
			"id": 1693,
			"name": "山亭区",
			"zipcode": "277200"
		}, {
			"id": 1694,
			"name": "滕州市",
			"zipcode": "277500"
		}]
	}, {
		"id": 174,
		"name": "东营市",
		"child": [{
			"id": 1695,
			"name": "东营区",
			"zipcode": "257029"
		}, {
			"id": 1696,
			"name": "河口区",
			"zipcode": "257200"
		}, {
			"id": 1697,
			"name": "垦利县",
			"zipcode": "257500"
		}, {
			"id": 1698,
			"name": "利津县",
			"zipcode": "257400"
		}, {
			"id": 1699,
			"name": "广饶县",
			"zipcode": "257300"
		}]
	}, {
		"id": 175,
		"name": "烟台市",
		"child": [{
			"id": 1700,
			"name": "芝罘区",
			"zipcode": "264001"
		}, {
			"id": 1701,
			"name": "福山区",
			"zipcode": "265500"
		}, {
			"id": 1702,
			"name": "牟平区",
			"zipcode": "264100"
		}, {
			"id": 1703,
			"name": "莱山区",
			"zipcode": "264600"
		}, {
			"id": 1704,
			"name": "长岛县",
			"zipcode": "265800"
		}, {
			"id": 1705,
			"name": "龙口市",
			"zipcode": "265700"
		}, {
			"id": 1706,
			"name": "莱阳市",
			"zipcode": "265200"
		}, {
			"id": 1707,
			"name": "莱州市",
			"zipcode": "261400"
		}, {
			"id": 1708,
			"name": "蓬莱市",
			"zipcode": "265600"
		}, {
			"id": 1709,
			"name": "招远市",
			"zipcode": "265400"
		}, {
			"id": 1710,
			"name": "栖霞市",
			"zipcode": "265300"
		}, {
			"id": 1711,
			"name": "海阳市",
			"zipcode": "265100"
		}, {
			"id": 1712,
			"name": "高新区",
			"zipcode": "264006"
		}]
	}, {
		"id": 176,
		"name": "潍坊市",
		"child": [{
			"id": 1713,
			"name": "潍城区",
			"zipcode": "261021"
		}, {
			"id": 1714,
			"name": "寒亭区",
			"zipcode": "261100"
		}, {
			"id": 1715,
			"name": "坊子区",
			"zipcode": "261200"
		}, {
			"id": 1716,
			"name": "奎文区",
			"zipcode": "261031"
		}, {
			"id": 1717,
			"name": "临朐县",
			"zipcode": "262600"
		}, {
			"id": 1718,
			"name": "昌乐县",
			"zipcode": "262400"
		}, {
			"id": 1719,
			"name": "青州市",
			"zipcode": "262500"
		}, {
			"id": 1720,
			"name": "诸城市",
			"zipcode": "262200"
		}, {
			"id": 1721,
			"name": "寿光市",
			"zipcode": "262700"
		}, {
			"id": 1722,
			"name": "安丘市",
			"zipcode": "262100"
		}, {
			"id": 1723,
			"name": "高密市",
			"zipcode": "261500"
		}, {
			"id": 1724,
			"name": "昌邑市",
			"zipcode": "261300"
		}, {
			"id": 1725,
			"name": "经济开发区",
			"zipcode": "261061"
		}, {
			"id": 1726,
			"name": "滨海经济开发区",
			"zipcode": "262737"
		}, {
			"id": 1727,
			"name": "高新技术开发区",
			"zipcode": "261061"
		}, {
			"id": 1728,
			"name": "出口加工区",
			"zipcode": "261205"
		}]
	}, {
		"id": 177,
		"name": "济宁市",
		"child": [{
			"id": 1729,
			"name": "市中区",
			"zipcode": "272133"
		}, {
			"id": 1730,
			"name": "任城区",
			"zipcode": "272113"
		}, {
			"id": 1731,
			"name": "微山县",
			"zipcode": "277600"
		}, {
			"id": 1732,
			"name": "鱼台县",
			"zipcode": "272300"
		}, {
			"id": 1733,
			"name": "金乡县",
			"zipcode": "272200"
		}, {
			"id": 1734,
			"name": "嘉祥县",
			"zipcode": "272400"
		}, {
			"id": 1735,
			"name": "汶上县",
			"zipcode": "272501"
		}, {
			"id": 1736,
			"name": "泗水县",
			"zipcode": "273200"
		}, {
			"id": 1737,
			"name": "梁山县",
			"zipcode": "272600"
		}, {
			"id": 1738,
			"name": "曲阜市",
			"zipcode": "273100"
		}, {
			"id": 1739,
			"name": "兖州市",
			"zipcode": "272000"
		}, {
			"id": 1740,
			"name": "邹城市",
			"zipcode": "273500"
		}]
	}, {
		"id": 178,
		"name": "泰安市",
		"child": [{
			"id": 1741,
			"name": "泰山区",
			"zipcode": "271000"
		}, {
			"id": 1742,
			"name": "岱岳区",
			"zipcode": "271000"
		}, {
			"id": 1743,
			"name": "宁阳县",
			"zipcode": "271400"
		}, {
			"id": 1744,
			"name": "东平县",
			"zipcode": "271500"
		}, {
			"id": 1745,
			"name": "新泰市",
			"zipcode": "271200"
		}, {
			"id": 1746,
			"name": "肥城市",
			"zipcode": "271600"
		}]
	}, {
		"id": 179,
		"name": "威海市",
		"child": [{
			"id": 1747,
			"name": "环翠区",
			"zipcode": "264200"
		}, {
			"id": 1748,
			"name": "文登市",
			"zipcode": "264400"
		}, {
			"id": 1749,
			"name": "荣成市",
			"zipcode": "264300"
		}, {
			"id": 1750,
			"name": "乳山市",
			"zipcode": "264500"
		}, {
			"id": 1751,
			"name": "经济技术开发区",
			"zipcode": "264205"
		}, {
			"id": 1752,
			"name": "高新技术开发区",
			"zipcode": "264209"
		}]
	}, {
		"id": 180,
		"name": "日照市",
		"child": [{
			"id": 1753,
			"name": "东港区",
			"zipcode": "276800"
		}, {
			"id": 1754,
			"name": "岚山区",
			"zipcode": "276808"
		}, {
			"id": 1755,
			"name": "五莲县",
			"zipcode": "272300"
		}, {
			"id": 1756,
			"name": "莒县",
			"zipcode": "266500"
		}]
	}, {
		"id": 181,
		"name": "莱芜市",
		"child": [{
			"id": 1757,
			"name": "莱城区",
			"zipcode": "271100"
		}, {
			"id": 1758,
			"name": "钢城区",
			"zipcode": "271100"
		}]
	}, {
		"id": 182,
		"name": "临沂市",
		"child": [{
			"id": 1759,
			"name": "兰山区",
			"zipcode": "276002"
		}, {
			"id": 1760,
			"name": "罗庄区",
			"zipcode": "276022"
		}, {
			"id": 1761,
			"name": "河东区",
			"zipcode": "276034"
		}, {
			"id": 1762,
			"name": "沂南县",
			"zipcode": "276300"
		}, {
			"id": 1763,
			"name": "郯城县",
			"zipcode": "276100"
		}, {
			"id": 1764,
			"name": "沂水县",
			"zipcode": "276400"
		}, {
			"id": 1765,
			"name": "苍山县",
			"zipcode": "277700"
		}, {
			"id": 1766,
			"name": "费县",
			"zipcode": "273400"
		}, {
			"id": 1767,
			"name": "平邑县",
			"zipcode": "273300"
		}, {
			"id": 1768,
			"name": "莒南县",
			"zipcode": "276600"
		}, {
			"id": 1769,
			"name": "蒙阴县",
			"zipcode": "276200"
		}, {
			"id": 1770,
			"name": "临沭县",
			"zipcode": "276700"
		}]
	}, {
		"id": 183,
		"name": "德州市",
		"child": [{
			"id": 1771,
			"name": "德城区",
			"zipcode": "253011"
		}, {
			"id": 1772,
			"name": "陵县",
			"zipcode": "253500"
		}, {
			"id": 1773,
			"name": "宁津县",
			"zipcode": "253400"
		}, {
			"id": 1774,
			"name": "庆云县",
			"zipcode": "253700"
		}, {
			"id": 1775,
			"name": "临邑县",
			"zipcode": "251500"
		}, {
			"id": 1776,
			"name": "齐河县",
			"zipcode": "251100"
		}, {
			"id": 1777,
			"name": "平原县",
			"zipcode": "253100"
		}, {
			"id": 1778,
			"name": "夏津县",
			"zipcode": "253200"
		}, {
			"id": 1779,
			"name": "武城县",
			"zipcode": "253300"
		}, {
			"id": 1780,
			"name": "乐陵市",
			"zipcode": "253600"
		}, {
			"id": 1781,
			"name": "禹城市",
			"zipcode": "251200"
		}]
	}, {
		"id": 184,
		"name": "聊城市",
		"child": [{
			"id": 1782,
			"name": "东昌府区",
			"zipcode": "252000"
		}, {
			"id": 1783,
			"name": "阳谷县",
			"zipcode": "252300"
		}, {
			"id": 1784,
			"name": "莘县",
			"zipcode": "252400"
		}, {
			"id": 1785,
			"name": "茌平县",
			"zipcode": "252100"
		}, {
			"id": 1786,
			"name": "东阿县",
			"zipcode": "252200"
		}, {
			"id": 1787,
			"name": "冠县",
			"zipcode": "252500"
		}, {
			"id": 1788,
			"name": "高唐县",
			"zipcode": "252800"
		}, {
			"id": 1789,
			"name": "临清市",
			"zipcode": "252600"
		}]
	}, {
		"id": 185,
		"name": "滨州市",
		"child": [{
			"id": 1790,
			"name": "滨城区",
			"zipcode": "256613"
		}, {
			"id": 1791,
			"name": "惠民县",
			"zipcode": "251700"
		}, {
			"id": 1792,
			"name": "阳信县",
			"zipcode": "251800"
		}, {
			"id": 1793,
			"name": "无棣县",
			"zipcode": "251900"
		}, {
			"id": 1794,
			"name": "沾化县",
			"zipcode": "256800"
		}, {
			"id": 1795,
			"name": "博兴县",
			"zipcode": "256500"
		}, {
			"id": 1796,
			"name": "邹平县",
			"zipcode": "256200"
		}]
	}, {
		"id": 186,
		"name": "菏泽市",
		"child": [{
			"id": 1797,
			"name": "牡丹区",
			"zipcode": "274009"
		}, {
			"id": 1798,
			"name": "曹县",
			"zipcode": "274400"
		}, {
			"id": 1799,
			"name": "单县",
			"zipcode": "274300"
		}, {
			"id": 1800,
			"name": "成武县",
			"zipcode": "274200"
		}, {
			"id": 1801,
			"name": "巨野县",
			"zipcode": "274900"
		}, {
			"id": 1802,
			"name": "郓城县",
			"zipcode": "274700"
		}, {
			"id": 1803,
			"name": "鄄城县",
			"zipcode": "274600"
		}, {
			"id": 1804,
			"name": "定陶县",
			"zipcode": "274100"
		}, {
			"id": 1805,
			"name": "东明县",
			"zipcode": "274500"
		}]
	}]
}, {
	"id": 17,
	"name": "河南",
	"child": [{
		"id": 187,
		"name": "郑州市",
		"child": [{
			"id": 1806,
			"name": "中原区",
			"zipcode": "450007"
		}, {
			"id": 1807,
			"name": "二七区",
			"zipcode": "450052"
		}, {
			"id": 1808,
			"name": "管城回族区",
			"zipcode": "450000"
		}, {
			"id": 1809,
			"name": "金水区",
			"zipcode": "450003"
		}, {
			"id": 1810,
			"name": "上街区",
			"zipcode": "450041"
		}, {
			"id": 1811,
			"name": "中牟县",
			"zipcode": "451450"
		}, {
			"id": 1812,
			"name": "巩义市",
			"zipcode": "451200"
		}, {
			"id": 1813,
			"name": "荥阳市",
			"zipcode": "450100"
		}, {
			"id": 1814,
			"name": "新密市",
			"zipcode": "452300"
		}, {
			"id": 1815,
			"name": "新郑市",
			"zipcode": "451100"
		}, {
			"id": 1816,
			"name": "登封市",
			"zipcode": "452470"
		}, {
			"id": 1817,
			"name": "高新技术开发区",
			"zipcode": "450001"
		}, {
			"id": 1818,
			"name": "惠济区",
			"zipcode": "450053"
		}, {
			"id": 1819,
			"name": "经济技术开发区",
			"zipcode": "450016"
		}, {
			"id": 1820,
			"name": "郑东新区",
			"zipcode": "450008"
		}, {
			"id": 1821,
			"name": "出口加工区",
			"zipcode": "450016"
		}]
	}, {
		"id": 188,
		"name": "开封市",
		"child": [{
			"id": 1822,
			"name": "龙亭区",
			"zipcode": "475100"
		}, {
			"id": 1823,
			"name": "顺河回族区",
			"zipcode": "475000"
		}, {
			"id": 1824,
			"name": "鼓楼区",
			"zipcode": "475000"
		}, {
			"id": 1825,
			"name": "杞县",
			"zipcode": "475200"
		}, {
			"id": 1826,
			"name": "通许县",
			"zipcode": "475400"
		}, {
			"id": 1827,
			"name": "尉氏县",
			"zipcode": "475500"
		}, {
			"id": 1828,
			"name": "开封县",
			"zipcode": "475100"
		}, {
			"id": 1829,
			"name": "兰考县",
			"zipcode": "475300"
		}, {
			"id": 1830,
			"name": "金明区",
			"zipcode": "475003"
		}, {
			"id": 1831,
			"name": "禹王台区",
			"zipcode": "475003"
		}]
	}, {
		"id": 189,
		"name": "洛阳市",
		"child": [{
			"id": 1832,
			"name": "老城区",
			"zipcode": "471002"
		}, {
			"id": 1833,
			"name": "西工区",
			"zipcode": "471000"
		}, {
			"id": 1834,
			"name": "瀍河回族区",
			"zipcode": "471002"
		}, {
			"id": 1835,
			"name": "涧西区",
			"zipcode": "471003"
		}, {
			"id": 1836,
			"name": "吉利区",
			"zipcode": "471012"
		}, {
			"id": 1837,
			"name": "洛龙区",
			"zipcode": "471000"
		}, {
			"id": 1838,
			"name": "孟津县",
			"zipcode": "471100"
		}, {
			"id": 1839,
			"name": "新安县",
			"zipcode": "471800"
		}, {
			"id": 1840,
			"name": "栾川县",
			"zipcode": "471500"
		}, {
			"id": 1841,
			"name": "嵩县",
			"zipcode": "471400"
		}, {
			"id": 1842,
			"name": "汝阳县",
			"zipcode": "471200"
		}, {
			"id": 1843,
			"name": "宜阳县",
			"zipcode": "471600"
		}, {
			"id": 1844,
			"name": "洛宁县",
			"zipcode": "471700"
		}, {
			"id": 1845,
			"name": "伊川县",
			"zipcode": "471300"
		}, {
			"id": 1846,
			"name": "偃师市",
			"zipcode": "471900"
		}, {
			"id": 1847,
			"name": "高新技术开发区",
			"zipcode": "471003"
		}, {
			"id": 1848,
			"name": "经济技术开发区",
			"zipcode": "471023"
		}]
	}, {
		"id": 190,
		"name": "平顶山市",
		"child": [{
			"id": 1849,
			"name": "新华区",
			"zipcode": "467002"
		}, {
			"id": 1850,
			"name": "卫东区",
			"zipcode": "467021"
		}, {
			"id": 1851,
			"name": "石龙区",
			"zipcode": "467045"
		}, {
			"id": 1852,
			"name": "湛河区",
			"zipcode": "467000"
		}, {
			"id": 1853,
			"name": "宝丰县",
			"zipcode": "467400"
		}, {
			"id": 1854,
			"name": "叶县",
			"zipcode": "467200"
		}, {
			"id": 1855,
			"name": "鲁山县",
			"zipcode": "467300"
		}, {
			"id": 1856,
			"name": "郏县",
			"zipcode": "467100"
		}, {
			"id": 1857,
			"name": "舞钢市",
			"zipcode": "462500"
		}, {
			"id": 1858,
			"name": "汝州市",
			"zipcode": "467500"
		}]
	}, {
		"id": 191,
		"name": "安阳市",
		"child": [{
			"id": 1859,
			"name": "文峰区",
			"zipcode": "455000"
		}, {
			"id": 1860,
			"name": "北关区",
			"zipcode": "455001"
		}, {
			"id": 1861,
			"name": "殷都区",
			"zipcode": "455004"
		}, {
			"id": 1862,
			"name": "龙安区",
			"zipcode": "455001"
		}, {
			"id": 1863,
			"name": "安阳县",
			"zipcode": "455000"
		}, {
			"id": 1864,
			"name": "汤阴县",
			"zipcode": "456150"
		}, {
			"id": 1865,
			"name": "滑县",
			"zipcode": "456400"
		}, {
			"id": 1866,
			"name": "内黄县",
			"zipcode": "456350"
		}, {
			"id": 1867,
			"name": "林州市",
			"zipcode": "456500"
		}]
	}, {
		"id": 192,
		"name": "鹤壁市",
		"child": [{
			"id": 1868,
			"name": "鹤山区",
			"zipcode": "458010"
		}, {
			"id": 1869,
			"name": "山城区",
			"zipcode": "458000"
		}, {
			"id": 1870,
			"name": "淇滨区",
			"zipcode": "458000"
		}, {
			"id": 1871,
			"name": "浚县",
			"zipcode": "456250"
		}, {
			"id": 1872,
			"name": "淇县",
			"zipcode": "456750"
		}]
	}, {
		"id": 193,
		"name": "新乡市",
		"child": [{
			"id": 1873,
			"name": "红旗区",
			"zipcode": "453000"
		}, {
			"id": 1874,
			"name": "卫滨区",
			"zipcode": "453000"
		}, {
			"id": 1875,
			"name": "凤泉区",
			"zipcode": "453011"
		}, {
			"id": 1876,
			"name": "牧野区",
			"zipcode": "453002"
		}, {
			"id": 1877,
			"name": "新乡县",
			"zipcode": "453700"
		}, {
			"id": 1878,
			"name": "获嘉县",
			"zipcode": "453800"
		}, {
			"id": 1879,
			"name": "原阳县",
			"zipcode": "453500"
		}, {
			"id": 1880,
			"name": "延津县",
			"zipcode": "453200"
		}, {
			"id": 1881,
			"name": "封丘县",
			"zipcode": "453300"
		}, {
			"id": 1882,
			"name": "长垣县",
			"zipcode": "453400"
		}, {
			"id": 1883,
			"name": "卫辉市",
			"zipcode": "453100"
		}, {
			"id": 1884,
			"name": "辉县市",
			"zipcode": "453600"
		}]
	}, {
		"id": 194,
		"name": "焦作市",
		"child": [{
			"id": 1885,
			"name": "解放区",
			"zipcode": "454000"
		}, {
			"id": 1886,
			"name": "中站区",
			"zipcode": "454191"
		}, {
			"id": 1887,
			"name": "马村区",
			"zipcode": "454171"
		}, {
			"id": 1888,
			"name": "山阳区",
			"zipcode": "454002"
		}, {
			"id": 1889,
			"name": "修武县",
			"zipcode": "454350"
		}, {
			"id": 1890,
			"name": "博爱县",
			"zipcode": "454450"
		}, {
			"id": 1891,
			"name": "武陟县",
			"zipcode": "454950"
		}, {
			"id": 1892,
			"name": "温县",
			"zipcode": "454850"
		}, {
			"id": 1893,
			"name": "沁阳市",
			"zipcode": "454550"
		}, {
			"id": 1894,
			"name": "孟州市",
			"zipcode": "454750"
		}]
	}, {
		"id": 195,
		"name": "济源市",
		"child": [{
			"id": 1895,
			"name": "济源市",
			"zipcode": "454650"
		}]
	}, {
		"id": 196,
		"name": "濮阳市",
		"child": [{
			"id": 1896,
			"name": "华龙区",
			"zipcode": "457001"
		}, {
			"id": 1897,
			"name": "清丰县",
			"zipcode": "457300"
		}, {
			"id": 1898,
			"name": "南乐县",
			"zipcode": "457400"
		}, {
			"id": 1899,
			"name": "范县",
			"zipcode": "457500"
		}, {
			"id": 1900,
			"name": "台前县",
			"zipcode": "457600"
		}, {
			"id": 1901,
			"name": "濮阳县",
			"zipcode": "457100"
		}]
	}, {
		"id": 197,
		"name": "许昌市",
		"child": [{
			"id": 1902,
			"name": "魏都区",
			"zipcode": "461000"
		}, {
			"id": 1903,
			"name": "许昌县",
			"zipcode": "461100"
		}, {
			"id": 1904,
			"name": "鄢陵县",
			"zipcode": "461200"
		}, {
			"id": 1905,
			"name": "襄城县",
			"zipcode": "461700"
		}, {
			"id": 1906,
			"name": "禹州市",
			"zipcode": "461670"
		}, {
			"id": 1907,
			"name": "长葛市",
			"zipcode": "461500"
		}]
	}, {
		"id": 198,
		"name": "漯河市",
		"child": [{
			"id": 1908,
			"name": "源汇区",
			"zipcode": "462000"
		}, {
			"id": 1909,
			"name": "郾城区",
			"zipcode": "462300"
		}, {
			"id": 1910,
			"name": "召陵区",
			"zipcode": "462300"
		}, {
			"id": 1911,
			"name": "舞阳县",
			"zipcode": "462400"
		}, {
			"id": 1912,
			"name": "临颍县",
			"zipcode": "462600"
		}]
	}, {
		"id": 199,
		"name": "三门峡市",
		"child": [{
			"id": 1913,
			"name": "湖滨区",
			"zipcode": "472000"
		}, {
			"id": 1914,
			"name": "渑池县",
			"zipcode": "472400"
		}, {
			"id": 1915,
			"name": "陕县",
			"zipcode": "472100"
		}, {
			"id": 1916,
			"name": "卢氏县",
			"zipcode": "472200"
		}, {
			"id": 1917,
			"name": "义马市",
			"zipcode": "472300"
		}, {
			"id": 1918,
			"name": "灵宝市",
			"zipcode": "472500"
		}]
	}, {
		"id": 200,
		"name": "南阳市",
		"child": [{
			"id": 1919,
			"name": "宛城区",
			"zipcode": "473001"
		}, {
			"id": 1920,
			"name": "卧龙区",
			"zipcode": "473003"
		}, {
			"id": 1921,
			"name": "南召县",
			"zipcode": "474650"
		}, {
			"id": 1922,
			"name": "方城县",
			"zipcode": "473200"
		}, {
			"id": 1923,
			"name": "西峡县",
			"zipcode": "474550"
		}, {
			"id": 1924,
			"name": "镇平县",
			"zipcode": "474250"
		}, {
			"id": 1925,
			"name": "内乡县",
			"zipcode": "474350"
		}, {
			"id": 1926,
			"name": "淅川县",
			"zipcode": "474450"
		}, {
			"id": 1927,
			"name": "社旗县",
			"zipcode": "473300"
		}, {
			"id": 1928,
			"name": "唐河县",
			"zipcode": "473400"
		}, {
			"id": 1929,
			"name": "新野县",
			"zipcode": "473500"
		}, {
			"id": 1930,
			"name": "桐柏县",
			"zipcode": "474750"
		}, {
			"id": 1931,
			"name": "邓州市",
			"zipcode": "474150"
		}]
	}, {
		"id": 201,
		"name": "商丘市",
		"child": [{
			"id": 1932,
			"name": "梁园区",
			"zipcode": "476000"
		}, {
			"id": 1933,
			"name": "睢阳区",
			"zipcode": "476100"
		}, {
			"id": 1934,
			"name": "民权县",
			"zipcode": "476800"
		}, {
			"id": 1935,
			"name": "睢县",
			"zipcode": "476900"
		}, {
			"id": 1936,
			"name": "宁陵县",
			"zipcode": "476700"
		}, {
			"id": 1937,
			"name": "柘城县",
			"zipcode": "476200"
		}, {
			"id": 1938,
			"name": "虞城县",
			"zipcode": "476300"
		}, {
			"id": 1939,
			"name": "夏邑县",
			"zipcode": "476400"
		}, {
			"id": 1940,
			"name": "永城市",
			"zipcode": "476600"
		}]
	}, {
		"id": 202,
		"name": "信阳市",
		"child": [{
			"id": 1941,
			"name": "浉河区",
			"zipcode": "464000"
		}, {
			"id": 1942,
			"name": "平桥区",
			"zipcode": "464100"
		}, {
			"id": 1943,
			"name": "罗山县",
			"zipcode": "464200"
		}, {
			"id": 1944,
			"name": "光山县",
			"zipcode": "465450"
		}, {
			"id": 1945,
			"name": "新县",
			"zipcode": "465550"
		}, {
			"id": 1946,
			"name": "商城县",
			"zipcode": "465350"
		}, {
			"id": 1947,
			"name": "固始县",
			"zipcode": "465250"
		}, {
			"id": 1948,
			"name": "潢川县",
			"zipcode": "465150"
		}, {
			"id": 1949,
			"name": "淮滨县",
			"zipcode": "464400"
		}, {
			"id": 1950,
			"name": "息县",
			"zipcode": "464300"
		}]
	}, {
		"id": 203,
		"name": "周口市",
		"child": [{
			"id": 1951,
			"name": "川汇区",
			"zipcode": "466000"
		}, {
			"id": 1952,
			"name": "扶沟县",
			"zipcode": "461300"
		}, {
			"id": 1953,
			"name": "西华县",
			"zipcode": "466600"
		}, {
			"id": 1954,
			"name": "商水县",
			"zipcode": "466100"
		}, {
			"id": 1955,
			"name": "沈丘县",
			"zipcode": "466300"
		}, {
			"id": 1956,
			"name": "郸城县",
			"zipcode": "477150"
		}, {
			"id": 1957,
			"name": "淮阳县",
			"zipcode": "466700"
		}, {
			"id": 1958,
			"name": "太康县",
			"zipcode": "461400"
		}, {
			"id": 1959,
			"name": "鹿邑县",
			"zipcode": "477200"
		}, {
			"id": 1960,
			"name": "项城市",
			"zipcode": "466200"
		}]
	}, {
		"id": 204,
		"name": "驻马店市",
		"child": [{
			"id": 1961,
			"name": "驿城区",
			"zipcode": "463000"
		}, {
			"id": 1962,
			"name": "西平县",
			"zipcode": "463900"
		}, {
			"id": 1963,
			"name": "上蔡县",
			"zipcode": "463800"
		}, {
			"id": 1964,
			"name": "平舆县",
			"zipcode": "463400"
		}, {
			"id": 1965,
			"name": "正阳县",
			"zipcode": "463600"
		}, {
			"id": 1966,
			"name": "确山县",
			"zipcode": "463200"
		}, {
			"id": 1967,
			"name": "泌阳县",
			"zipcode": "463700"
		}, {
			"id": 1968,
			"name": "汝南县",
			"zipcode": "463300"
		}, {
			"id": 1969,
			"name": "遂平县",
			"zipcode": "463100"
		}, {
			"id": 1970,
			"name": "新蔡县",
			"zipcode": "463500"
		}]
	}]
}, {
	"id": 18,
	"name": "湖北",
	"child": [{
		"id": 205,
		"name": "武汉市",
		"child": [{
			"id": 1971,
			"name": "江岸区",
			"zipcode": "430014"
		}, {
			"id": 1972,
			"name": "江汉区",
			"zipcode": "430021"
		}, {
			"id": 1973,
			"name": "硚口区",
			"zipcode": "430033"
		}, {
			"id": 1974,
			"name": "汉阳区",
			"zipcode": "430050"
		}, {
			"id": 1975,
			"name": "武昌区",
			"zipcode": "430061"
		}, {
			"id": 1976,
			"name": "青山区",
			"zipcode": "430080"
		}, {
			"id": 1977,
			"name": "洪山区",
			"zipcode": "430070"
		}, {
			"id": 1978,
			"name": "东西湖区",
			"zipcode": "430040"
		}, {
			"id": 1979,
			"name": "汉南区",
			"zipcode": "430090"
		}, {
			"id": 1980,
			"name": "蔡甸区",
			"zipcode": "430100"
		}, {
			"id": 1981,
			"name": "江夏区",
			"zipcode": "430200"
		}, {
			"id": 1982,
			"name": "黄陂区",
			"zipcode": "432200"
		}, {
			"id": 1983,
			"name": "新洲区",
			"zipcode": "431400"
		}]
	}, {
		"id": 206,
		"name": "黄石市",
		"child": [{
			"id": 1984,
			"name": "黄石港区",
			"zipcode": "435000"
		}, {
			"id": 1985,
			"name": "西塞山区",
			"zipcode": "435001"
		}, {
			"id": 1986,
			"name": "下陆区",
			"zipcode": "435005"
		}, {
			"id": 1987,
			"name": "铁山区",
			"zipcode": "435006"
		}, {
			"id": 1988,
			"name": "阳新县",
			"zipcode": "435200"
		}, {
			"id": 1989,
			"name": "大冶市",
			"zipcode": "435100"
		}]
	}, {
		"id": 207,
		"name": "十堰市",
		"child": [{
			"id": 1990,
			"name": "茅箭区",
			"zipcode": "442012"
		}, {
			"id": 1991,
			"name": "张湾区",
			"zipcode": "442001"
		}, {
			"id": 1992,
			"name": "郧县",
			"zipcode": "442500"
		}, {
			"id": 1993,
			"name": "郧西县",
			"zipcode": "442600"
		}, {
			"id": 1994,
			"name": "竹山县",
			"zipcode": "442200"
		}, {
			"id": 1995,
			"name": "竹溪县",
			"zipcode": "442300"
		}, {
			"id": 1996,
			"name": "房县",
			"zipcode": "442100"
		}, {
			"id": 1997,
			"name": "丹江口市",
			"zipcode": "442700"
		}]
	}, {
		"id": 208,
		"name": "宜昌市",
		"child": [{
			"id": 1998,
			"name": "西陵区",
			"zipcode": "443000"
		}, {
			"id": 1999,
			"name": "伍家岗区",
			"zipcode": "443001"
		}, {
			"id": 2000,
			"name": "点军区",
			"zipcode": "443006"
		}, {
			"id": 2001,
			"name": "猇亭区",
			"zipcode": "443007"
		}, {
			"id": 2002,
			"name": "夷陵区",
			"zipcode": "443100"
		}, {
			"id": 2003,
			"name": "远安县",
			"zipcode": "444200"
		}, {
			"id": 2004,
			"name": "兴山县",
			"zipcode": "443711"
		}, {
			"id": 2005,
			"name": "秭归县",
			"zipcode": "443600"
		}, {
			"id": 2006,
			"name": "长阳土家族自治县",
			"zipcode": "443500"
		}, {
			"id": 2007,
			"name": "五峰土家族自治县",
			"zipcode": "443400"
		}, {
			"id": 2008,
			"name": "宜都市",
			"zipcode": "443300"
		}, {
			"id": 2009,
			"name": "当阳市",
			"zipcode": "444100"
		}, {
			"id": 2010,
			"name": "枝江市",
			"zipcode": "443200"
		}, {
			"id": 2011,
			"name": "经济技术开发区",
			"zipcode": "443003"
		}]
	}, {
		"id": 209,
		"name": "襄阳市",
		"child": [{
			"id": 2012,
			"name": "襄城区",
			"zipcode": "441021"
		}, {
			"id": 2013,
			"name": "樊城区",
			"zipcode": "441001"
		}, {
			"id": 2014,
			"name": "襄阳区",
			"zipcode": "441100"
		}, {
			"id": 2015,
			"name": "南漳县",
			"zipcode": "441500"
		}, {
			"id": 2016,
			"name": "谷城县",
			"zipcode": "441700"
		}, {
			"id": 2017,
			"name": "保康县",
			"zipcode": "441600"
		}, {
			"id": 2018,
			"name": "老河口市",
			"zipcode": "441800"
		}, {
			"id": 2019,
			"name": "枣阳市",
			"zipcode": "441200"
		}, {
			"id": 2020,
			"name": "宜城市",
			"zipcode": "441400"
		}]
	}, {
		"id": 210,
		"name": "鄂州市",
		"child": [{
			"id": 2021,
			"name": "梁子湖区",
			"zipcode": "436064"
		}, {
			"id": 2022,
			"name": "华容区",
			"zipcode": "436030"
		}, {
			"id": 2023,
			"name": "鄂城区",
			"zipcode": "436000"
		}]
	}, {
		"id": 211,
		"name": "荆门市",
		"child": [{
			"id": 2024,
			"name": "东宝区",
			"zipcode": "448004"
		}, {
			"id": 2025,
			"name": "掇刀区",
			"zipcode": "448124"
		}, {
			"id": 2026,
			"name": "京山县",
			"zipcode": "431800"
		}, {
			"id": 2027,
			"name": "沙洋县",
			"zipcode": "448200"
		}, {
			"id": 2028,
			"name": "钟祥市",
			"zipcode": "431900"
		}]
	}, {
		"id": 212,
		"name": "孝感市",
		"child": [{
			"id": 2029,
			"name": "孝南区",
			"zipcode": "432100"
		}, {
			"id": 2030,
			"name": "孝昌县",
			"zipcode": "432900"
		}, {
			"id": 2031,
			"name": "大悟县",
			"zipcode": "432800"
		}, {
			"id": 2032,
			"name": "云梦县",
			"zipcode": "432500"
		}, {
			"id": 2033,
			"name": "应城市",
			"zipcode": "432400"
		}, {
			"id": 2034,
			"name": "安陆市",
			"zipcode": "432600"
		}, {
			"id": 2035,
			"name": "汉川市",
			"zipcode": "432300"
		}]
	}, {
		"id": 213,
		"name": "荆州市",
		"child": [{
			"id": 2036,
			"name": "沙市区",
			"zipcode": "434000"
		}, {
			"id": 2037,
			"name": "荆州区",
			"zipcode": "434020"
		}, {
			"id": 2038,
			"name": "公安县",
			"zipcode": "434300"
		}, {
			"id": 2039,
			"name": "监利县",
			"zipcode": "433300"
		}, {
			"id": 2040,
			"name": "江陵县",
			"zipcode": "434101"
		}, {
			"id": 2041,
			"name": "石首市",
			"zipcode": "434400"
		}, {
			"id": 2042,
			"name": "洪湖市",
			"zipcode": "433200"
		}, {
			"id": 2043,
			"name": "松滋市",
			"zipcode": "434200"
		}]
	}, {
		"id": 214,
		"name": "黄冈市",
		"child": [{
			"id": 2044,
			"name": "黄州区",
			"zipcode": "438000"
		}, {
			"id": 2045,
			"name": "团风县",
			"zipcode": "438000"
		}, {
			"id": 2046,
			"name": "红安县",
			"zipcode": "438401"
		}, {
			"id": 2047,
			"name": "罗田县",
			"zipcode": "438600"
		}, {
			"id": 2048,
			"name": "英山县",
			"zipcode": "438700"
		}, {
			"id": 2049,
			"name": "浠水县",
			"zipcode": "438200"
		}, {
			"id": 2050,
			"name": "蕲春县",
			"zipcode": "435300"
		}, {
			"id": 2051,
			"name": "黄梅县",
			"zipcode": "435500"
		}, {
			"id": 2052,
			"name": "麻城市",
			"zipcode": "438300"
		}, {
			"id": 2053,
			"name": "武穴市",
			"zipcode": "435400"
		}]
	}, {
		"id": 215,
		"name": "咸宁市",
		"child": [{
			"id": 2054,
			"name": "咸安区",
			"zipcode": "437000"
		}, {
			"id": 2055,
			"name": "嘉鱼县",
			"zipcode": "437200"
		}, {
			"id": 2056,
			"name": "通城县",
			"zipcode": "437400"
		}, {
			"id": 2057,
			"name": "崇阳县",
			"zipcode": "437500"
		}, {
			"id": 2058,
			"name": "通山县",
			"zipcode": "437600"
		}, {
			"id": 2059,
			"name": "赤壁市",
			"zipcode": "437300"
		}]
	}, {
		"id": 216,
		"name": "随州市",
		"child": [{
			"id": 2060,
			"name": "曾都区",
			"zipcode": "441300"
		}, {
			"id": 2061,
			"name": "广水市",
			"zipcode": "432700"
		}]
	}, {
		"id": 217,
		"name": "恩施土家族苗族自治州",
		"child": [{
			"id": 2062,
			"name": "恩施市",
			"zipcode": "445000"
		}, {
			"id": 2063,
			"name": "利川市",
			"zipcode": "445400"
		}, {
			"id": 2064,
			"name": "建始县",
			"zipcode": "445300"
		}, {
			"id": 2065,
			"name": "巴东县",
			"zipcode": "444300"
		}, {
			"id": 2066,
			"name": "宣恩县",
			"zipcode": "445500"
		}, {
			"id": 2067,
			"name": "咸丰县",
			"zipcode": "445600"
		}, {
			"id": 2068,
			"name": "来凤县",
			"zipcode": "445700"
		}, {
			"id": 2069,
			"name": "鹤峰县",
			"zipcode": "445800"
		}]
	}, {
		"id": 7590,
		"name": "仙桃市",
		"child": [{
			"id": 7591,
			"name": "仙桃市",
			"zipcode": "433000"
		}]
	}, {
		"id": 7592,
		"name": "潜江市",
		"child": [{
			"id": 7593,
			"name": "潜江市",
			"zipcode": "433100"
		}]
	}, {
		"id": 7594,
		"name": "天门市",
		"child": [{
			"id": 7595,
			"name": "天门市",
			"zipcode": "431700"
		}]
	}, {
		"id": 7596,
		"name": "神农架林区",
		"child": [{
			"id": 7597,
			"name": "神农架林区",
			"zipcode": "442400"
		}]
	}]
}, {
	"id": 19,
	"name": "湖南",
	"child": [{
		"id": 219,
		"name": "长沙市",
		"child": [{
			"id": 2074,
			"name": "芙蓉区",
			"zipcode": "410011"
		}, {
			"id": 2075,
			"name": "天心区",
			"zipcode": "410011"
		}, {
			"id": 2076,
			"name": "岳麓区",
			"zipcode": "410006"
		}, {
			"id": 2077,
			"name": "开福区",
			"zipcode": "410008"
		}, {
			"id": 2078,
			"name": "雨花区",
			"zipcode": "410011"
		}, {
			"id": 2079,
			"name": "长沙县",
			"zipcode": "410100"
		}, {
			"id": 2080,
			"name": "望城县",
			"zipcode": "410200"
		}, {
			"id": 2081,
			"name": "宁乡县",
			"zipcode": "410600"
		}, {
			"id": 2082,
			"name": "浏阳市",
			"zipcode": "410300"
		}]
	}, {
		"id": 220,
		"name": "株洲市",
		"child": [{
			"id": 2083,
			"name": "荷塘区",
			"zipcode": "412000"
		}, {
			"id": 2084,
			"name": "芦淞区",
			"zipcode": "412000"
		}, {
			"id": 2085,
			"name": "石峰区",
			"zipcode": "412005"
		}, {
			"id": 2086,
			"name": "天元区",
			"zipcode": "412007"
		}, {
			"id": 2087,
			"name": "株洲县",
			"zipcode": "412100"
		}, {
			"id": 2088,
			"name": "攸县",
			"zipcode": "412300"
		}, {
			"id": 2089,
			"name": "茶陵县",
			"zipcode": "412400"
		}, {
			"id": 2090,
			"name": "炎陵县",
			"zipcode": "412500"
		}, {
			"id": 2091,
			"name": "醴陵市",
			"zipcode": "412200"
		}]
	}, {
		"id": 221,
		"name": "湘潭市",
		"child": [{
			"id": 2092,
			"name": "雨湖区",
			"zipcode": "411100"
		}, {
			"id": 2093,
			"name": "岳塘区",
			"zipcode": "411101"
		}, {
			"id": 2094,
			"name": "湘潭县",
			"zipcode": "411228"
		}, {
			"id": 2095,
			"name": "湘乡市",
			"zipcode": "411400"
		}, {
			"id": 2096,
			"name": "韶山市",
			"zipcode": "411300"
		}]
	}, {
		"id": 222,
		"name": "衡阳市",
		"child": [{
			"id": 2097,
			"name": "珠晖区",
			"zipcode": "421002"
		}, {
			"id": 2098,
			"name": "雁峰区",
			"zipcode": "421001"
		}, {
			"id": 2099,
			"name": "石鼓区",
			"zipcode": "421001"
		}, {
			"id": 2100,
			"name": "蒸湘区",
			"zipcode": "421001"
		}, {
			"id": 2101,
			"name": "南岳区",
			"zipcode": "421900"
		}, {
			"id": 2102,
			"name": "衡阳县",
			"zipcode": "421200"
		}, {
			"id": 2103,
			"name": "衡南县",
			"zipcode": "421131"
		}, {
			"id": 2104,
			"name": "衡山县",
			"zipcode": "421300"
		}, {
			"id": 2105,
			"name": "衡东县",
			"zipcode": "421400"
		}, {
			"id": 2106,
			"name": "祁东县",
			"zipcode": "421600"
		}, {
			"id": 2107,
			"name": "耒阳市",
			"zipcode": "421800"
		}, {
			"id": 2108,
			"name": "常宁市",
			"zipcode": "421500"
		}]
	}, {
		"id": 223,
		"name": "邵阳市",
		"child": [{
			"id": 2109,
			"name": "双清区",
			"zipcode": "422001"
		}, {
			"id": 2110,
			"name": "大祥区",
			"zipcode": "422000"
		}, {
			"id": 2111,
			"name": "北塔区",
			"zipcode": "422007"
		}, {
			"id": 2112,
			"name": "邵东县",
			"zipcode": "422800"
		}, {
			"id": 2113,
			"name": "新邵县",
			"zipcode": "422900"
		}, {
			"id": 2114,
			"name": "邵阳县",
			"zipcode": "422100"
		}, {
			"id": 2115,
			"name": "隆回县",
			"zipcode": "422200"
		}, {
			"id": 2116,
			"name": "洞口县",
			"zipcode": "422300"
		}, {
			"id": 2117,
			"name": "绥宁县",
			"zipcode": "422600"
		}, {
			"id": 2118,
			"name": "新宁县",
			"zipcode": "422700"
		}, {
			"id": 2119,
			"name": "城步苗族自治县",
			"zipcode": "422500"
		}, {
			"id": 2120,
			"name": "武冈市",
			"zipcode": "422400"
		}]
	}, {
		"id": 224,
		"name": "岳阳市",
		"child": [{
			"id": 2121,
			"name": "岳阳楼区",
			"zipcode": "414000"
		}, {
			"id": 2122,
			"name": "云溪区",
			"zipcode": "414009"
		}, {
			"id": 2123,
			"name": "君山区",
			"zipcode": "414005"
		}, {
			"id": 2124,
			"name": "岳阳县",
			"zipcode": "414100"
		}, {
			"id": 2125,
			"name": "华容县",
			"zipcode": "414200"
		}, {
			"id": 2126,
			"name": "湘阴县",
			"zipcode": "410500"
		}, {
			"id": 2127,
			"name": "平江县",
			"zipcode": "414500"
		}, {
			"id": 2128,
			"name": "汨罗市",
			"zipcode": "414400"
		}, {
			"id": 2129,
			"name": "临湘市",
			"zipcode": "414300"
		}]
	}, {
		"id": 225,
		"name": "常德市",
		"child": [{
			"id": 2130,
			"name": "武陵区",
			"zipcode": "415000"
		}, {
			"id": 2131,
			"name": "鼎城区",
			"zipcode": "415101"
		}, {
			"id": 2132,
			"name": "安乡县",
			"zipcode": "415600"
		}, {
			"id": 2133,
			"name": "汉寿县",
			"zipcode": "415900"
		}, {
			"id": 2134,
			"name": "澧县",
			"zipcode": "415500"
		}, {
			"id": 2135,
			"name": "临澧县",
			"zipcode": "415200"
		}, {
			"id": 2136,
			"name": "桃源县",
			"zipcode": "415700"
		}, {
			"id": 2137,
			"name": "石门县",
			"zipcode": "415300"
		}, {
			"id": 2138,
			"name": "津市市",
			"zipcode": "415400"
		}]
	}, {
		"id": 226,
		"name": "张家界市",
		"child": [{
			"id": 2139,
			"name": "永定区",
			"zipcode": "427000"
		}, {
			"id": 2140,
			"name": "武陵源区",
			"zipcode": "427400"
		}, {
			"id": 2141,
			"name": "慈利县",
			"zipcode": "427200"
		}, {
			"id": 2142,
			"name": "桑植县",
			"zipcode": "427100"
		}]
	}, {
		"id": 227,
		"name": "益阳市",
		"child": [{
			"id": 2143,
			"name": "资阳区",
			"zipcode": "413001"
		}, {
			"id": 2144,
			"name": "赫山区",
			"zipcode": "413002"
		}, {
			"id": 2145,
			"name": "南县",
			"zipcode": "413200"
		}, {
			"id": 2146,
			"name": "桃江县",
			"zipcode": "413400"
		}, {
			"id": 2147,
			"name": "安化县",
			"zipcode": "413500"
		}, {
			"id": 2148,
			"name": "沅江市",
			"zipcode": "413100"
		}]
	}, {
		"id": 228,
		"name": "郴州市",
		"child": [{
			"id": 2149,
			"name": "北湖区",
			"zipcode": "423000"
		}, {
			"id": 2150,
			"name": "苏仙区",
			"zipcode": "423000"
		}, {
			"id": 2151,
			"name": "桂阳县",
			"zipcode": "424400"
		}, {
			"id": 2152,
			"name": "宜章县",
			"zipcode": "424200"
		}, {
			"id": 2153,
			"name": "永兴县",
			"zipcode": "423300"
		}, {
			"id": 2154,
			"name": "嘉禾县",
			"zipcode": "424500"
		}, {
			"id": 2155,
			"name": "临武县",
			"zipcode": "424300"
		}, {
			"id": 2156,
			"name": "汝城县",
			"zipcode": "424100"
		}, {
			"id": 2157,
			"name": "桂东县",
			"zipcode": "423500"
		}, {
			"id": 2158,
			"name": "安仁县",
			"zipcode": "423600"
		}, {
			"id": 2159,
			"name": "资兴市",
			"zipcode": "423400"
		}]
	}, {
		"id": 229,
		"name": "永州市",
		"child": [{
			"id": 2160,
			"name": "冷水滩区",
			"zipcode": "425100"
		}, {
			"id": 2161,
			"name": "祁阳县",
			"zipcode": "426100"
		}, {
			"id": 2162,
			"name": "东安县",
			"zipcode": "425900"
		}, {
			"id": 2163,
			"name": "双牌县",
			"zipcode": "425200"
		}, {
			"id": 2164,
			"name": "道县",
			"zipcode": "425300"
		}, {
			"id": 2165,
			"name": "江永县",
			"zipcode": "425400"
		}, {
			"id": 2166,
			"name": "宁远县",
			"zipcode": "425600"
		}, {
			"id": 2167,
			"name": "蓝山县",
			"zipcode": "425800"
		}, {
			"id": 2168,
			"name": "新田县",
			"zipcode": "425700"
		}, {
			"id": 2169,
			"name": "江华瑶族自治县",
			"zipcode": "425500"
		}, {
			"id": 2170,
			"name": "零陵区",
			"zipcode": "425002"
		}]
	}, {
		"id": 230,
		"name": "怀化市",
		"child": [{
			"id": 2171,
			"name": "鹤城区",
			"zipcode": "418000"
		}, {
			"id": 2172,
			"name": "中方县",
			"zipcode": "418005"
		}, {
			"id": 2173,
			"name": "沅陵县",
			"zipcode": "419600"
		}, {
			"id": 2174,
			"name": "辰溪县",
			"zipcode": "419500"
		}, {
			"id": 2175,
			"name": "溆浦县",
			"zipcode": "419300"
		}, {
			"id": 2176,
			"name": "会同县",
			"zipcode": "418300"
		}, {
			"id": 2177,
			"name": "麻阳苗族自治县",
			"zipcode": "419400"
		}, {
			"id": 2178,
			"name": "新晃侗族自治县",
			"zipcode": "419200"
		}, {
			"id": 2179,
			"name": "芷江侗族自治县",
			"zipcode": "419100"
		}, {
			"id": 2180,
			"name": "靖州苗族侗族自治县",
			"zipcode": "418400"
		}, {
			"id": 2181,
			"name": "通道侗族自治县",
			"zipcode": "418500"
		}, {
			"id": 2182,
			"name": "洪江市",
			"zipcode": "418116"
		}]
	}, {
		"id": 231,
		"name": "娄底市",
		"child": [{
			"id": 2183,
			"name": "娄星区",
			"zipcode": "417000"
		}, {
			"id": 2184,
			"name": "双峰县",
			"zipcode": "417700"
		}, {
			"id": 2185,
			"name": "新化县",
			"zipcode": "417600"
		}, {
			"id": 2186,
			"name": "冷水江市",
			"zipcode": "417500"
		}, {
			"id": 2187,
			"name": "涟源市",
			"zipcode": "417100"
		}]
	}, {
		"id": 232,
		"name": "湘西土家族苗族自治州",
		"child": [{
			"id": 2188,
			"name": "吉首市",
			"zipcode": "416000"
		}, {
			"id": 2189,
			"name": "泸溪县",
			"zipcode": "416100"
		}, {
			"id": 2190,
			"name": "凤凰县",
			"zipcode": "416200"
		}, {
			"id": 2191,
			"name": "花垣县",
			"zipcode": "416400"
		}, {
			"id": 2192,
			"name": "保靖县",
			"zipcode": "416500"
		}, {
			"id": 2193,
			"name": "古丈县",
			"zipcode": "416300"
		}, {
			"id": 2194,
			"name": "永顺县",
			"zipcode": "416700"
		}, {
			"id": 2195,
			"name": "龙山县",
			"zipcode": "416800"
		}]
	}]
}, {
	"id": 20,
	"name": "广东",
	"child": [{
		"id": 233,
		"name": "广州市",
		"child": [{
			"id": 2196,
			"name": "荔湾区",
			"zipcode": "510145"
		}, {
			"id": 2197,
			"name": "越秀区",
			"zipcode": "510030"
		}, {
			"id": 2198,
			"name": "海珠区",
			"zipcode": "510220"
		}, {
			"id": 2199,
			"name": "天河区",
			"zipcode": "510630"
		}, {
			"id": 2200,
			"name": "白云区",
			"zipcode": "510080"
		}, {
			"id": 2201,
			"name": "黄埔区",
			"zipcode": "510700"
		}, {
			"id": 2202,
			"name": "番禺区",
			"zipcode": "511400"
		}, {
			"id": 2203,
			"name": "花都区",
			"zipcode": "510800"
		}, {
			"id": 2204,
			"name": "增城市",
			"zipcode": "511300"
		}, {
			"id": 2205,
			"name": "从化市",
			"zipcode": "510900"
		}, {
			"id": 2206,
			"name": "南沙区",
			"zipcode": "511400"
		}, {
			"id": 2207,
			"name": "萝岗区",
			"zipcode": "510100"
		}]
	}, {
		"id": 234,
		"name": "韶关市",
		"child": [{
			"id": 2208,
			"name": "武江区",
			"zipcode": "512026"
		}, {
			"id": 2209,
			"name": "浈江区",
			"zipcode": "512023"
		}, {
			"id": 2210,
			"name": "曲江区",
			"zipcode": "512100"
		}, {
			"id": 2211,
			"name": "始兴县",
			"zipcode": "512500"
		}, {
			"id": 2212,
			"name": "仁化县",
			"zipcode": "512300"
		}, {
			"id": 2213,
			"name": "翁源县",
			"zipcode": "512600"
		}, {
			"id": 2214,
			"name": "乳源瑶族自治县",
			"zipcode": "512700"
		}, {
			"id": 2215,
			"name": "新丰县",
			"zipcode": "511100"
		}, {
			"id": 2216,
			"name": "乐昌市",
			"zipcode": "512200"
		}, {
			"id": 2217,
			"name": "南雄市",
			"zipcode": "512400"
		}]
	}, {
		"id": 235,
		"name": "深圳市",
		"child": [{
			"id": 2218,
			"name": "罗湖区",
			"zipcode": "518001"
		}, {
			"id": 2219,
			"name": "福田区",
			"zipcode": "518033"
		}, {
			"id": 2220,
			"name": "南山区",
			"zipcode": "518052"
		}, {
			"id": 2221,
			"name": "宝安区",
			"zipcode": "518101"
		}, {
			"id": 2222,
			"name": "龙岗区",
			"zipcode": "518116"
		}, {
			"id": 2223,
			"name": "盐田区",
			"zipcode": "518083"
		}, {
			"id": 2224,
			"name": "光明新区",
			"zipcode": "518107"
		}, {
			"id": 2225,
			"name": "坪山新区",
			"zipcode": "518118"
		}, {
			"id": 7497,
			"name": "龙华新区",
			"zipcode": "518109"
		}]
	}, {
		"id": 236,
		"name": "珠海市",
		"child": [{
			"id": 2226,
			"name": "香洲区",
			"zipcode": "519000"
		}, {
			"id": 2227,
			"name": "斗门区",
			"zipcode": "519100"
		}, {
			"id": 2228,
			"name": "金湾区",
			"zipcode": "519090"
		}]
	}, {
		"id": 237,
		"name": "汕头市",
		"child": [{
			"id": 2229,
			"name": "龙湖区",
			"zipcode": "515041"
		}, {
			"id": 2230,
			"name": "金平区",
			"zipcode": "515041"
		}, {
			"id": 2231,
			"name": "濠江区",
			"zipcode": "515071"
		}, {
			"id": 2232,
			"name": "潮阳区",
			"zipcode": "515100"
		}, {
			"id": 2233,
			"name": "潮南区",
			"zipcode": "515144"
		}, {
			"id": 2234,
			"name": "澄海区",
			"zipcode": "515800"
		}, {
			"id": 2235,
			"name": "南澳县",
			"zipcode": "515900"
		}]
	}, {
		"id": 238,
		"name": "佛山市",
		"child": [{
			"id": 2236,
			"name": "禅城区",
			"zipcode": "528000"
		}, {
			"id": 2237,
			"name": "南海区",
			"zipcode": "528200"
		}, {
			"id": 2238,
			"name": "顺德区",
			"zipcode": "528300"
		}, {
			"id": 2239,
			"name": "三水区",
			"zipcode": "528100"
		}, {
			"id": 2240,
			"name": "高明区",
			"zipcode": "528500"
		}]
	}, {
		"id": 239,
		"name": "江门市",
		"child": [{
			"id": 2241,
			"name": "蓬江区",
			"zipcode": "529051"
		}, {
			"id": 2242,
			"name": "江海区",
			"zipcode": "529000"
		}, {
			"id": 2243,
			"name": "新会区",
			"zipcode": "529100"
		}, {
			"id": 2244,
			"name": "台山市",
			"zipcode": "529211"
		}, {
			"id": 2245,
			"name": "开平市",
			"zipcode": "529312"
		}, {
			"id": 2246,
			"name": "鹤山市",
			"zipcode": "529711"
		}, {
			"id": 2247,
			"name": "恩平市",
			"zipcode": "529411"
		}]
	}, {
		"id": 240,
		"name": "湛江市",
		"child": [{
			"id": 2248,
			"name": "赤坎区",
			"zipcode": "524033"
		}, {
			"id": 2249,
			"name": "霞山区",
			"zipcode": "524002"
		}, {
			"id": 2250,
			"name": "坡头区",
			"zipcode": "524057"
		}, {
			"id": 2251,
			"name": "麻章区",
			"zipcode": "524003"
		}, {
			"id": 2252,
			"name": "遂溪县",
			"zipcode": "524300"
		}, {
			"id": 2253,
			"name": "徐闻县",
			"zipcode": "524100"
		}, {
			"id": 2254,
			"name": "廉江市",
			"zipcode": "524400"
		}, {
			"id": 2255,
			"name": "雷州市",
			"zipcode": "524200"
		}, {
			"id": 2256,
			"name": "吴川市",
			"zipcode": "524500"
		}, {
			"id": 2257,
			"name": "开发区",
			"zipcode": "524022"
		}]
	}, {
		"id": 241,
		"name": "茂名市",
		"child": [{
			"id": 2258,
			"name": "茂南区",
			"zipcode": "525011"
		}, {
			"id": 2259,
			"name": "茂港区",
			"zipcode": "525027"
		}, {
			"id": 2260,
			"name": "电白县",
			"zipcode": "525400"
		}, {
			"id": 2261,
			"name": "高州市",
			"zipcode": "525200"
		}, {
			"id": 2262,
			"name": "化州市",
			"zipcode": "525100"
		}, {
			"id": 2263,
			"name": "信宜市",
			"zipcode": "525300"
		}]
	}, {
		"id": 242,
		"name": "肇庆市",
		"child": [{
			"id": 2264,
			"name": "端州区",
			"zipcode": "526040"
		}, {
			"id": 2265,
			"name": "鼎湖区",
			"zipcode": "526070"
		}, {
			"id": 2266,
			"name": "广宁县",
			"zipcode": "526300"
		}, {
			"id": 2267,
			"name": "怀集县",
			"zipcode": "526400"
		}, {
			"id": 2268,
			"name": "封开县",
			"zipcode": "526500"
		}, {
			"id": 2269,
			"name": "德庆县",
			"zipcode": "526600"
		}, {
			"id": 2270,
			"name": "高要市",
			"zipcode": "526100"
		}, {
			"id": 2271,
			"name": "四会市",
			"zipcode": "526200"
		}, {
			"id": 2272,
			"name": "高新技术产业开发区",
			"zipcode": "526238"
		}]
	}, {
		"id": 243,
		"name": "惠州市",
		"child": [{
			"id": 2273,
			"name": "惠城区",
			"zipcode": "516001"
		}, {
			"id": 2274,
			"name": "惠阳区",
			"zipcode": "516200"
		}, {
			"id": 2275,
			"name": "博罗县",
			"zipcode": "516100"
		}, {
			"id": 2276,
			"name": "惠东县",
			"zipcode": "516300"
		}, {
			"id": 2277,
			"name": "龙门县",
			"zipcode": "516800"
		}, {
			"id": 2278,
			"name": "大亚湾区",
			"zipcode": "516080"
		}, {
			"id": 2279,
			"name": "仲恺高新区",
			"zipcode": "516080"
		}]
	}, {
		"id": 244,
		"name": "梅州市",
		"child": [{
			"id": 2280,
			"name": "梅江区",
			"zipcode": "514000"
		}, {
			"id": 2281,
			"name": "梅县",
			"zipcode": "514733"
		}, {
			"id": 2282,
			"name": "大埔县",
			"zipcode": "514200"
		}, {
			"id": 2283,
			"name": "丰顺县",
			"zipcode": "514300"
		}, {
			"id": 2284,
			"name": "五华县",
			"zipcode": "514400"
		}, {
			"id": 2285,
			"name": "平远县",
			"zipcode": "514600"
		}, {
			"id": 2286,
			"name": "蕉岭县",
			"zipcode": "514100"
		}, {
			"id": 2287,
			"name": "兴宁市",
			"zipcode": "514500"
		}]
	}, {
		"id": 245,
		"name": "汕尾市",
		"child": [{
			"id": 2288,
			"name": "城区",
			"zipcode": "516601"
		}, {
			"id": 2289,
			"name": "陆丰市",
			"zipcode": "516500"
		}, {
			"id": 2290,
			"name": "海丰县",
			"zipcode": "516400"
		}, {
			"id": 2291,
			"name": "陆河县",
			"zipcode": "516700"
		}]
	}, {
		"id": 246,
		"name": "河源市",
		"child": [{
			"id": 2292,
			"name": "源城区",
			"zipcode": "517000"
		}, {
			"id": 2293,
			"name": "紫金县",
			"zipcode": "517400"
		}, {
			"id": 2294,
			"name": "龙川县",
			"zipcode": "517300"
		}, {
			"id": 2295,
			"name": "连平县",
			"zipcode": "517100"
		}, {
			"id": 2296,
			"name": "和平县",
			"zipcode": "517200"
		}, {
			"id": 2297,
			"name": "东源县",
			"zipcode": "517500"
		}]
	}, {
		"id": 247,
		"name": "阳江市",
		"child": [{
			"id": 2298,
			"name": "江城区",
			"zipcode": "529525"
		}, {
			"id": 2299,
			"name": "阳西县",
			"zipcode": "529800"
		}, {
			"id": 2300,
			"name": "阳东县",
			"zipcode": "529931"
		}, {
			"id": 2301,
			"name": "阳春市",
			"zipcode": "529611"
		}]
	}, {
		"id": 248,
		"name": "清远市",
		"child": [{
			"id": 2302,
			"name": "清城区",
			"zipcode": "511500"
		}, {
			"id": 2303,
			"name": "佛冈县",
			"zipcode": "511600"
		}, {
			"id": 2304,
			"name": "阳山县",
			"zipcode": "513100"
		}, {
			"id": 2305,
			"name": "连山壮族瑶族自治县",
			"zipcode": "513200"
		}, {
			"id": 2306,
			"name": "连南瑶族自治县",
			"zipcode": "513300"
		}, {
			"id": 2307,
			"name": "清新县",
			"zipcode": "511800"
		}, {
			"id": 2308,
			"name": "英德市",
			"zipcode": "513000"
		}, {
			"id": 2309,
			"name": "连州市",
			"zipcode": "513401"
		}]
	}, {
		"id": 249,
		"name": "潮州市",
		"child": [{
			"id": 2310,
			"name": "湘桥区",
			"zipcode": "521000"
		}, {
			"id": 2311,
			"name": "潮安县",
			"zipcode": "515638"
		}, {
			"id": 2312,
			"name": "饶平县",
			"zipcode": "515700"
		}]
	}, {
		"id": 250,
		"name": "揭阳市",
		"child": [{
			"id": 2313,
			"name": "榕城区",
			"zipcode": "522095"
		}, {
			"id": 2314,
			"name": "揭东县",
			"zipcode": "515554"
		}, {
			"id": 2315,
			"name": "揭西县",
			"zipcode": "515400"
		}, {
			"id": 2316,
			"name": "惠来县",
			"zipcode": "515200"
		}, {
			"id": 2317,
			"name": "普宁市",
			"zipcode": "515300"
		}, {
			"id": 2318,
			"name": "东山区",
			"zipcode": "522031"
		}, {
			"id": 2319,
			"name": "普侨区",
			"zipcode": "515339"
		}, {
			"id": 2320,
			"name": "大南山侨区",
			"zipcode": "515237"
		}]
	}, {
		"id": 251,
		"name": "云浮市",
		"child": [{
			"id": 2321,
			"name": "云城区",
			"zipcode": "527300"
		}, {
			"id": 2322,
			"name": "新兴县",
			"zipcode": "527400"
		}, {
			"id": 2323,
			"name": "郁南县",
			"zipcode": "527100"
		}, {
			"id": 2324,
			"name": "云安县",
			"zipcode": "527500"
		}, {
			"id": 2325,
			"name": "罗定市",
			"zipcode": "527200"
		}]
	}, {
		"id": 252,
		"name": "东莞市",
		"child": [{
			"id": 2326,
			"name": "南城区",
			"zipcode": "523000"
		}, {
			"id": 2327,
			"name": "石龙镇",
			"zipcode": "523021"
		}, {
			"id": 2328,
			"name": "长安镇",
			"zipcode": "523068"
		}, {
			"id": 2329,
			"name": "虎门镇",
			"zipcode": "523061"
		}, {
			"id": 2330,
			"name": "横沥镇",
			"zipcode": "523032"
		}, {
			"id": 2331,
			"name": "寮步镇",
			"zipcode": "523058"
		}, {
			"id": 2332,
			"name": "黄江镇",
			"zipcode": "523054"
		}, {
			"id": 2333,
			"name": "清溪镇",
			"zipcode": "523046"
		}, {
			"id": 2334,
			"name": "莞城区",
			"zipcode": "523000"
		}, {
			"id": 2335,
			"name": "万江区",
			"zipcode": "523050"
		}, {
			"id": 2336,
			"name": "东城区",
			"zipcode": "523000"
		}, {
			"id": 2337,
			"name": "石碣镇",
			"zipcode": "523024"
		}, {
			"id": 2338,
			"name": "茶山镇",
			"zipcode": "523029"
		}, {
			"id": 2339,
			"name": "石排镇",
			"zipcode": "523025"
		}, {
			"id": 2340,
			"name": "企石镇",
			"zipcode": "523027"
		}, {
			"id": 2341,
			"name": "桥头镇",
			"zipcode": "523038"
		}, {
			"id": 2342,
			"name": "谢岗镇",
			"zipcode": "523044"
		}, {
			"id": 2343,
			"name": "东坑镇",
			"zipcode": "523034"
		}, {
			"id": 2344,
			"name": "常平镇",
			"zipcode": "523036"
		}, {
			"id": 2345,
			"name": "大朗镇",
			"zipcode": "523056"
		}, {
			"id": 2346,
			"name": "塘厦镇",
			"zipcode": "523710"
		}, {
			"id": 2347,
			"name": "凤岗镇",
			"zipcode": "523048"
		}, {
			"id": 2348,
			"name": "厚街镇",
			"zipcode": "523071"
		}, {
			"id": 2349,
			"name": "沙田镇",
			"zipcode": "523073"
		}, {
			"id": 2350,
			"name": "道滘镇",
			"zipcode": "523170"
		}, {
			"id": 2351,
			"name": "洪梅镇",
			"zipcode": "523083"
		}, {
			"id": 2352,
			"name": "麻涌镇",
			"zipcode": "523078"
		}, {
			"id": 2353,
			"name": "中堂镇",
			"zipcode": "523075"
		}, {
			"id": 2354,
			"name": "高埗镇",
			"zipcode": "523270"
		}, {
			"id": 2355,
			"name": "樟木头镇",
			"zipcode": "523041"
		}, {
			"id": 2356,
			"name": "大岭山镇",
			"zipcode": "523074"
		}, {
			"id": 2357,
			"name": "望牛墩镇",
			"zipcode": "523077"
		}]
	}, {
		"id": 253,
		"name": "中山市",
		"child": [{
			"id": 2358,
			"name": "中山市",
			"zipcode": "528403"
		}]
	}]
}, {
	"id": 21,
	"name": "广西",
	"child": [{
		"id": 254,
		"name": "南宁市",
		"child": [{
			"id": 2359,
			"name": "兴宁区",
			"zipcode": "530012"
		}, {
			"id": 2360,
			"name": "青秀区",
			"zipcode": "530022"
		}, {
			"id": 2361,
			"name": "江南区",
			"zipcode": "530031"
		}, {
			"id": 2362,
			"name": "西乡塘区",
			"zipcode": "530001"
		}, {
			"id": 2363,
			"name": "良庆区",
			"zipcode": "530200"
		}, {
			"id": 2364,
			"name": "邕宁区",
			"zipcode": "530200"
		}, {
			"id": 2365,
			"name": "武鸣县",
			"zipcode": "530100"
		}, {
			"id": 2366,
			"name": "隆安县",
			"zipcode": "532700"
		}, {
			"id": 2367,
			"name": "马山县",
			"zipcode": "530600"
		}, {
			"id": 2368,
			"name": "上林县",
			"zipcode": "530500"
		}, {
			"id": 2369,
			"name": "宾阳县",
			"zipcode": "530400"
		}, {
			"id": 2370,
			"name": "横县",
			"zipcode": "530300"
		}]
	}, {
		"id": 255,
		"name": "柳州市",
		"child": [{
			"id": 2371,
			"name": "城中区",
			"zipcode": "545001"
		}, {
			"id": 2372,
			"name": "鱼峰区",
			"zipcode": "545005"
		}, {
			"id": 2373,
			"name": "柳南区",
			"zipcode": "545005"
		}, {
			"id": 2374,
			"name": "柳北区",
			"zipcode": "545001"
		}, {
			"id": 2375,
			"name": "柳江县",
			"zipcode": "545100"
		}, {
			"id": 2376,
			"name": "柳城县",
			"zipcode": "545200"
		}, {
			"id": 2377,
			"name": "鹿寨县",
			"zipcode": "545600"
		}, {
			"id": 2378,
			"name": "融安县",
			"zipcode": "545400"
		}, {
			"id": 2379,
			"name": "融水苗族自治县",
			"zipcode": "545300"
		}, {
			"id": 2380,
			"name": "三江侗族自治县",
			"zipcode": "545500"
		}]
	}, {
		"id": 256,
		"name": "桂林市",
		"child": [{
			"id": 2381,
			"name": "秀峰区",
			"zipcode": "541001"
		}, {
			"id": 2382,
			"name": "叠彩区",
			"zipcode": "541001"
		}, {
			"id": 2383,
			"name": "象山区",
			"zipcode": "541002"
		}, {
			"id": 2384,
			"name": "七星区",
			"zipcode": "541004"
		}, {
			"id": 2385,
			"name": "雁山区",
			"zipcode": "541006"
		}, {
			"id": 2386,
			"name": "阳朔县",
			"zipcode": "541900"
		}, {
			"id": 2387,
			"name": "临桂县",
			"zipcode": "541100"
		}, {
			"id": 2388,
			"name": "灵川县",
			"zipcode": "541200"
		}, {
			"id": 2389,
			"name": "全州县",
			"zipcode": "541500"
		}, {
			"id": 2390,
			"name": "兴安县",
			"zipcode": "541300"
		}, {
			"id": 2391,
			"name": "永福县",
			"zipcode": "541800"
		}, {
			"id": 2392,
			"name": "灌阳县",
			"zipcode": "541600"
		}, {
			"id": 2393,
			"name": "龙胜各族自治县",
			"zipcode": "541700"
		}, {
			"id": 2394,
			"name": "资源县",
			"zipcode": "541400"
		}, {
			"id": 2395,
			"name": "平乐县",
			"zipcode": "542400"
		}, {
			"id": 2396,
			"name": "荔浦县",
			"zipcode": "546600"
		}, {
			"id": 2397,
			"name": "恭城瑶族自治县",
			"zipcode": "542500"
		}]
	}, {
		"id": 257,
		"name": "梧州市",
		"child": [{
			"id": 2398,
			"name": "万秀区",
			"zipcode": "543000"
		}, {
			"id": 2399,
			"name": "蝶山区",
			"zipcode": "543002"
		}, {
			"id": 2400,
			"name": "长洲区",
			"zipcode": "543002"
		}, {
			"id": 2401,
			"name": "苍梧县",
			"zipcode": "543100"
		}, {
			"id": 2402,
			"name": "藤县",
			"zipcode": "543300"
		}, {
			"id": 2403,
			"name": "蒙山县",
			"zipcode": "546700"
		}, {
			"id": 2404,
			"name": "岑溪市",
			"zipcode": "543200"
		}]
	}, {
		"id": 258,
		"name": "北海市",
		"child": [{
			"id": 2405,
			"name": "海城区",
			"zipcode": "536000"
		}, {
			"id": 2406,
			"name": "银海区",
			"zipcode": "536000"
		}, {
			"id": 2407,
			"name": "铁山港区",
			"zipcode": "536017"
		}, {
			"id": 2408,
			"name": "合浦县",
			"zipcode": "536100"
		}]
	}, {
		"id": 259,
		"name": "防城港市",
		"child": [{
			"id": 2409,
			"name": "港口区",
			"zipcode": "538001"
		}, {
			"id": 2410,
			"name": "防城区",
			"zipcode": "538021"
		}, {
			"id": 2411,
			"name": "上思县",
			"zipcode": "535500"
		}, {
			"id": 2412,
			"name": "东兴市",
			"zipcode": "538100"
		}]
	}, {
		"id": 260,
		"name": "钦州市",
		"child": [{
			"id": 2413,
			"name": "钦南区",
			"zipcode": "535000"
		}, {
			"id": 2414,
			"name": "钦北区",
			"zipcode": "535000"
		}, {
			"id": 2415,
			"name": "灵山县",
			"zipcode": "535400"
		}, {
			"id": 2416,
			"name": "浦北县",
			"zipcode": "535300"
		}, {
			"id": 2417,
			"name": "钦州港经济开发区",
			"zipcode": "535008"
		}]
	}, {
		"id": 261,
		"name": "贵港市",
		"child": [{
			"id": 2418,
			"name": "港北区",
			"zipcode": "537100"
		}, {
			"id": 2419,
			"name": "港南区",
			"zipcode": "537132"
		}, {
			"id": 2420,
			"name": "覃塘区",
			"zipcode": "537121"
		}, {
			"id": 2421,
			"name": "平南县",
			"zipcode": "537300"
		}, {
			"id": 2422,
			"name": "桂平市",
			"zipcode": "537200"
		}]
	}, {
		"id": 262,
		"name": "玉林市",
		"child": [{
			"id": 2423,
			"name": "玉州区",
			"zipcode": "537000"
		}, {
			"id": 2424,
			"name": "容县",
			"zipcode": "537500"
		}, {
			"id": 2425,
			"name": "陆川县",
			"zipcode": "537700"
		}, {
			"id": 2426,
			"name": "博白县",
			"zipcode": "537600"
		}, {
			"id": 2427,
			"name": "兴业县",
			"zipcode": "537800"
		}, {
			"id": 2428,
			"name": "北流市",
			"zipcode": "537400"
		}]
	}, {
		"id": 263,
		"name": "百色市",
		"child": [{
			"id": 2429,
			"name": "右江区",
			"zipcode": "533000"
		}, {
			"id": 2430,
			"name": "田阳县",
			"zipcode": "533600"
		}, {
			"id": 2431,
			"name": "田东县",
			"zipcode": "531500"
		}, {
			"id": 2432,
			"name": "平果县",
			"zipcode": "531400"
		}, {
			"id": 2433,
			"name": "德保县",
			"zipcode": "533700"
		}, {
			"id": 2434,
			"name": "靖西县",
			"zipcode": "533800"
		}, {
			"id": 2435,
			"name": "那坡县",
			"zipcode": "533900"
		}, {
			"id": 2436,
			"name": "凌云县",
			"zipcode": "533100"
		}, {
			"id": 2437,
			"name": "乐业县",
			"zipcode": "533200"
		}, {
			"id": 2438,
			"name": "田林县",
			"zipcode": "533300"
		}, {
			"id": 2439,
			"name": "西林县",
			"zipcode": "533500"
		}, {
			"id": 2440,
			"name": "隆林各族自治县",
			"zipcode": "533400"
		}]
	}, {
		"id": 264,
		"name": "贺州市",
		"child": [{
			"id": 2441,
			"name": "八步区",
			"zipcode": "542800"
		}, {
			"id": 2442,
			"name": "昭平县",
			"zipcode": "546800"
		}, {
			"id": 2443,
			"name": "钟山县",
			"zipcode": "542600"
		}, {
			"id": 2444,
			"name": "富川瑶族自治县",
			"zipcode": "542700"
		}]
	}, {
		"id": 265,
		"name": "河池市",
		"child": [{
			"id": 2445,
			"name": "金城江区",
			"zipcode": "547000"
		}, {
			"id": 2446,
			"name": "南丹县",
			"zipcode": "547200"
		}, {
			"id": 2447,
			"name": "天峨县",
			"zipcode": "547300"
		}, {
			"id": 2448,
			"name": "凤山县",
			"zipcode": "547600"
		}, {
			"id": 2449,
			"name": "东兰县",
			"zipcode": "547400"
		}, {
			"id": 2450,
			"name": "罗城仫佬族自治县",
			"zipcode": "546400"
		}, {
			"id": 2451,
			"name": "环江毛南族自治县",
			"zipcode": "547100"
		}, {
			"id": 2452,
			"name": "巴马瑶族自治县",
			"zipcode": "547500"
		}, {
			"id": 2453,
			"name": "都安瑶族自治县",
			"zipcode": "530700"
		}, {
			"id": 2454,
			"name": "大化瑶族自治县",
			"zipcode": "530800"
		}, {
			"id": 2455,
			"name": "宜州市",
			"zipcode": "546300"
		}]
	}, {
		"id": 266,
		"name": "来宾市",
		"child": [{
			"id": 2456,
			"name": "兴宾区",
			"zipcode": "546100"
		}, {
			"id": 2457,
			"name": "忻城县",
			"zipcode": "546200"
		}, {
			"id": 2458,
			"name": "象州县",
			"zipcode": "545800"
		}, {
			"id": 2459,
			"name": "武宣县",
			"zipcode": "545900"
		}, {
			"id": 2460,
			"name": "金秀瑶族自治县",
			"zipcode": "545700"
		}, {
			"id": 2461,
			"name": "合山市",
			"zipcode": "546500"
		}]
	}, {
		"id": 267,
		"name": "崇左市",
		"child": [{
			"id": 2462,
			"name": "江洲区",
			"zipcode": "532200"
		}, {
			"id": 2463,
			"name": "扶绥县",
			"zipcode": "532100"
		}, {
			"id": 2464,
			"name": "宁明县",
			"zipcode": "532500"
		}, {
			"id": 2465,
			"name": "龙州县",
			"zipcode": "532400"
		}, {
			"id": 2466,
			"name": "大新县",
			"zipcode": "532300"
		}, {
			"id": 2467,
			"name": "天等县",
			"zipcode": "532800"
		}, {
			"id": 2468,
			"name": "凭祥市",
			"zipcode": "532600"
		}]
	}]
}, {
	"id": 22,
	"name": "海南",
	"child": [{
		"id": 268,
		"name": "海口市",
		"child": [{
			"id": 2470,
			"name": "秀英区",
			"zipcode": "570311"
		}, {
			"id": 2471,
			"name": "龙华区",
			"zipcode": "570105"
		}, {
			"id": 2472,
			"name": "琼山区",
			"zipcode": "571100"
		}, {
			"id": 2473,
			"name": "美兰区",
			"zipcode": "570203"
		}]
	}, {
		"id": 269,
		"name": "省直辖县级行政单位",
		"child": [{
			"id": 2474,
			"name": "五指山市",
			"zipcode": "572200"
		}, {
			"id": 2475,
			"name": "琼海市",
			"zipcode": "571400"
		}, {
			"id": 2476,
			"name": "儋州市",
			"zipcode": "571700"
		}, {
			"id": 2477,
			"name": "文昌市",
			"zipcode": "571300"
		}, {
			"id": 2478,
			"name": "万宁市",
			"zipcode": "571500"
		}, {
			"id": 2479,
			"name": "东方市",
			"zipcode": "572600"
		}, {
			"id": 2480,
			"name": "定安县",
			"zipcode": "571200"
		}, {
			"id": 2481,
			"name": "屯昌县",
			"zipcode": "571600"
		}, {
			"id": 2482,
			"name": "澄迈县",
			"zipcode": "571900"
		}, {
			"id": 2483,
			"name": "临高县",
			"zipcode": "571800"
		}, {
			"id": 2484,
			"name": "白沙黎族自治县",
			"zipcode": "572800"
		}, {
			"id": 2485,
			"name": "昌江黎族自治县",
			"zipcode": "572700"
		}, {
			"id": 2486,
			"name": "乐东黎族自治县",
			"zipcode": "572500"
		}, {
			"id": 2487,
			"name": "陵水黎族自治县",
			"zipcode": "572400"
		}, {
			"id": 2488,
			"name": "保亭黎族苗族自治县",
			"zipcode": "572300"
		}, {
			"id": 2489,
			"name": "琼中黎族苗族自治县",
			"zipcode": "572900"
		}, {
			"id": 2490,
			"name": "西、南、中沙群岛办事处",
			"zipcode": "573100"
		}]
	}, {
		"id": 270,
		"name": "三亚市",
		"child": [{
			"id": 2491,
			"name": "河西区",
			"zipcode": "572000"
		}, {
			"id": 2492,
			"name": "河东区",
			"zipcode": "572000"
		}, {
			"id": 2493,
			"name": "田独镇",
			"zipcode": "572011"
		}, {
			"id": 2494,
			"name": "凤凰镇",
			"zipcode": "572023"
		}, {
			"id": 2495,
			"name": "三亚市",
			"zipcode": "572000"
		}, {
			"id": 2496,
			"name": "崖城镇",
			"zipcode": "572025"
		}, {
			"id": 2497,
			"name": "天涯镇",
			"zipcode": "572029"
		}, {
			"id": 2498,
			"name": "育才乡",
			"zipcode": "572032"
		}, {
			"id": 2499,
			"name": "海棠湾镇",
			"zipcode": "572014"
		}]
	}]
}, {
	"id": 23,
	"name": "重庆",
	"child": [{
		"id": 271,
		"name": "重庆市",
		"child": [{
			"id": 2500,
			"name": "万州区",
			"zipcode": "404100"
		}, {
			"id": 2501,
			"name": "涪陵区",
			"zipcode": "408000"
		}, {
			"id": 2502,
			"name": "渝中区",
			"zipcode": "400010"
		}, {
			"id": 2503,
			"name": "大渡口区",
			"zipcode": "400080"
		}, {
			"id": 2504,
			"name": "江北区",
			"zipcode": "400020"
		}, {
			"id": 2505,
			"name": "沙坪坝区",
			"zipcode": "400030"
		}, {
			"id": 2506,
			"name": "九龙坡区",
			"zipcode": "400050"
		}, {
			"id": 2507,
			"name": "南岸区",
			"zipcode": "400064"
		}, {
			"id": 2508,
			"name": "北碚区",
			"zipcode": "400700"
		}, {
			"id": 2509,
			"name": "万盛区",
			"zipcode": "400800"
		}, {
			"id": 2510,
			"name": "双桥区",
			"zipcode": "400900"
		}, {
			"id": 2511,
			"name": "渝北区",
			"zipcode": "401120"
		}, {
			"id": 2512,
			"name": "巴南区",
			"zipcode": "401320"
		}, {
			"id": 2513,
			"name": "黔江区",
			"zipcode": "409700"
		}, {
			"id": 2514,
			"name": "长寿区",
			"zipcode": "401220"
		}, {
			"id": 2515,
			"name": "綦江县",
			"zipcode": "401420"
		}, {
			"id": 2516,
			"name": "潼南县",
			"zipcode": "402660"
		}, {
			"id": 2517,
			"name": "铜梁县",
			"zipcode": "402560"
		}, {
			"id": 2518,
			"name": "大足县",
			"zipcode": "402360"
		}, {
			"id": 2519,
			"name": "荣昌县",
			"zipcode": "402460"
		}, {
			"id": 2520,
			"name": "璧山县",
			"zipcode": "402760"
		}, {
			"id": 2521,
			"name": "梁平县",
			"zipcode": "405200"
		}, {
			"id": 2522,
			"name": "城口县",
			"zipcode": "405900"
		}, {
			"id": 2523,
			"name": "丰都县",
			"zipcode": "408200"
		}, {
			"id": 2524,
			"name": "垫江县",
			"zipcode": "408300"
		}, {
			"id": 2525,
			"name": "武隆县",
			"zipcode": "408500"
		}, {
			"id": 2526,
			"name": "忠县",
			"zipcode": "404300"
		}, {
			"id": 2527,
			"name": "开县",
			"zipcode": "405400"
		}, {
			"id": 2528,
			"name": "云阳县",
			"zipcode": "404500"
		}, {
			"id": 2529,
			"name": "奉节县",
			"zipcode": "404600"
		}, {
			"id": 2530,
			"name": "巫山县",
			"zipcode": "404700"
		}, {
			"id": 2531,
			"name": "巫溪县",
			"zipcode": "405800"
		}, {
			"id": 2532,
			"name": "石柱土家族自治县",
			"zipcode": "409100"
		}, {
			"id": 2533,
			"name": "秀山土家族苗族自治县",
			"zipcode": "409900"
		}, {
			"id": 2534,
			"name": "酉阳土家族苗族自治县",
			"zipcode": "409800"
		}, {
			"id": 2535,
			"name": "彭水苗族土家族自治县",
			"zipcode": "409600"
		}, {
			"id": 2536,
			"name": "高新区",
			"zipcode": "400039"
		}, {
			"id": 2537,
			"name": "江津区",
			"zipcode": "402260"
		}, {
			"id": 2538,
			"name": "合川区",
			"zipcode": "401520"
		}, {
			"id": 2539,
			"name": "永川区",
			"zipcode": "402160"
		}, {
			"id": 2540,
			"name": "南川区",
			"zipcode": "408400"
		}]
	}]
}, {
	"id": 24,
	"name": "四川",
	"child": [{
		"id": 272,
		"name": "成都市",
		"child": [{
			"id": 2541,
			"name": "锦江区",
			"zipcode": "610021"
		}, {
			"id": 2542,
			"name": "青羊区",
			"zipcode": "610031"
		}, {
			"id": 2543,
			"name": "金牛区",
			"zipcode": "610036"
		}, {
			"id": 2544,
			"name": "武侯区",
			"zipcode": "610041"
		}, {
			"id": 2545,
			"name": "成华区",
			"zipcode": "610066"
		}, {
			"id": 2546,
			"name": "龙泉驿区",
			"zipcode": "610100"
		}, {
			"id": 2547,
			"name": "青白江区",
			"zipcode": "610300"
		}, {
			"id": 2548,
			"name": "新都区",
			"zipcode": "610500"
		}, {
			"id": 2549,
			"name": "温江区",
			"zipcode": "611130"
		}, {
			"id": 2550,
			"name": "金堂县",
			"zipcode": "610400"
		}, {
			"id": 2551,
			"name": "双流县",
			"zipcode": "610200"
		}, {
			"id": 2552,
			"name": "郫县",
			"zipcode": "611700"
		}, {
			"id": 2553,
			"name": "大邑县",
			"zipcode": "611300"
		}, {
			"id": 2554,
			"name": "蒲江县",
			"zipcode": "611630"
		}, {
			"id": 2555,
			"name": "新津县",
			"zipcode": "611430"
		}, {
			"id": 2556,
			"name": "都江堰市",
			"zipcode": "611830"
		}, {
			"id": 2557,
			"name": "彭州市",
			"zipcode": "611930"
		}, {
			"id": 2558,
			"name": "邛崃市",
			"zipcode": "611530"
		}, {
			"id": 2559,
			"name": "崇州市",
			"zipcode": "611230"
		}, {
			"id": 2560,
			"name": "高新区",
			"zipcode": "610041"
		}, {
			"id": 2561,
			"name": "高新西区",
			"zipcode": "611731"
		}]
	}, {
		"id": 273,
		"name": "自贡市",
		"child": [{
			"id": 2562,
			"name": "自流井区",
			"zipcode": "643000"
		}, {
			"id": 2563,
			"name": "贡井区",
			"zipcode": "643020"
		}, {
			"id": 2564,
			"name": "大安区",
			"zipcode": "643010"
		}, {
			"id": 2565,
			"name": "沿滩区",
			"zipcode": "643030"
		}, {
			"id": 2566,
			"name": "荣县",
			"zipcode": "643100"
		}, {
			"id": 2567,
			"name": "富顺县",
			"zipcode": "643200"
		}]
	}, {
		"id": 274,
		"name": "攀枝花市",
		"child": [{
			"id": 2568,
			"name": "东区",
			"zipcode": "617067"
		}, {
			"id": 2569,
			"name": "西区",
			"zipcode": "617068"
		}, {
			"id": 2570,
			"name": "仁和区",
			"zipcode": "617061"
		}, {
			"id": 2571,
			"name": "米易县",
			"zipcode": "617200"
		}, {
			"id": 2572,
			"name": "盐边县",
			"zipcode": "617100"
		}]
	}, {
		"id": 275,
		"name": "泸州市",
		"child": [{
			"id": 2573,
			"name": "江阳区",
			"zipcode": "646000"
		}, {
			"id": 2574,
			"name": "纳溪区",
			"zipcode": "646300"
		}, {
			"id": 2575,
			"name": "龙马潭区",
			"zipcode": "646000"
		}, {
			"id": 2576,
			"name": "泸县",
			"zipcode": "646106"
		}, {
			"id": 2577,
			"name": "合江县",
			"zipcode": "646200"
		}, {
			"id": 2578,
			"name": "叙永县",
			"zipcode": "646400"
		}, {
			"id": 2579,
			"name": "古蔺县",
			"zipcode": "646500"
		}]
	}, {
		"id": 276,
		"name": "德阳市",
		"child": [{
			"id": 2580,
			"name": "旌阳区",
			"zipcode": "618000"
		}, {
			"id": 2581,
			"name": "中江县",
			"zipcode": "618100"
		}, {
			"id": 2582,
			"name": "罗江县",
			"zipcode": "618500"
		}, {
			"id": 2583,
			"name": "广汉市",
			"zipcode": "618300"
		}, {
			"id": 2584,
			"name": "什邡市",
			"zipcode": "618400"
		}, {
			"id": 2585,
			"name": "绵竹市",
			"zipcode": "618200"
		}]
	}, {
		"id": 277,
		"name": "绵阳市",
		"child": [{
			"id": 2586,
			"name": "涪城区",
			"zipcode": "621000"
		}, {
			"id": 2587,
			"name": "游仙区",
			"zipcode": "621022"
		}, {
			"id": 2588,
			"name": "三台县",
			"zipcode": "621100"
		}, {
			"id": 2589,
			"name": "盐亭县",
			"zipcode": "621600"
		}, {
			"id": 2590,
			"name": "安县",
			"zipcode": "622650"
		}, {
			"id": 2591,
			"name": "梓潼县",
			"zipcode": "622150"
		}, {
			"id": 2592,
			"name": "北川羌族自治县",
			"zipcode": "622750"
		}, {
			"id": 2593,
			"name": "平武县",
			"zipcode": "622550"
		}, {
			"id": 2594,
			"name": "江油市",
			"zipcode": "621700"
		}, {
			"id": 2595,
			"name": "农科区",
			"zipcode": "621023"
		}, {
			"id": 2596,
			"name": "经济技术开发区",
			"zipcode": "621000"
		}, {
			"id": 2597,
			"name": "高新区",
			"zipcode": "621000"
		}, {
			"id": 2598,
			"name": "仙海区",
			"zipcode": "621007"
		}]
	}, {
		"id": 278,
		"name": "广元市",
		"child": [{
			"id": 2599,
			"name": "利州区",
			"zipcode": "628017"
		}, {
			"id": 2600,
			"name": "元坝区",
			"zipcode": "628017"
		}, {
			"id": 2601,
			"name": "朝天区",
			"zipcode": "628017"
		}, {
			"id": 2602,
			"name": "旺苍县",
			"zipcode": "628200"
		}, {
			"id": 2603,
			"name": "青川县",
			"zipcode": "628100"
		}, {
			"id": 2604,
			"name": "剑阁县",
			"zipcode": "628300"
		}, {
			"id": 2605,
			"name": "苍溪县",
			"zipcode": "628400"
		}]
	}, {
		"id": 279,
		"name": "遂宁市",
		"child": [{
			"id": 2606,
			"name": "船山区",
			"zipcode": "629000"
		}, {
			"id": 2607,
			"name": "安居区",
			"zipcode": "629000"
		}, {
			"id": 2608,
			"name": "蓬溪县",
			"zipcode": "629100"
		}, {
			"id": 2609,
			"name": "射洪县",
			"zipcode": "629200"
		}, {
			"id": 2610,
			"name": "大英县",
			"zipcode": "629300"
		}]
	}, {
		"id": 280,
		"name": "内江市",
		"child": [{
			"id": 2611,
			"name": "市中区",
			"zipcode": "641000"
		}, {
			"id": 2612,
			"name": "东兴区",
			"zipcode": "641100"
		}, {
			"id": 2613,
			"name": "威远县",
			"zipcode": "642450"
		}, {
			"id": 2614,
			"name": "资中县",
			"zipcode": "641200"
		}, {
			"id": 2615,
			"name": "隆昌县",
			"zipcode": "642150"
		}]
	}, {
		"id": 281,
		"name": "乐山市",
		"child": [{
			"id": 2616,
			"name": "市中区",
			"zipcode": "614000"
		}, {
			"id": 2617,
			"name": "沙湾区",
			"zipcode": "614900"
		}, {
			"id": 2618,
			"name": "五通桥区",
			"zipcode": "614800"
		}, {
			"id": 2619,
			"name": "金口河区",
			"zipcode": "614700"
		}, {
			"id": 2620,
			"name": "犍为县",
			"zipcode": "614400"
		}, {
			"id": 2621,
			"name": "井研县",
			"zipcode": "613100"
		}, {
			"id": 2622,
			"name": "夹江县",
			"zipcode": "614100"
		}, {
			"id": 2623,
			"name": "沐川县",
			"zipcode": "614500"
		}, {
			"id": 2624,
			"name": "峨边彝族自治县",
			"zipcode": "614300"
		}, {
			"id": 2625,
			"name": "马边彝族自治县",
			"zipcode": "614600"
		}, {
			"id": 2626,
			"name": "峨眉山市",
			"zipcode": "614200"
		}]
	}, {
		"id": 282,
		"name": "南充市",
		"child": [{
			"id": 2627,
			"name": "顺庆区",
			"zipcode": "637000"
		}, {
			"id": 2628,
			"name": "高坪区",
			"zipcode": "637100"
		}, {
			"id": 2629,
			"name": "嘉陵区",
			"zipcode": "637100"
		}, {
			"id": 2630,
			"name": "南部县",
			"zipcode": "637300"
		}, {
			"id": 2631,
			"name": "营山县",
			"zipcode": "637700"
		}, {
			"id": 2632,
			"name": "蓬安县",
			"zipcode": "637800"
		}, {
			"id": 2633,
			"name": "仪陇县",
			"zipcode": "637600"
		}, {
			"id": 2634,
			"name": "西充县",
			"zipcode": "637200"
		}, {
			"id": 2635,
			"name": "阆中市",
			"zipcode": "637400"
		}]
	}, {
		"id": 283,
		"name": "眉山市",
		"child": [{
			"id": 2636,
			"name": "东坡区",
			"zipcode": "620010"
		}, {
			"id": 2637,
			"name": "仁寿县",
			"zipcode": "620500"
		}, {
			"id": 2638,
			"name": "彭山县",
			"zipcode": "620860"
		}, {
			"id": 2639,
			"name": "洪雅县",
			"zipcode": "620360"
		}, {
			"id": 2640,
			"name": "丹棱县",
			"zipcode": "620200"
		}, {
			"id": 2641,
			"name": "青神县",
			"zipcode": "620460"
		}]
	}, {
		"id": 284,
		"name": "宜宾市",
		"child": [{
			"id": 2642,
			"name": "翠屏区",
			"zipcode": "644000"
		}, {
			"id": 2643,
			"name": "宜宾县",
			"zipcode": "644600"
		}, {
			"id": 2644,
			"name": "南溪县",
			"zipcode": "644100"
		}, {
			"id": 2645,
			"name": "江安县",
			"zipcode": "644200"
		}, {
			"id": 2646,
			"name": "长宁县",
			"zipcode": "644300"
		}, {
			"id": 2647,
			"name": "高县",
			"zipcode": "645150"
		}, {
			"id": 2648,
			"name": "珙县",
			"zipcode": "644500"
		}, {
			"id": 2649,
			"name": "筠连县",
			"zipcode": "645250"
		}, {
			"id": 2650,
			"name": "兴文县",
			"zipcode": "644400"
		}, {
			"id": 2651,
			"name": "屏山县",
			"zipcode": "645350"
		}]
	}, {
		"id": 285,
		"name": "广安市",
		"child": [{
			"id": 2652,
			"name": "广安区",
			"zipcode": "638000"
		}, {
			"id": 2653,
			"name": "岳池县",
			"zipcode": "638300"
		}, {
			"id": 2654,
			"name": "武胜县",
			"zipcode": "638400"
		}, {
			"id": 2655,
			"name": "邻水县",
			"zipcode": "638500"
		}, {
			"id": 2656,
			"name": "华蓥市",
			"zipcode": "638600"
		}]
	}, {
		"id": 286,
		"name": "达州市",
		"child": [{
			"id": 2657,
			"name": "通川区",
			"zipcode": "635000"
		}, {
			"id": 2658,
			"name": "达县",
			"zipcode": "635000"
		}, {
			"id": 2659,
			"name": "宣汉县",
			"zipcode": "636150"
		}, {
			"id": 2660,
			"name": "开江县",
			"zipcode": "636250"
		}, {
			"id": 2661,
			"name": "大竹县",
			"zipcode": "635100"
		}, {
			"id": 2662,
			"name": "渠县",
			"zipcode": "635200"
		}, {
			"id": 2663,
			"name": "万源市",
			"zipcode": "636350"
		}]
	}, {
		"id": 287,
		"name": "雅安市",
		"child": [{
			"id": 2664,
			"name": "雨城区",
			"zipcode": "625000"
		}, {
			"id": 2665,
			"name": "名山县",
			"zipcode": "625100"
		}, {
			"id": 2666,
			"name": "荥经县",
			"zipcode": "625200"
		}, {
			"id": 2667,
			"name": "汉源县",
			"zipcode": "625300"
		}, {
			"id": 2668,
			"name": "石棉县",
			"zipcode": "625400"
		}, {
			"id": 2669,
			"name": "天全县",
			"zipcode": "625500"
		}, {
			"id": 2670,
			"name": "芦山县",
			"zipcode": "625600"
		}, {
			"id": 2671,
			"name": "宝兴县",
			"zipcode": "625700"
		}]
	}, {
		"id": 288,
		"name": "巴中市",
		"child": [{
			"id": 2672,
			"name": "巴州区",
			"zipcode": "636001"
		}, {
			"id": 2673,
			"name": "通江县",
			"zipcode": "636700"
		}, {
			"id": 2674,
			"name": "南江县",
			"zipcode": "636600"
		}, {
			"id": 2675,
			"name": "平昌县",
			"zipcode": "636400"
		}]
	}, {
		"id": 289,
		"name": "资阳市",
		"child": [{
			"id": 2676,
			"name": "雁江区",
			"zipcode": "641300"
		}, {
			"id": 2677,
			"name": "安岳县",
			"zipcode": "642350"
		}, {
			"id": 2678,
			"name": "乐至县",
			"zipcode": "641500"
		}, {
			"id": 2679,
			"name": "简阳市",
			"zipcode": "641400"
		}]
	}, {
		"id": 290,
		"name": "阿坝藏族羌族自治州",
		"child": [{
			"id": 2680,
			"name": "汶川县",
			"zipcode": "623000"
		}, {
			"id": 2681,
			"name": "理县",
			"zipcode": "623100"
		}, {
			"id": 2682,
			"name": "茂县",
			"zipcode": "623200"
		}, {
			"id": 2683,
			"name": "松潘县",
			"zipcode": "623300"
		}, {
			"id": 2684,
			"name": "九寨沟县",
			"zipcode": "623400"
		}, {
			"id": 2685,
			"name": "金川县",
			"zipcode": "624100"
		}, {
			"id": 2686,
			"name": "小金县",
			"zipcode": "624200"
		}, {
			"id": 2687,
			"name": "黑水县",
			"zipcode": "623500"
		}, {
			"id": 2688,
			"name": "马尔康县",
			"zipcode": "624000"
		}, {
			"id": 2689,
			"name": "壤塘县",
			"zipcode": "624300"
		}, {
			"id": 2690,
			"name": "阿坝县",
			"zipcode": "624600"
		}, {
			"id": 2691,
			"name": "若尔盖县",
			"zipcode": "624500"
		}, {
			"id": 2692,
			"name": "红原县",
			"zipcode": "624400"
		}]
	}, {
		"id": 291,
		"name": "甘孜藏族自治州",
		"child": [{
			"id": 2693,
			"name": "康定县",
			"zipcode": "626000"
		}, {
			"id": 2694,
			"name": "泸定县",
			"zipcode": "626100"
		}, {
			"id": 2695,
			"name": "丹巴县",
			"zipcode": "626300"
		}, {
			"id": 2696,
			"name": "九龙县",
			"zipcode": "626200"
		}, {
			"id": 2697,
			"name": "雅江县",
			"zipcode": "627450"
		}, {
			"id": 2698,
			"name": "道孚县",
			"zipcode": "626400"
		}, {
			"id": 2699,
			"name": "炉霍县",
			"zipcode": "626500"
		}, {
			"id": 2700,
			"name": "甘孜县",
			"zipcode": "626700"
		}, {
			"id": 2701,
			"name": "新龙县",
			"zipcode": "626800"
		}, {
			"id": 2702,
			"name": "德格县",
			"zipcode": "627250"
		}, {
			"id": 2703,
			"name": "白玉县",
			"zipcode": "200000"
		}, {
			"id": 2704,
			"name": "石渠县",
			"zipcode": "200000"
		}, {
			"id": 2705,
			"name": "色达县",
			"zipcode": "201100"
		}, {
			"id": 2706,
			"name": "理塘县",
			"zipcode": "200000"
		}, {
			"id": 2707,
			"name": "巴塘县",
			"zipcode": "200120"
		}, {
			"id": 2708,
			"name": "乡城县",
			"zipcode": "200000"
		}, {
			"id": 2709,
			"name": "稻城县",
			"zipcode": "200000"
		}, {
			"id": 2710,
			"name": "得荣县",
			"zipcode": "200000"
		}]
	}, {
		"id": 292,
		"name": "凉山彝族自治州",
		"child": [{
			"id": 2711,
			"name": "西昌市",
			"zipcode": "200000"
		}, {
			"id": 2712,
			"name": "木里藏族自治县",
			"zipcode": "200000"
		}, {
			"id": 2713,
			"name": "盐源县",
			"zipcode": "200000"
		}, {
			"id": 2714,
			"name": "德昌县",
			"zipcode": "201300"
		}, {
			"id": 2715,
			"name": "会理县",
			"zipcode": "201600"
		}, {
			"id": 2716,
			"name": "会东县",
			"zipcode": "201800"
		}, {
			"id": 2717,
			"name": "宁南县",
			"zipcode": "201900"
		}, {
			"id": 2718,
			"name": "普格县",
			"zipcode": "201700"
		}, {
			"id": 2719,
			"name": "布拖县",
			"zipcode": "201500"
		}, {
			"id": 2720,
			"name": "金阳县",
			"zipcode": "201400"
		}, {
			"id": 2721,
			"name": "昭觉县",
			"zipcode": "202150"
		}, {
			"id": 2722,
			"name": "喜德县",
			"zipcode": "616750"
		}, {
			"id": 2723,
			"name": "冕宁县",
			"zipcode": "615600"
		}, {
			"id": 2724,
			"name": "越西县",
			"zipcode": "616650"
		}, {
			"id": 2725,
			"name": "甘洛县",
			"zipcode": "616850"
		}, {
			"id": 2726,
			"name": "美姑县",
			"zipcode": "616450"
		}, {
			"id": 2727,
			"name": "雷波县",
			"zipcode": "616550"
		}]
	}]
}, {
	"id": 25,
	"name": "贵州",
	"child": [{
		"id": 293,
		"name": "贵阳市",
		"child": [{
			"id": 2728,
			"name": "南明区",
			"zipcode": "550001"
		}, {
			"id": 2729,
			"name": "云岩区",
			"zipcode": "550001"
		}, {
			"id": 2730,
			"name": "花溪区",
			"zipcode": "550025"
		}, {
			"id": 2731,
			"name": "乌当区",
			"zipcode": "550018"
		}, {
			"id": 2732,
			"name": "白云区",
			"zipcode": "550014"
		}, {
			"id": 2733,
			"name": "小河区",
			"zipcode": "550009"
		}, {
			"id": 2734,
			"name": "开阳县",
			"zipcode": "550300"
		}, {
			"id": 2735,
			"name": "息烽县",
			"zipcode": "551100"
		}, {
			"id": 2736,
			"name": "修文县",
			"zipcode": "550200"
		}, {
			"id": 2737,
			"name": "清镇市",
			"zipcode": "551400"
		}, {
			"id": 2738,
			"name": "金阳新区",
			"zipcode": "550081"
		}]
	}, {
		"id": 294,
		"name": "六盘水市",
		"child": [{
			"id": 2739,
			"name": "钟山区",
			"zipcode": "553000"
		}, {
			"id": 2740,
			"name": "六枝特区",
			"zipcode": "553400"
		}, {
			"id": 2741,
			"name": "水城县",
			"zipcode": "553000"
		}, {
			"id": 2742,
			"name": "盘县",
			"zipcode": "561601"
		}]
	}, {
		"id": 295,
		"name": "遵义市",
		"child": [{
			"id": 2743,
			"name": "红花岗区",
			"zipcode": "563000"
		}, {
			"id": 2744,
			"name": "汇川区",
			"zipcode": "563000"
		}, {
			"id": 2745,
			"name": "遵义县",
			"zipcode": "563100"
		}, {
			"id": 2746,
			"name": "桐梓县",
			"zipcode": "563200"
		}, {
			"id": 2747,
			"name": "绥阳县",
			"zipcode": "563300"
		}, {
			"id": 2748,
			"name": "正安县",
			"zipcode": "563400"
		}, {
			"id": 2749,
			"name": "道真仡佬族苗族自治县",
			"zipcode": "563500"
		}, {
			"id": 2750,
			"name": "务川仡佬族苗族自治县",
			"zipcode": "564300"
		}, {
			"id": 2751,
			"name": "凤冈县",
			"zipcode": "564200"
		}, {
			"id": 2752,
			"name": "湄潭县",
			"zipcode": "564100"
		}, {
			"id": 2753,
			"name": "余庆县",
			"zipcode": "564400"
		}, {
			"id": 2754,
			"name": "习水县",
			"zipcode": "564600"
		}, {
			"id": 2755,
			"name": "赤水市",
			"zipcode": "564700"
		}, {
			"id": 2756,
			"name": "仁怀市",
			"zipcode": "564500"
		}]
	}, {
		"id": 296,
		"name": "安顺市",
		"child": [{
			"id": 2757,
			"name": "西秀区",
			"zipcode": "561000"
		}, {
			"id": 2758,
			"name": "平坝县",
			"zipcode": "561100"
		}, {
			"id": 2759,
			"name": "普定县",
			"zipcode": "562100"
		}, {
			"id": 2760,
			"name": "镇宁布依族苗族自治县",
			"zipcode": "561200"
		}, {
			"id": 2761,
			"name": "关岭布依族苗族自治县",
			"zipcode": "561300"
		}, {
			"id": 2762,
			"name": "紫云苗族布依族自治县",
			"zipcode": "550800"
		}]
	}, {
		"id": 297,
		"name": "铜仁地区",
		"child": [{
			"id": 2763,
			"name": "铜仁市",
			"zipcode": "554300"
		}, {
			"id": 2764,
			"name": "江口县",
			"zipcode": "554400"
		}, {
			"id": 2765,
			"name": "玉屏侗族自治县",
			"zipcode": "554004"
		}, {
			"id": 2766,
			"name": "石阡县",
			"zipcode": "555100"
		}, {
			"id": 2767,
			"name": "思南县",
			"zipcode": "565100"
		}, {
			"id": 2768,
			"name": "印江土家族苗族自治县",
			"zipcode": "555200"
		}, {
			"id": 2769,
			"name": "德江县",
			"zipcode": "565200"
		}, {
			"id": 2770,
			"name": "沿河土家族自治县",
			"zipcode": "565300"
		}, {
			"id": 2771,
			"name": "松桃苗族自治县",
			"zipcode": "554100"
		}, {
			"id": 2772,
			"name": "万山特区",
			"zipcode": "554200"
		}]
	}, {
		"id": 298,
		"name": "黔西南布依族苗族自治州",
		"child": [{
			"id": 2773,
			"name": "兴义市",
			"zipcode": "562400"
		}, {
			"id": 2774,
			"name": "兴仁县",
			"zipcode": "562300"
		}, {
			"id": 2775,
			"name": "普安县",
			"zipcode": "561500"
		}, {
			"id": 2776,
			"name": "晴隆县",
			"zipcode": "561400"
		}, {
			"id": 2777,
			"name": "贞丰县",
			"zipcode": "562200"
		}, {
			"id": 2778,
			"name": "望谟县",
			"zipcode": "552300"
		}, {
			"id": 2779,
			"name": "册亨县",
			"zipcode": "552200"
		}, {
			"id": 2780,
			"name": "安龙县",
			"zipcode": "552400"
		}]
	}, {
		"id": 299,
		"name": "毕节地区",
		"child": [{
			"id": 2781,
			"name": "毕节市",
			"zipcode": "551700"
		}, {
			"id": 2782,
			"name": "大方县",
			"zipcode": "551600"
		}, {
			"id": 2783,
			"name": "黔西县",
			"zipcode": "551500"
		}, {
			"id": 2784,
			"name": "金沙县",
			"zipcode": "551800"
		}, {
			"id": 2785,
			"name": "织金县",
			"zipcode": "552100"
		}, {
			"id": 2786,
			"name": "纳雍县",
			"zipcode": "553300"
		}, {
			"id": 2787,
			"name": "威宁彝族回族苗族自治县",
			"zipcode": "553100"
		}, {
			"id": 2788,
			"name": "赫章县",
			"zipcode": "553200"
		}]
	}, {
		"id": 300,
		"name": "黔东南苗族侗族自治州",
		"child": [{
			"id": 2789,
			"name": "凯里市",
			"zipcode": "556000"
		}, {
			"id": 2790,
			"name": "黄平县",
			"zipcode": "556100"
		}, {
			"id": 2791,
			"name": "施秉县",
			"zipcode": "556200"
		}, {
			"id": 2792,
			"name": "三穗县",
			"zipcode": "556500"
		}, {
			"id": 2793,
			"name": "镇远县",
			"zipcode": "557700"
		}, {
			"id": 2794,
			"name": "岑巩县",
			"zipcode": "557800"
		}, {
			"id": 2795,
			"name": "天柱县",
			"zipcode": "556600"
		}, {
			"id": 2796,
			"name": "锦屏县",
			"zipcode": "556700"
		}, {
			"id": 2797,
			"name": "剑河县",
			"zipcode": "556400"
		}, {
			"id": 2798,
			"name": "台江县",
			"zipcode": "556300"
		}, {
			"id": 2799,
			"name": "黎平县",
			"zipcode": "557300"
		}, {
			"id": 2800,
			"name": "榕江县",
			"zipcode": "557200"
		}, {
			"id": 2801,
			"name": "从江县",
			"zipcode": "557400"
		}, {
			"id": 2802,
			"name": "雷山县",
			"zipcode": "557100"
		}, {
			"id": 2803,
			"name": "麻江县",
			"zipcode": "557600"
		}, {
			"id": 2804,
			"name": "丹寨县",
			"zipcode": "557500"
		}]
	}, {
		"id": 301,
		"name": "黔南布依族苗族自治州",
		"child": [{
			"id": 2805,
			"name": "都匀市",
			"zipcode": "558000"
		}, {
			"id": 2806,
			"name": "福泉市",
			"zipcode": "550500"
		}, {
			"id": 2807,
			"name": "荔波县",
			"zipcode": "558400"
		}, {
			"id": 2808,
			"name": "贵定县",
			"zipcode": "551300"
		}, {
			"id": 2809,
			"name": "瓮安县",
			"zipcode": "550400"
		}, {
			"id": 2810,
			"name": "独山县",
			"zipcode": "558200"
		}, {
			"id": 2811,
			"name": "平塘县",
			"zipcode": "558300"
		}, {
			"id": 2812,
			"name": "罗甸县",
			"zipcode": "550100"
		}, {
			"id": 2813,
			"name": "长顺县",
			"zipcode": "550700"
		}, {
			"id": 2814,
			"name": "龙里县",
			"zipcode": "551200"
		}, {
			"id": 2815,
			"name": "惠水县",
			"zipcode": "550600"
		}, {
			"id": 2816,
			"name": "三都水族自治县",
			"zipcode": "558100"
		}]
	}]
}, {
	"id": 26,
	"name": "云南",
	"child": [{
		"id": 302,
		"name": "昆明市",
		"child": [{
			"id": 2817,
			"name": "五华区",
			"zipcode": "650032"
		}, {
			"id": 2818,
			"name": "盘龙区",
			"zipcode": "650051"
		}, {
			"id": 2819,
			"name": "官渡区",
			"zipcode": "650220"
		}, {
			"id": 2820,
			"name": "西山区",
			"zipcode": "650100"
		}, {
			"id": 2821,
			"name": "东川区",
			"zipcode": "654100"
		}, {
			"id": 2822,
			"name": "呈贡县",
			"zipcode": "650500"
		}, {
			"id": 2823,
			"name": "晋宁县",
			"zipcode": "650600"
		}, {
			"id": 2824,
			"name": "富民县",
			"zipcode": "650400"
		}, {
			"id": 2825,
			"name": "宜良县",
			"zipcode": "652100"
		}, {
			"id": 2826,
			"name": "石林彝族自治县",
			"zipcode": "652200"
		}, {
			"id": 2827,
			"name": "嵩明县",
			"zipcode": "651700"
		}, {
			"id": 2828,
			"name": "禄劝彝族苗族自治县",
			"zipcode": "651500"
		}, {
			"id": 2829,
			"name": "寻甸回族彝族自治县",
			"zipcode": "655200"
		}, {
			"id": 2830,
			"name": "安宁市",
			"zipcode": "650300"
		}]
	}, {
		"id": 303,
		"name": "曲靖市",
		"child": [{
			"id": 2831,
			"name": "麒麟区",
			"zipcode": "655000"
		}, {
			"id": 2832,
			"name": "马龙县",
			"zipcode": "655100"
		}, {
			"id": 2833,
			"name": "陆良县",
			"zipcode": "655600"
		}, {
			"id": 2834,
			"name": "师宗县",
			"zipcode": "655700"
		}, {
			"id": 2835,
			"name": "罗平县",
			"zipcode": "655800"
		}, {
			"id": 2836,
			"name": "富源县",
			"zipcode": "655500"
		}, {
			"id": 2837,
			"name": "会泽县",
			"zipcode": "654200"
		}, {
			"id": 2838,
			"name": "沾益县",
			"zipcode": "655331"
		}, {
			"id": 2839,
			"name": "宣威市",
			"zipcode": "655400"
		}]
	}, {
		"id": 304,
		"name": "玉溪市",
		"child": [{
			"id": 2840,
			"name": "红塔区",
			"zipcode": "653100"
		}, {
			"id": 2841,
			"name": "江川县",
			"zipcode": "652600"
		}, {
			"id": 2842,
			"name": "澄江县",
			"zipcode": "652500"
		}, {
			"id": 2843,
			"name": "通海县",
			"zipcode": "652700"
		}, {
			"id": 2844,
			"name": "华宁县",
			"zipcode": "652800"
		}, {
			"id": 2845,
			"name": "易门县",
			"zipcode": "651100"
		}, {
			"id": 2846,
			"name": "峨山彝族自治县",
			"zipcode": "653200"
		}, {
			"id": 2847,
			"name": "新平彝族傣族自治县",
			"zipcode": "653400"
		}, {
			"id": 2848,
			"name": "元江哈尼族彝族傣族自治县",
			"zipcode": "653300"
		}]
	}, {
		"id": 305,
		"name": "保山市",
		"child": [{
			"id": 2849,
			"name": "隆阳区",
			"zipcode": "678000"
		}, {
			"id": 2850,
			"name": "施甸县",
			"zipcode": "678200"
		}, {
			"id": 2851,
			"name": "腾冲县",
			"zipcode": "679100"
		}, {
			"id": 2852,
			"name": "龙陵县",
			"zipcode": "678300"
		}, {
			"id": 2853,
			"name": "昌宁县",
			"zipcode": "678100"
		}]
	}, {
		"id": 306,
		"name": "昭通市",
		"child": [{
			"id": 2854,
			"name": "昭阳区",
			"zipcode": "657000"
		}, {
			"id": 2855,
			"name": "鲁甸县",
			"zipcode": "657100"
		}, {
			"id": 2856,
			"name": "巧家县",
			"zipcode": "654600"
		}, {
			"id": 2857,
			"name": "盐津县",
			"zipcode": "657500"
		}, {
			"id": 2858,
			"name": "大关县",
			"zipcode": "657400"
		}, {
			"id": 2859,
			"name": "永善县",
			"zipcode": "657300"
		}, {
			"id": 2860,
			"name": "绥江县",
			"zipcode": "657700"
		}, {
			"id": 2861,
			"name": "镇雄县",
			"zipcode": "657200"
		}, {
			"id": 2862,
			"name": "彝良县",
			"zipcode": "657600"
		}, {
			"id": 2863,
			"name": "威信县",
			"zipcode": "657900"
		}, {
			"id": 2864,
			"name": "水富县",
			"zipcode": "657800"
		}]
	}, {
		"id": 307,
		"name": "丽江市",
		"child": [{
			"id": 2865,
			"name": "古城区",
			"zipcode": "674100"
		}, {
			"id": 2866,
			"name": "玉龙纳西族自治县",
			"zipcode": "674100"
		}, {
			"id": 2867,
			"name": "永胜县",
			"zipcode": "674200"
		}, {
			"id": 2868,
			"name": "华坪县",
			"zipcode": "674800"
		}, {
			"id": 2869,
			"name": "宁蒗彝族自治县",
			"zipcode": "674300"
		}]
	}, {
		"id": 308,
		"name": "普洱市",
		"child": [{
			"id": 2870,
			"name": "思茅区",
			"zipcode": "665000"
		}, {
			"id": 2871,
			"name": "宁洱哈尼族彝族自治县",
			"zipcode": "665100"
		}, {
			"id": 2872,
			"name": "墨江哈尼族自治县",
			"zipcode": "654800"
		}, {
			"id": 2873,
			"name": "景东彝族自治县",
			"zipcode": "676200"
		}, {
			"id": 2874,
			"name": "景谷傣族彝族自治县",
			"zipcode": "666400"
		}, {
			"id": 2875,
			"name": "镇沅彝族哈尼族拉祜族自治县",
			"zipcode": "666500"
		}, {
			"id": 2876,
			"name": "江城哈尼族彝族自治县",
			"zipcode": "665900"
		}, {
			"id": 2877,
			"name": "孟连傣族拉祜族佤族自治县",
			"zipcode": "665800"
		}, {
			"id": 2878,
			"name": "澜沧拉祜族自治县",
			"zipcode": "665600"
		}, {
			"id": 2879,
			"name": "西盟佤族自治县",
			"zipcode": "665700"
		}]
	}, {
		"id": 309,
		"name": "临沧市",
		"child": [{
			"id": 2880,
			"name": "临翔区",
			"zipcode": "677000"
		}, {
			"id": 2881,
			"name": "凤庆县",
			"zipcode": "675900"
		}, {
			"id": 2882,
			"name": "云县",
			"zipcode": "675800"
		}, {
			"id": 2883,
			"name": "永德县",
			"zipcode": "677600"
		}, {
			"id": 2884,
			"name": "镇康县",
			"zipcode": "677704"
		}, {
			"id": 2885,
			"name": "双江拉祜族佤族布朗族傣族自治县",
			"zipcode": "677300"
		}, {
			"id": 2886,
			"name": "耿马傣族佤族自治县",
			"zipcode": "677500"
		}, {
			"id": 2887,
			"name": "沧源佤族自治县",
			"zipcode": "677400"
		}]
	}, {
		"id": 310,
		"name": "楚雄彝族自治州",
		"child": [{
			"id": 2888,
			"name": "楚雄市",
			"zipcode": "675000"
		}, {
			"id": 2889,
			"name": "双柏县",
			"zipcode": "675100"
		}, {
			"id": 2890,
			"name": "牟定县",
			"zipcode": "675500"
		}, {
			"id": 2891,
			"name": "南华县",
			"zipcode": "675200"
		}, {
			"id": 2892,
			"name": "姚安县",
			"zipcode": "675300"
		}, {
			"id": 2893,
			"name": "大姚县",
			"zipcode": "675400"
		}, {
			"id": 2894,
			"name": "永仁县",
			"zipcode": "651400"
		}, {
			"id": 2895,
			"name": "元谋县",
			"zipcode": "651300"
		}, {
			"id": 2896,
			"name": "武定县",
			"zipcode": "651600"
		}, {
			"id": 2897,
			"name": "禄丰县",
			"zipcode": "651200"
		}]
	}, {
		"id": 311,
		"name": "红河哈尼族彝族自治州",
		"child": [{
			"id": 2898,
			"name": "个旧市",
			"zipcode": "661000"
		}, {
			"id": 2899,
			"name": "开远市",
			"zipcode": "661600"
		}, {
			"id": 2900,
			"name": "蒙自县",
			"zipcode": "661100"
		}, {
			"id": 2901,
			"name": "屏边苗族自治县",
			"zipcode": "661200"
		}, {
			"id": 2902,
			"name": "建水县",
			"zipcode": "654300"
		}, {
			"id": 2903,
			"name": "石屏县",
			"zipcode": "662200"
		}, {
			"id": 2904,
			"name": "弥勒县",
			"zipcode": "652300"
		}, {
			"id": 2905,
			"name": "泸西县",
			"zipcode": "652400"
		}, {
			"id": 2906,
			"name": "元阳县",
			"zipcode": "662400"
		}, {
			"id": 2907,
			"name": "红河县",
			"zipcode": "654400"
		}, {
			"id": 2908,
			"name": "金平苗族瑶族傣族自治县",
			"zipcode": "661500"
		}, {
			"id": 2909,
			"name": "绿春县",
			"zipcode": "662500"
		}, {
			"id": 2910,
			"name": "河口瑶族自治县",
			"zipcode": "661300"
		}]
	}, {
		"id": 312,
		"name": "文山壮族苗族自治州",
		"child": [{
			"id": 2911,
			"name": "文山县",
			"zipcode": "663000"
		}, {
			"id": 2912,
			"name": "砚山县",
			"zipcode": "663100"
		}, {
			"id": 2913,
			"name": "西畴县",
			"zipcode": "663500"
		}, {
			"id": 2914,
			"name": "麻栗坡县",
			"zipcode": "663600"
		}, {
			"id": 2915,
			"name": "马关县",
			"zipcode": "663700"
		}, {
			"id": 2916,
			"name": "丘北县",
			"zipcode": "663200"
		}, {
			"id": 2917,
			"name": "广南县",
			"zipcode": "663300"
		}, {
			"id": 2918,
			"name": "富宁县",
			"zipcode": "663400"
		}]
	}, {
		"id": 313,
		"name": "西双版纳傣族自治州",
		"child": [{
			"id": 2919,
			"name": "景洪市",
			"zipcode": "666100"
		}, {
			"id": 2920,
			"name": "勐海县",
			"zipcode": "666200"
		}, {
			"id": 2921,
			"name": "勐腊县",
			"zipcode": "666300"
		}]
	}, {
		"id": 314,
		"name": "大理白族自治州",
		"child": [{
			"id": 2922,
			"name": "大理市",
			"zipcode": "671000"
		}, {
			"id": 2923,
			"name": "漾濞彝族自治县",
			"zipcode": "672500"
		}, {
			"id": 2924,
			"name": "祥云县",
			"zipcode": "672100"
		}, {
			"id": 2925,
			"name": "宾川县",
			"zipcode": "671600"
		}, {
			"id": 2926,
			"name": "弥渡县",
			"zipcode": "675600"
		}, {
			"id": 2927,
			"name": "南涧彝族自治县",
			"zipcode": "675700"
		}, {
			"id": 2928,
			"name": "巍山彝族回族自治县",
			"zipcode": "672400"
		}, {
			"id": 2929,
			"name": "永平县",
			"zipcode": "672600"
		}, {
			"id": 2930,
			"name": "云龙县",
			"zipcode": "672700"
		}, {
			"id": 2931,
			"name": "洱源县",
			"zipcode": "671200"
		}, {
			"id": 2932,
			"name": "剑川县",
			"zipcode": "671300"
		}, {
			"id": 2933,
			"name": "鹤庆县",
			"zipcode": "671500"
		}]
	}, {
		"id": 315,
		"name": "德宏傣族景颇族自治州",
		"child": [{
			"id": 2934,
			"name": "瑞丽市",
			"zipcode": "678600"
		}, {
			"id": 2935,
			"name": "潞西市",
			"zipcode": "678400"
		}, {
			"id": 2936,
			"name": "梁河县",
			"zipcode": "679200"
		}, {
			"id": 2937,
			"name": "盈江县",
			"zipcode": "679300"
		}, {
			"id": 2938,
			"name": "陇川县",
			"zipcode": "678700"
		}]
	}, {
		"id": 316,
		"name": "怒江傈僳族自治州",
		"child": [{
			"id": 2939,
			"name": "泸水县",
			"zipcode": "673100"
		}, {
			"id": 2940,
			"name": "福贡县",
			"zipcode": "673400"
		}, {
			"id": 2941,
			"name": "贡山独龙族怒族自治县",
			"zipcode": "673500"
		}, {
			"id": 2942,
			"name": "兰坪白族普米族自治县",
			"zipcode": "671400"
		}]
	}, {
		"id": 317,
		"name": "迪庆藏族自治州",
		"child": [{
			"id": 2943,
			"name": "香格里拉县",
			"zipcode": "674400"
		}, {
			"id": 2944,
			"name": "德钦县",
			"zipcode": "674500"
		}, {
			"id": 2945,
			"name": "维西傈僳族自治县",
			"zipcode": "674600"
		}]
	}]
}, {
	"id": 27,
	"name": "西藏",
	"child": [{
		"id": 318,
		"name": "拉萨市",
		"child": [{
			"id": 2946,
			"name": "城关区",
			"zipcode": "850000"
		}, {
			"id": 2947,
			"name": "林周县",
			"zipcode": "852000"
		}, {
			"id": 2948,
			"name": "当雄县",
			"zipcode": "851500"
		}, {
			"id": 2949,
			"name": "尼木县",
			"zipcode": "851300"
		}, {
			"id": 2950,
			"name": "曲水县",
			"zipcode": "850600"
		}, {
			"id": 2951,
			"name": "堆龙德庆县",
			"zipcode": "851400"
		}, {
			"id": 2952,
			"name": "达孜县",
			"zipcode": "850100"
		}, {
			"id": 2953,
			"name": "墨竹工卡县",
			"zipcode": "850200"
		}]
	}, {
		"id": 319,
		"name": "昌都地区",
		"child": [{
			"id": 2954,
			"name": "昌都县",
			"zipcode": "854000"
		}, {
			"id": 2955,
			"name": "江达县",
			"zipcode": "854100"
		}, {
			"id": 2956,
			"name": "贡觉县",
			"zipcode": "854200"
		}, {
			"id": 2957,
			"name": "类乌齐县",
			"zipcode": "855600"
		}, {
			"id": 2958,
			"name": "丁青县",
			"zipcode": "855700"
		}, {
			"id": 2959,
			"name": "察雅县",
			"zipcode": "854300"
		}, {
			"id": 2960,
			"name": "八宿县",
			"zipcode": "854600"
		}, {
			"id": 2961,
			"name": "左贡县",
			"zipcode": "854400"
		}, {
			"id": 2962,
			"name": "芒康县",
			"zipcode": "854500"
		}, {
			"id": 2963,
			"name": "洛隆县",
			"zipcode": "855400"
		}, {
			"id": 2964,
			"name": "边坝县",
			"zipcode": "855500"
		}]
	}, {
		"id": 320,
		"name": "山南地区",
		"child": [{
			"id": 2965,
			"name": "乃东县",
			"zipcode": "856100"
		}, {
			"id": 2966,
			"name": "扎囊县",
			"zipcode": "850800"
		}, {
			"id": 2967,
			"name": "贡嘎县",
			"zipcode": "850700"
		}, {
			"id": 2968,
			"name": "桑日县",
			"zipcode": "856200"
		}, {
			"id": 2969,
			"name": "琼结县",
			"zipcode": "856800"
		}, {
			"id": 2970,
			"name": "曲松县",
			"zipcode": "856300"
		}, {
			"id": 2971,
			"name": "措美县",
			"zipcode": "856900"
		}, {
			"id": 2972,
			"name": "洛扎县",
			"zipcode": "851200"
		}, {
			"id": 2973,
			"name": "加查县",
			"zipcode": "856400"
		}, {
			"id": 2974,
			"name": "隆子县",
			"zipcode": "856600"
		}, {
			"id": 2975,
			"name": "错那县",
			"zipcode": "856700"
		}, {
			"id": 2976,
			"name": "浪卡子县",
			"zipcode": "851000"
		}]
	}, {
		"id": 321,
		"name": "日喀则地区",
		"child": [{
			"id": 2977,
			"name": "日喀则市",
			"zipcode": "857000"
		}, {
			"id": 2978,
			"name": "南木林县",
			"zipcode": "857100"
		}, {
			"id": 2979,
			"name": "江孜县",
			"zipcode": "857400"
		}, {
			"id": 2980,
			"name": "定日县",
			"zipcode": "858200"
		}, {
			"id": 2981,
			"name": "萨迦县",
			"zipcode": "857800"
		}, {
			"id": 2982,
			"name": "拉孜县",
			"zipcode": "858100"
		}, {
			"id": 2983,
			"name": "昂仁县",
			"zipcode": "858500"
		}, {
			"id": 2984,
			"name": "谢通门县",
			"zipcode": "858900"
		}, {
			"id": 2985,
			"name": "白朗县",
			"zipcode": "857300"
		}, {
			"id": 2986,
			"name": "仁布县",
			"zipcode": "857200"
		}, {
			"id": 2987,
			"name": "康马县",
			"zipcode": "857500"
		}, {
			"id": 2988,
			"name": "定结县",
			"zipcode": "857900"
		}, {
			"id": 2989,
			"name": "仲巴县",
			"zipcode": "858800"
		}, {
			"id": 2990,
			"name": "亚东县",
			"zipcode": "857600"
		}, {
			"id": 2991,
			"name": "吉隆县",
			"zipcode": "858700"
		}, {
			"id": 2992,
			"name": "聂拉木县",
			"zipcode": "858300"
		}, {
			"id": 2993,
			"name": "萨嘎县",
			"zipcode": "857800"
		}, {
			"id": 2994,
			"name": "岗巴县",
			"zipcode": "857700"
		}]
	}, {
		"id": 322,
		"name": "那曲地区",
		"child": [{
			"id": 2995,
			"name": "那曲县",
			"zipcode": "852000"
		}, {
			"id": 2996,
			"name": "嘉黎县",
			"zipcode": "852400"
		}, {
			"id": 2997,
			"name": "比如县",
			"zipcode": "852300"
		}, {
			"id": 2998,
			"name": "聂荣县",
			"zipcode": "853500"
		}, {
			"id": 2999,
			"name": "安多县",
			"zipcode": "852600"
		}, {
			"id": 3000,
			"name": "申扎县",
			"zipcode": "853100"
		}, {
			"id": 3001,
			"name": "索县",
			"zipcode": "852200"
		}, {
			"id": 3002,
			"name": "班戈县",
			"zipcode": "852500"
		}, {
			"id": 3003,
			"name": "巴青县",
			"zipcode": "852100"
		}, {
			"id": 3004,
			"name": "尼玛县",
			"zipcode": "853200"
		}]
	}, {
		"id": 323,
		"name": "阿里地区",
		"child": [{
			"id": 3005,
			"name": "普兰县",
			"zipcode": "859500"
		}, {
			"id": 3006,
			"name": "札达县",
			"zipcode": "859600"
		}, {
			"id": 3007,
			"name": "噶尔县",
			"zipcode": "859400"
		}, {
			"id": 3008,
			"name": "日土县",
			"zipcode": "859700"
		}, {
			"id": 3009,
			"name": "革吉县",
			"zipcode": "859100"
		}, {
			"id": 3010,
			"name": "改则县",
			"zipcode": "859200"
		}, {
			"id": 3011,
			"name": "措勤县",
			"zipcode": "859300"
		}]
	}, {
		"id": 324,
		"name": "林芝地区",
		"child": [{
			"id": 3012,
			"name": "林芝县",
			"zipcode": "850400"
		}, {
			"id": 3013,
			"name": "工布江达县",
			"zipcode": "850300"
		}, {
			"id": 3014,
			"name": "米林县",
			"zipcode": "860500"
		}, {
			"id": 3015,
			"name": "墨脱县",
			"zipcode": "855300"
		}, {
			"id": 3016,
			"name": "波密县",
			"zipcode": "855200"
		}, {
			"id": 3017,
			"name": "察隅县",
			"zipcode": "855100"
		}, {
			"id": 3018,
			"name": "朗县",
			"zipcode": "856500"
		}]
	}]
}, {
	"id": 28,
	"name": "陕西",
	"child": [{
		"id": 325,
		"name": "西安市",
		"child": [{
			"id": 3019,
			"name": "新城区",
			"zipcode": "710004"
		}, {
			"id": 3020,
			"name": "碑林区",
			"zipcode": "710001"
		}, {
			"id": 3021,
			"name": "莲湖区",
			"zipcode": "710003"
		}, {
			"id": 3022,
			"name": "灞桥区",
			"zipcode": "710038"
		}, {
			"id": 3023,
			"name": "未央区",
			"zipcode": "710014"
		}, {
			"id": 3024,
			"name": "雁塔区",
			"zipcode": "710061"
		}, {
			"id": 3025,
			"name": "阎良区",
			"zipcode": "710087"
		}, {
			"id": 3026,
			"name": "临潼区",
			"zipcode": "710600"
		}, {
			"id": 3027,
			"name": "长安区",
			"zipcode": "710100"
		}, {
			"id": 3028,
			"name": "蓝田县",
			"zipcode": "710500"
		}, {
			"id": 3029,
			"name": "周至县",
			"zipcode": "710400"
		}, {
			"id": 3030,
			"name": "户县",
			"zipcode": "710300"
		}, {
			"id": 3031,
			"name": "高陵县",
			"zipcode": "710200"
		}, {
			"id": 3032,
			"name": "高新区",
			"zipcode": "710075"
		}]
	}, {
		"id": 326,
		"name": "铜川市",
		"child": [{
			"id": 3033,
			"name": "王益区",
			"zipcode": "727000"
		}, {
			"id": 3034,
			"name": "印台区",
			"zipcode": "727007"
		}, {
			"id": 3035,
			"name": "耀州区",
			"zipcode": "727100"
		}, {
			"id": 3036,
			"name": "宜君县",
			"zipcode": "727200"
		}, {
			"id": 3037,
			"name": "新区",
			"zipcode": "727100"
		}]
	}, {
		"id": 327,
		"name": "宝鸡市",
		"child": [{
			"id": 3038,
			"name": "渭滨区",
			"zipcode": "721000"
		}, {
			"id": 3039,
			"name": "金台区",
			"zipcode": "721000"
		}, {
			"id": 3040,
			"name": "陈仓区",
			"zipcode": "721300"
		}, {
			"id": 3041,
			"name": "凤翔县",
			"zipcode": "721400"
		}, {
			"id": 3042,
			"name": "岐山县",
			"zipcode": "722400"
		}, {
			"id": 3043,
			"name": "扶风县",
			"zipcode": "722200"
		}, {
			"id": 3044,
			"name": "眉县",
			"zipcode": "722300"
		}, {
			"id": 3045,
			"name": "陇县",
			"zipcode": "721200"
		}, {
			"id": 3046,
			"name": "千阳县",
			"zipcode": "721100"
		}, {
			"id": 3047,
			"name": "麟游县",
			"zipcode": "721500"
		}, {
			"id": 3048,
			"name": "凤县",
			"zipcode": "721700"
		}, {
			"id": 3049,
			"name": "太白县",
			"zipcode": "721600"
		}]
	}, {
		"id": 328,
		"name": "咸阳市",
		"child": [{
			"id": 3050,
			"name": "秦都区",
			"zipcode": "712000"
		}, {
			"id": 3051,
			"name": "渭城区",
			"zipcode": "712000"
		}, {
			"id": 3052,
			"name": "杨陵区",
			"zipcode": "712100"
		}, {
			"id": 3053,
			"name": "三原县",
			"zipcode": "713800"
		}, {
			"id": 3054,
			"name": "泾阳县",
			"zipcode": "713700"
		}, {
			"id": 3055,
			"name": "兴平市",
			"zipcode": "713100"
		}, {
			"id": 3056,
			"name": "乾县",
			"zipcode": "713300"
		}, {
			"id": 3057,
			"name": "礼泉县",
			"zipcode": "713200"
		}, {
			"id": 3058,
			"name": "永寿县",
			"zipcode": "713400"
		}, {
			"id": 3059,
			"name": "彬县",
			"zipcode": "713500"
		}, {
			"id": 3060,
			"name": "长武县",
			"zipcode": "713600"
		}, {
			"id": 3061,
			"name": "旬邑县",
			"zipcode": "711300"
		}, {
			"id": 3062,
			"name": "淳化县",
			"zipcode": "711200"
		}, {
			"id": 3063,
			"name": "武功县",
			"zipcode": "712200"
		}]
	}, {
		"id": 329,
		"name": "渭南市",
		"child": [{
			"id": 3064,
			"name": "临渭区",
			"zipcode": "714000"
		}, {
			"id": 3065,
			"name": "华县",
			"zipcode": "714100"
		}, {
			"id": 3066,
			"name": "潼关县",
			"zipcode": "714300"
		}, {
			"id": 3067,
			"name": "大荔县",
			"zipcode": "715100"
		}, {
			"id": 3068,
			"name": "合阳县",
			"zipcode": "715300"
		}, {
			"id": 3069,
			"name": "澄城县",
			"zipcode": "715200"
		}, {
			"id": 3070,
			"name": "蒲城县",
			"zipcode": "715500"
		}, {
			"id": 3071,
			"name": "白水县",
			"zipcode": "715600"
		}, {
			"id": 3072,
			"name": "富平县",
			"zipcode": "711700"
		}, {
			"id": 3073,
			"name": "韩城市",
			"zipcode": "715400"
		}, {
			"id": 3074,
			"name": "华阴市",
			"zipcode": "714200"
		}]
	}, {
		"id": 330,
		"name": "延安市",
		"child": [{
			"id": 3075,
			"name": "宝塔区",
			"zipcode": "716000"
		}, {
			"id": 3076,
			"name": "延长县",
			"zipcode": "717100"
		}, {
			"id": 3077,
			"name": "延川县",
			"zipcode": "717200"
		}, {
			"id": 3078,
			"name": "子长县",
			"zipcode": "717300"
		}, {
			"id": 3079,
			"name": "安塞县",
			"zipcode": "717400"
		}, {
			"id": 3080,
			"name": "志丹县",
			"zipcode": "717500"
		}, {
			"id": 3081,
			"name": "吴旗县",
			"zipcode": "717600"
		}, {
			"id": 3082,
			"name": "甘泉县",
			"zipcode": "716100"
		}, {
			"id": 3083,
			"name": "富县",
			"zipcode": "727500"
		}, {
			"id": 3084,
			"name": "洛川县",
			"zipcode": "727400"
		}, {
			"id": 3085,
			"name": "宜川县",
			"zipcode": "716200"
		}, {
			"id": 3086,
			"name": "黄龙县",
			"zipcode": "715700"
		}, {
			"id": 3087,
			"name": "黄陵县",
			"zipcode": "727300"
		}]
	}, {
		"id": 331,
		"name": "汉中市",
		"child": [{
			"id": 3088,
			"name": "汉台区",
			"zipcode": "723000"
		}, {
			"id": 3089,
			"name": "南郑县",
			"zipcode": "723100"
		}, {
			"id": 3090,
			"name": "城固县",
			"zipcode": "723200"
		}, {
			"id": 3091,
			"name": "洋县",
			"zipcode": "723300"
		}, {
			"id": 3092,
			"name": "西乡县",
			"zipcode": "723500"
		}, {
			"id": 3093,
			"name": "勉县",
			"zipcode": "724200"
		}, {
			"id": 3094,
			"name": "宁强县",
			"zipcode": "724400"
		}, {
			"id": 3095,
			"name": "略阳县",
			"zipcode": "724300"
		}, {
			"id": 3096,
			"name": "镇巴县",
			"zipcode": "723600"
		}, {
			"id": 3097,
			"name": "留坝县",
			"zipcode": "724100"
		}, {
			"id": 3098,
			"name": "佛坪县",
			"zipcode": "723400"
		}, {
			"id": 3099,
			"name": "经济开发区",
			"zipcode": "723000"
		}]
	}, {
		"id": 332,
		"name": "榆林市",
		"child": [{
			"id": 3100,
			"name": "榆阳区",
			"zipcode": "719000"
		}, {
			"id": 3101,
			"name": "神木县",
			"zipcode": "719300"
		}, {
			"id": 3102,
			"name": "府谷县",
			"zipcode": "719400"
		}, {
			"id": 3103,
			"name": "横山县",
			"zipcode": "719100"
		}, {
			"id": 3104,
			"name": "靖边县",
			"zipcode": "718500"
		}, {
			"id": 3105,
			"name": "定边县",
			"zipcode": "718600"
		}, {
			"id": 3106,
			"name": "绥德县",
			"zipcode": "718000"
		}, {
			"id": 3107,
			"name": "米脂县",
			"zipcode": "718100"
		}, {
			"id": 3108,
			"name": "佳县",
			"zipcode": "719200"
		}, {
			"id": 3109,
			"name": "吴堡县",
			"zipcode": "718200"
		}, {
			"id": 3110,
			"name": "清涧县",
			"zipcode": "718300"
		}, {
			"id": 3111,
			"name": "子洲县",
			"zipcode": "718400"
		}]
	}, {
		"id": 333,
		"name": "安康市",
		"child": [{
			"id": 3112,
			"name": "汉滨区",
			"zipcode": "725000"
		}, {
			"id": 3113,
			"name": "汉阴县",
			"zipcode": "725100"
		}, {
			"id": 3114,
			"name": "石泉县",
			"zipcode": "725200"
		}, {
			"id": 3115,
			"name": "宁陕县",
			"zipcode": "711600"
		}, {
			"id": 3116,
			"name": "紫阳县",
			"zipcode": "725300"
		}, {
			"id": 3117,
			"name": "岚皋县",
			"zipcode": "725400"
		}, {
			"id": 3118,
			"name": "平利县",
			"zipcode": "725500"
		}, {
			"id": 3119,
			"name": "镇坪县",
			"zipcode": "725600"
		}, {
			"id": 3120,
			"name": "旬阳县",
			"zipcode": "725700"
		}, {
			"id": 3121,
			"name": "白河县",
			"zipcode": "725800"
		}]
	}, {
		"id": 334,
		"name": "商洛市",
		"child": [{
			"id": 3122,
			"name": "商州区",
			"zipcode": "726000"
		}, {
			"id": 3123,
			"name": "洛南县",
			"zipcode": "726100"
		}, {
			"id": 3124,
			"name": "丹凤县",
			"zipcode": "726200"
		}, {
			"id": 3125,
			"name": "商南县",
			"zipcode": "726300"
		}, {
			"id": 3126,
			"name": "山阳县",
			"zipcode": "726400"
		}, {
			"id": 3127,
			"name": "镇安县",
			"zipcode": "711500"
		}, {
			"id": 3128,
			"name": "柞水县",
			"zipcode": "674100"
		}]
	}]
}, {
	"id": 29,
	"name": "甘肃",
	"child": [{
		"id": 335,
		"name": "兰州市",
		"child": [{
			"id": 3129,
			"name": "城关区",
			"zipcode": "674100"
		}, {
			"id": 3130,
			"name": "七里河区",
			"zipcode": "674100"
		}, {
			"id": 3131,
			"name": "西固区",
			"zipcode": "674100"
		}, {
			"id": 3132,
			"name": "安宁区",
			"zipcode": "674100"
		}, {
			"id": 3133,
			"name": "红古区",
			"zipcode": "678000"
		}, {
			"id": 3134,
			"name": "永登县",
			"zipcode": "678000"
		}, {
			"id": 3135,
			"name": "皋兰县",
			"zipcode": "678000"
		}, {
			"id": 3136,
			"name": "榆中县",
			"zipcode": "678000"
		}]
	}, {
		"id": 336,
		"name": "嘉峪关市",
		"child": [{
			"id": 3137,
			"name": "嘉峪关市",
			"zipcode": "678000"
		}]
	}, {
		"id": 337,
		"name": "金昌市",
		"child": [{
			"id": 3138,
			"name": "金川区",
			"zipcode": "737103"
		}, {
			"id": 3139,
			"name": "永昌县",
			"zipcode": "737200"
		}]
	}, {
		"id": 338,
		"name": "白银市",
		"child": [{
			"id": 3140,
			"name": "白银区",
			"zipcode": "730900"
		}, {
			"id": 3141,
			"name": "平川区",
			"zipcode": "730913"
		}, {
			"id": 3142,
			"name": "靖远县",
			"zipcode": "730600"
		}, {
			"id": 3143,
			"name": "会宁县",
			"zipcode": "730700"
		}, {
			"id": 3144,
			"name": "景泰县",
			"zipcode": "730400"
		}]
	}, {
		"id": 339,
		"name": "天水市",
		"child": [{
			"id": 3145,
			"name": "秦州区",
			"zipcode": "741000"
		}, {
			"id": 3146,
			"name": "麦积区",
			"zipcode": "741020"
		}, {
			"id": 3147,
			"name": "清水县",
			"zipcode": "741400"
		}, {
			"id": 3148,
			"name": "秦安县",
			"zipcode": "671000"
		}, {
			"id": 3149,
			"name": "甘谷县",
			"zipcode": "671000"
		}, {
			"id": 3150,
			"name": "武山县",
			"zipcode": "671000"
		}, {
			"id": 3151,
			"name": "张家川回族自治县",
			"zipcode": "671000"
		}]
	}, {
		"id": 340,
		"name": "武威市",
		"child": [{
			"id": 3152,
			"name": "凉州区",
			"zipcode": "671000"
		}, {
			"id": 3153,
			"name": "民勤县",
			"zipcode": "671000"
		}, {
			"id": 3154,
			"name": "古浪县",
			"zipcode": "671000"
		}, {
			"id": 3155,
			"name": "天祝藏族自治县",
			"zipcode": "671000"
		}]
	}, {
		"id": 341,
		"name": "张掖市",
		"child": [{
			"id": 3156,
			"name": "甘州区",
			"zipcode": "671000"
		}, {
			"id": 3157,
			"name": "肃南裕固族自治县",
			"zipcode": "671000"
		}, {
			"id": 3158,
			"name": "民乐县",
			"zipcode": "671000"
		}, {
			"id": 3159,
			"name": "临泽县",
			"zipcode": "671000"
		}, {
			"id": 3160,
			"name": "高台县",
			"zipcode": "734300"
		}, {
			"id": 3161,
			"name": "山丹县",
			"zipcode": "734100"
		}]
	}, {
		"id": 342,
		"name": "平凉市",
		"child": [{
			"id": 3162,
			"name": "崆峒区",
			"zipcode": "678400"
		}, {
			"id": 3163,
			"name": "泾川县",
			"zipcode": "744300"
		}, {
			"id": 3164,
			"name": "灵台县",
			"zipcode": "744400"
		}, {
			"id": 3165,
			"name": "崇信县",
			"zipcode": "744200"
		}, {
			"id": 3166,
			"name": "华亭县",
			"zipcode": "744100"
		}, {
			"id": 3167,
			"name": "庄浪县",
			"zipcode": "744600"
		}, {
			"id": 3168,
			"name": "静宁县",
			"zipcode": "743400"
		}]
	}, {
		"id": 343,
		"name": "酒泉市",
		"child": [{
			"id": 3169,
			"name": "肃州区",
			"zipcode": "735000"
		}, {
			"id": 3170,
			"name": "金塔县",
			"zipcode": "735300"
		}, {
			"id": 3171,
			"name": "安西县",
			"zipcode": "736100"
		}, {
			"id": 3172,
			"name": "肃北蒙古族自治县",
			"zipcode": "736300"
		}, {
			"id": 3173,
			"name": "阿克塞哈萨克族自治县",
			"zipcode": "736400"
		}, {
			"id": 3174,
			"name": "玉门市",
			"zipcode": "735200"
		}, {
			"id": 3175,
			"name": "敦煌市",
			"zipcode": "736200"
		}]
	}, {
		"id": 344,
		"name": "庆阳市",
		"child": [{
			"id": 3176,
			"name": "西峰区",
			"zipcode": "745000"
		}, {
			"id": 3177,
			"name": "庆城县",
			"zipcode": "745100"
		}, {
			"id": 3178,
			"name": "环县",
			"zipcode": "745700"
		}, {
			"id": 3179,
			"name": "华池县",
			"zipcode": "745600"
		}, {
			"id": 3180,
			"name": "合水县",
			"zipcode": "745400"
		}, {
			"id": 3181,
			"name": "正宁县",
			"zipcode": "677000"
		}, {
			"id": 3182,
			"name": "宁县",
			"zipcode": "677000"
		}, {
			"id": 3183,
			"name": "镇原县",
			"zipcode": "677000"
		}]
	}, {
		"id": 345,
		"name": "定西市",
		"child": [{
			"id": 3184,
			"name": "安定区",
			"zipcode": "677000"
		}, {
			"id": 3185,
			"name": "通渭县",
			"zipcode": "677000"
		}, {
			"id": 3186,
			"name": "陇西县",
			"zipcode": "677000"
		}, {
			"id": 3187,
			"name": "渭源县",
			"zipcode": "677000"
		}, {
			"id": 3188,
			"name": "临洮县",
			"zipcode": "677000"
		}, {
			"id": 3189,
			"name": "漳县",
			"zipcode": "748300"
		}, {
			"id": 3190,
			"name": "岷县",
			"zipcode": "748400"
		}]
	}, {
		"id": 346,
		"name": "陇南市",
		"child": [{
			"id": 3191,
			"name": "武都区",
			"zipcode": "746000"
		}, {
			"id": 3192,
			"name": "成县",
			"zipcode": "742500"
		}, {
			"id": 3193,
			"name": "文县",
			"zipcode": "746400"
		}, {
			"id": 3194,
			"name": "宕昌县",
			"zipcode": "748500"
		}, {
			"id": 3195,
			"name": "康县",
			"zipcode": "746500"
		}, {
			"id": 3196,
			"name": "西和县",
			"zipcode": "742100"
		}, {
			"id": 3197,
			"name": "礼县",
			"zipcode": "742200"
		}, {
			"id": 3198,
			"name": "徽县",
			"zipcode": "742300"
		}, {
			"id": 3199,
			"name": "两当县",
			"zipcode": "742400"
		}]
	}, {
		"id": 347,
		"name": "临夏回族自治州",
		"child": [{
			"id": 3200,
			"name": "临夏市",
			"zipcode": "731100"
		}, {
			"id": 3201,
			"name": "临夏县",
			"zipcode": "731800"
		}, {
			"id": 3202,
			"name": "康乐县",
			"zipcode": "731500"
		}, {
			"id": 3203,
			"name": "永靖县",
			"zipcode": "731600"
		}, {
			"id": 3204,
			"name": "广河县",
			"zipcode": "731300"
		}, {
			"id": 3205,
			"name": "和政县",
			"zipcode": "731200"
		}, {
			"id": 3206,
			"name": "东乡族自治县",
			"zipcode": "731400"
		}, {
			"id": 3207,
			"name": "积石山保安族东乡族撒拉族自治县",
			"zipcode": "731700"
		}]
	}, {
		"id": 348,
		"name": "甘南藏族自治州",
		"child": [{
			"id": 3208,
			"name": "合作市",
			"zipcode": "747000"
		}, {
			"id": 3209,
			"name": "临潭县",
			"zipcode": "747500"
		}, {
			"id": 3210,
			"name": "卓尼县",
			"zipcode": "747600"
		}, {
			"id": 3211,
			"name": "舟曲县",
			"zipcode": "746300"
		}, {
			"id": 3212,
			"name": "迭部县",
			"zipcode": "747400"
		}, {
			"id": 3213,
			"name": "玛曲县",
			"zipcode": "747300"
		}, {
			"id": 3214,
			"name": "碌曲县",
			"zipcode": "747200"
		}, {
			"id": 3215,
			"name": "夏河县",
			"zipcode": "747100"
		}]
	}]
}, {
	"id": 30,
	"name": "青海",
	"child": [{
		"id": 349,
		"name": "西宁市",
		"child": [{
			"id": 3216,
			"name": "城东区",
			"zipcode": "810000"
		}, {
			"id": 3217,
			"name": "城中区",
			"zipcode": "810000"
		}, {
			"id": 3218,
			"name": "城西区",
			"zipcode": "810000"
		}, {
			"id": 3219,
			"name": "城北区",
			"zipcode": "810000"
		}, {
			"id": 3220,
			"name": "大通回族土族自治县",
			"zipcode": "810100"
		}, {
			"id": 3221,
			"name": "湟中县",
			"zipcode": "811600"
		}, {
			"id": 3222,
			"name": "湟源县",
			"zipcode": "812100"
		}]
	}, {
		"id": 350,
		"name": "海东地区",
		"child": [{
			"id": 3223,
			"name": "平安县",
			"zipcode": "810600"
		}, {
			"id": 3224,
			"name": "民和回族土族自治县",
			"zipcode": "810800"
		}, {
			"id": 3225,
			"name": "乐都县",
			"zipcode": "810700"
		}, {
			"id": 3226,
			"name": "互助土族自治县",
			"zipcode": "810500"
		}, {
			"id": 3227,
			"name": "化隆回族自治县",
			"zipcode": "810900"
		}, {
			"id": 3228,
			"name": "循化撒拉族自治县",
			"zipcode": "811100"
		}]
	}, {
		"id": 351,
		"name": "海北藏族自治州",
		"child": [{
			"id": 3229,
			"name": "门源回族自治县",
			"zipcode": "810300"
		}, {
			"id": 3230,
			"name": "祁连县",
			"zipcode": "810400"
		}, {
			"id": 3231,
			"name": "海晏县",
			"zipcode": "812200"
		}, {
			"id": 3232,
			"name": "刚察县",
			"zipcode": "812300"
		}]
	}, {
		"id": 352,
		"name": "黄南藏族自治州",
		"child": [{
			"id": 3233,
			"name": "同仁县",
			"zipcode": "811300"
		}, {
			"id": 3234,
			"name": "尖扎县",
			"zipcode": "811200"
		}, {
			"id": 3235,
			"name": "泽库县",
			"zipcode": "811400"
		}, {
			"id": 3236,
			"name": "河南蒙古族自治县",
			"zipcode": "811500"
		}]
	}, {
		"id": 353,
		"name": "海南藏族自治州",
		"child": [{
			"id": 3237,
			"name": "共和县",
			"zipcode": "813000"
		}, {
			"id": 3238,
			"name": "同德县",
			"zipcode": "813200"
		}, {
			"id": 3239,
			"name": "贵德县",
			"zipcode": "811700"
		}, {
			"id": 3240,
			"name": "兴海县",
			"zipcode": "813300"
		}, {
			"id": 3241,
			"name": "贵南县",
			"zipcode": "813100"
		}]
	}, {
		"id": 354,
		"name": "果洛藏族自治州",
		"child": [{
			"id": 3242,
			"name": "玛沁县",
			"zipcode": "814000"
		}, {
			"id": 3243,
			"name": "班玛县",
			"zipcode": "814300"
		}, {
			"id": 3244,
			"name": "甘德县",
			"zipcode": "814100"
		}, {
			"id": 3245,
			"name": "达日县",
			"zipcode": "814200"
		}, {
			"id": 3246,
			"name": "久治县",
			"zipcode": "624700"
		}, {
			"id": 3247,
			"name": "玛多县",
			"zipcode": "813500"
		}]
	}, {
		"id": 355,
		"name": "玉树藏族自治州",
		"child": [{
			"id": 3248,
			"name": "玉树县",
			"zipcode": "815000"
		}, {
			"id": 3249,
			"name": "杂多县",
			"zipcode": "815300"
		}, {
			"id": 3250,
			"name": "称多县",
			"zipcode": "815100"
		}, {
			"id": 3251,
			"name": "治多县",
			"zipcode": "815400"
		}, {
			"id": 3252,
			"name": "囊谦县",
			"zipcode": "815200"
		}, {
			"id": 3253,
			"name": "曲麻莱县",
			"zipcode": "815500"
		}]
	}, {
		"id": 356,
		"name": "海西蒙古族藏族自治州",
		"child": [{
			"id": 3254,
			"name": "格尔木市",
			"zipcode": "816000"
		}, {
			"id": 3255,
			"name": "德令哈市",
			"zipcode": "817000"
		}, {
			"id": 3256,
			"name": "乌兰县",
			"zipcode": "817100"
		}, {
			"id": 3257,
			"name": "都兰县",
			"zipcode": "816100"
		}, {
			"id": 3258,
			"name": "天峻县",
			"zipcode": "817200"
		}, {
			"id": 3259,
			"name": "大柴旦行委",
			"zipcode": "817300"
		}]
	}]
}, {
	"id": 31,
	"name": "宁夏",
	"child": [{
		"id": 357,
		"name": "银川市",
		"child": [{
			"id": 3260,
			"name": "兴庆区",
			"zipcode": "750001"
		}, {
			"id": 3261,
			"name": "西夏区",
			"zipcode": "750021"
		}, {
			"id": 3262,
			"name": "金凤区",
			"zipcode": "750011"
		}, {
			"id": 3263,
			"name": "永宁县",
			"zipcode": "750100"
		}, {
			"id": 3264,
			"name": "贺兰县",
			"zipcode": "750200"
		}, {
			"id": 3265,
			"name": "灵武市",
			"zipcode": "750004"
		}]
	}, {
		"id": 358,
		"name": "石嘴山市",
		"child": [{
			"id": 3266,
			"name": "大武口区",
			"zipcode": "753000"
		}, {
			"id": 3267,
			"name": "惠农区",
			"zipcode": "753600"
		}, {
			"id": 3268,
			"name": "平罗县",
			"zipcode": "753400"
		}]
	}, {
		"id": 359,
		"name": "吴忠市",
		"child": [{
			"id": 3269,
			"name": "利通区",
			"zipcode": "751100"
		}, {
			"id": 3270,
			"name": "盐池县",
			"zipcode": "751500"
		}, {
			"id": 3271,
			"name": "同心县",
			"zipcode": "751300"
		}, {
			"id": 3272,
			"name": "青铜峡市",
			"zipcode": "751600"
		}, {
			"id": 3381,
			"name": "红寺堡区",
			"zipcode": "751900"
		}]
	}, {
		"id": 360,
		"name": "固原市",
		"child": [{
			"id": 3273,
			"name": "原州区",
			"zipcode": "756000"
		}, {
			"id": 3274,
			"name": "西吉县",
			"zipcode": "756200"
		}, {
			"id": 3275,
			"name": "隆德县",
			"zipcode": "756300"
		}, {
			"id": 3276,
			"name": "泾源县",
			"zipcode": "756400"
		}, {
			"id": 3277,
			"name": "彭阳县",
			"zipcode": "756500"
		}]
	}, {
		"id": 361,
		"name": "中卫市",
		"child": [{
			"id": 3278,
			"name": "沙坡头区",
			"zipcode": "755000"
		}, {
			"id": 3279,
			"name": "中宁县",
			"zipcode": "755100"
		}, {
			"id": 3280,
			"name": "海原县",
			"zipcode": "755200"
		}]
	}]
}, {
	"id": 32,
	"name": "新疆",
	"child": [{
		"id": 362,
		"name": "乌鲁木齐市",
		"child": [{
			"id": 3281,
			"name": "天山区",
			"zipcode": "830000"
		}, {
			"id": 3282,
			"name": "沙依巴克区",
			"zipcode": "830002"
		}, {
			"id": 3283,
			"name": "新市区",
			"zipcode": "830011"
		}, {
			"id": 3284,
			"name": "水磨沟区",
			"zipcode": "830017"
		}, {
			"id": 3285,
			"name": "头屯河区",
			"zipcode": "830022"
		}, {
			"id": 3286,
			"name": "达坂城区",
			"zipcode": "830039"
		}, {
			"id": 3287,
			"name": "米东区",
			"zipcode": "830019"
		}, {
			"id": 3288,
			"name": "乌鲁木齐县",
			"zipcode": "830063"
		}]
	}, {
		"id": 363,
		"name": "克拉玛依市",
		"child": [{
			"id": 3289,
			"name": "独山子区",
			"zipcode": "834021"
		}, {
			"id": 3290,
			"name": "克拉玛依区",
			"zipcode": "834000"
		}, {
			"id": 3291,
			"name": "白碱滩区",
			"zipcode": "834008"
		}, {
			"id": 3292,
			"name": "乌尔禾区",
			"zipcode": "834012"
		}]
	}, {
		"id": 364,
		"name": "吐鲁番地区",
		"child": [{
			"id": 3293,
			"name": "吐鲁番市",
			"zipcode": "838000"
		}, {
			"id": 3294,
			"name": "鄯善县",
			"zipcode": "838200"
		}, {
			"id": 3295,
			"name": "托克逊县",
			"zipcode": "838100"
		}]
	}, {
		"id": 365,
		"name": "哈密地区",
		"child": [{
			"id": 3296,
			"name": "哈密市",
			"zipcode": "839000"
		}, {
			"id": 3297,
			"name": "巴里坤哈萨克自治县",
			"zipcode": "839200"
		}, {
			"id": 3298,
			"name": "伊吾县",
			"zipcode": "839300"
		}]
	}, {
		"id": 366,
		"name": "昌吉回族自治州",
		"child": [{
			"id": 3299,
			"name": "昌吉市",
			"zipcode": "831100"
		}, {
			"id": 3300,
			"name": "阜康市",
			"zipcode": "831500"
		}, {
			"id": 3301,
			"name": "米泉市",
			"zipcode": "831400"
		}, {
			"id": 3302,
			"name": "呼图壁县",
			"zipcode": "831200"
		}, {
			"id": 3303,
			"name": "玛纳斯县",
			"zipcode": "832200"
		}, {
			"id": 3304,
			"name": "奇台县",
			"zipcode": "831800"
		}, {
			"id": 3305,
			"name": "吉木萨尔县",
			"zipcode": "831700"
		}, {
			"id": 3306,
			"name": "木垒哈萨克自治县",
			"zipcode": "831900"
		}]
	}, {
		"id": 367,
		"name": "博尔塔拉蒙古自治州",
		"child": [{
			"id": 3307,
			"name": "博乐市",
			"zipcode": "833400"
		}, {
			"id": 3308,
			"name": "精河县",
			"zipcode": "833300"
		}, {
			"id": 3309,
			"name": "温泉县",
			"zipcode": "833500"
		}]
	}, {
		"id": 368,
		"name": "巴音郭楞蒙古自治州",
		"child": [{
			"id": 3310,
			"name": "库尔勒市",
			"zipcode": "841000"
		}, {
			"id": 3311,
			"name": "轮台县",
			"zipcode": "841600"
		}, {
			"id": 3312,
			"name": "尉犁县",
			"zipcode": "841500"
		}, {
			"id": 3313,
			"name": "若羌县",
			"zipcode": "841800"
		}, {
			"id": 3314,
			"name": "且末县",
			"zipcode": "841900"
		}, {
			"id": 3315,
			"name": "焉耆回族自治县",
			"zipcode": "841100"
		}, {
			"id": 3316,
			"name": "和静县",
			"zipcode": "841300"
		}, {
			"id": 3317,
			"name": "和硕县",
			"zipcode": "841200"
		}, {
			"id": 3318,
			"name": "博湖县",
			"zipcode": "841400"
		}]
	}, {
		"id": 369,
		"name": "阿克苏地区",
		"child": [{
			"id": 3319,
			"name": "阿克苏市",
			"zipcode": "843000"
		}, {
			"id": 3320,
			"name": "温宿县",
			"zipcode": "843100"
		}, {
			"id": 3321,
			"name": "库车县",
			"zipcode": "842000"
		}, {
			"id": 3322,
			"name": "沙雅县",
			"zipcode": "842200"
		}, {
			"id": 3323,
			"name": "新和县",
			"zipcode": "842100"
		}, {
			"id": 3324,
			"name": "拜城县",
			"zipcode": "842300"
		}, {
			"id": 3325,
			"name": "乌什县",
			"zipcode": "843400"
		}, {
			"id": 3326,
			"name": "阿瓦提县",
			"zipcode": "843200"
		}, {
			"id": 3327,
			"name": "柯坪县",
			"zipcode": "843600"
		}]
	}, {
		"id": 370,
		"name": "克孜勒苏柯尔克孜自治州",
		"child": [{
			"id": 3328,
			"name": "阿图什市",
			"zipcode": "845350"
		}, {
			"id": 3329,
			"name": "阿克陶县",
			"zipcode": "845550"
		}, {
			"id": 3330,
			"name": "阿合奇县",
			"zipcode": "843500"
		}, {
			"id": 3331,
			"name": "乌恰县",
			"zipcode": "845450"
		}]
	}, {
		"id": 371,
		"name": "喀什地区",
		"child": [{
			"id": 3332,
			"name": "喀什市",
			"zipcode": "844000"
		}, {
			"id": 3333,
			"name": "疏附县",
			"zipcode": "844100"
		}, {
			"id": 3334,
			"name": "疏勒县",
			"zipcode": "844200"
		}, {
			"id": 3335,
			"name": "英吉沙县",
			"zipcode": "844500"
		}, {
			"id": 3336,
			"name": "泽普县",
			"zipcode": "844800"
		}, {
			"id": 3337,
			"name": "莎车县",
			"zipcode": "844700"
		}, {
			"id": 3338,
			"name": "叶城县",
			"zipcode": "844900"
		}, {
			"id": 3339,
			"name": "麦盖提县",
			"zipcode": "844600"
		}, {
			"id": 3340,
			"name": "岳普湖县",
			"zipcode": "844400"
		}, {
			"id": 3341,
			"name": "伽师县",
			"zipcode": "844300"
		}, {
			"id": 3342,
			"name": "巴楚县",
			"zipcode": "843800"
		}, {
			"id": 3343,
			"name": "塔什库尔干塔吉克自治县",
			"zipcode": "845250"
		}]
	}, {
		"id": 372,
		"name": "和田地区",
		"child": [{
			"id": 3344,
			"name": "和田市",
			"zipcode": "848000"
		}, {
			"id": 3345,
			"name": "和田县",
			"zipcode": "848000"
		}, {
			"id": 3346,
			"name": "墨玉县",
			"zipcode": "848100"
		}, {
			"id": 3347,
			"name": "皮山县",
			"zipcode": "845150"
		}, {
			"id": 3348,
			"name": "洛浦县",
			"zipcode": "848200"
		}, {
			"id": 3349,
			"name": "策勒县",
			"zipcode": "848300"
		}, {
			"id": 3350,
			"name": "于田县",
			"zipcode": "848400"
		}, {
			"id": 3351,
			"name": "民丰县",
			"zipcode": "848500"
		}]
	}, {
		"id": 373,
		"name": "伊犁哈萨克自治州",
		"child": [{
			"id": 3352,
			"name": "伊宁市",
			"zipcode": "835000"
		}, {
			"id": 3353,
			"name": "奎屯市",
			"zipcode": "833200"
		}, {
			"id": 3354,
			"name": "伊宁县",
			"zipcode": "835100"
		}, {
			"id": 3355,
			"name": "察布查尔锡伯自治县",
			"zipcode": "835300"
		}, {
			"id": 3356,
			"name": "霍城县",
			"zipcode": "835200"
		}, {
			"id": 3357,
			"name": "巩留县",
			"zipcode": "835400"
		}, {
			"id": 3358,
			"name": "新源县",
			"zipcode": "835800"
		}, {
			"id": 3359,
			"name": "昭苏县",
			"zipcode": "835600"
		}, {
			"id": 3360,
			"name": "特克斯县",
			"zipcode": "835500"
		}, {
			"id": 3361,
			"name": "尼勒克县",
			"zipcode": "835700"
		}]
	}, {
		"id": 374,
		"name": "塔城地区",
		"child": [{
			"id": 3362,
			"name": "塔城市",
			"zipcode": "834700"
		}, {
			"id": 3363,
			"name": "乌苏市",
			"zipcode": "833300"
		}, {
			"id": 3364,
			"name": "额敏县",
			"zipcode": "834600"
		}, {
			"id": 3365,
			"name": "沙湾县",
			"zipcode": "832100"
		}, {
			"id": 3366,
			"name": "托里县",
			"zipcode": "834500"
		}, {
			"id": 3367,
			"name": "裕民县",
			"zipcode": "834800"
		}, {
			"id": 3368,
			"name": "和布克赛尔蒙古自治县",
			"zipcode": "834400"
		}]
	}, {
		"id": 375,
		"name": "阿勒泰地区",
		"child": [{
			"id": 3369,
			"name": "阿勒泰市",
			"zipcode": "836500"
		}, {
			"id": 3370,
			"name": "布尔津县",
			"zipcode": "836600"
		}, {
			"id": 3371,
			"name": "富蕴县",
			"zipcode": "836100"
		}, {
			"id": 3372,
			"name": "福海县",
			"zipcode": "836400"
		}, {
			"id": 3373,
			"name": "哈巴河县",
			"zipcode": "836700"
		}, {
			"id": 3374,
			"name": "青河县",
			"zipcode": "836200"
		}, {
			"id": 3375,
			"name": "吉木乃县",
			"zipcode": "836800"
		}]
	}, {
		"id": 376,
		"name": "省直辖县级行政单位",
		"child": [{
			"id": 3376,
			"name": "石河子市",
			"zipcode": "832000"
		}, {
			"id": 3377,
			"name": "阿拉尔市",
			"zipcode": "843300"
		}, {
			"id": 3378,
			"name": "图木舒克市",
			"zipcode": "843806"
		}, {
			"id": 3379,
			"name": "五家渠市",
			"zipcode": "831300"
		}]
	}]
}]
let foramtProvince = [{
    "name": "北京市",
    "id": "110000000000"
}, {
    "name": "天津市",
    "id": "120000000000"
}, {
    "name": "河北省",
    "id": "130000000000"
}, {
    "name": "山西省",
    "id": "140000000000"
}, {
    "name": "内蒙古自治区", 
    "id": "150000000000"
}, {
    "name": "辽宁省",
    "id": "210000000000"
}, {
    "name": "吉林省",
    "id": "220000000000"
}, {
    "name": "黑龙江省",
    "id": "230000000000"
}, {
    "name": "上海市",
    "id": "310000000000"
}, {
    "name": "江苏省",
    "id": "320000000000"
}, {
    "name": "浙江省",
    "id": "330000000000"
}, {
    "name": "安徽省",
    "id": "340000000000"
}, {
    "name": "福建省",
    "id": "350000000000"
}, {
    "name": "江西省",
    "id": "360000000000"
}, {
    "name": "山东省",
    "id": "370000000000"
}, {
    "name": "河南省",
    "id": "410000000000"
}, {
    "name": "湖北省",
    "id": "420000000000"
}, {
    "name": "湖南省",
    "id": "430000000000"
}, {
    "name": "广东省",
    "id": "440000000000"
}, {
    "name": "广西壮族自治区",
    "id": "450000000000"
}, {
    "name": "海南省",
    "id": "460000000000"
}, {
    "name": "重庆市",
    "id": "500000000000"
}, {
    "name": "四川省",
    "id": "510000000000"
}, {
    "name": "贵州省",
    "id": "520000000000"
}, {
    "name": "云南省",
    "id": "530000000000"
}, {
    "name": "西藏自治区",  
    "id": "540000000000"
}, {
    "name": "陕西省",
    "id": "610000000000"
}, {
    "name": "甘肃省",
    "id": "620000000000"
}, {
    "name": "青海省",
    "id": "630000000000"
}, {
    "name": "宁夏回族自治区",
    "id": "640000000000"
}, {
    "name": "新疆维吾尔自治区",
    "id": "650000000000"
}]
export default areaList;